import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import {
  LoadToBeRectifiedDataAndReleaseLock,
  InputAppClientDBActionTypes,
  NotifyBctxChangeAndReleaseLockAndThenDismissModal,
  InitializeReduxStore,
  InitializeReduxStoreFailed,
  InitializeReduxStoreSuccess,
  RestoreAppStateAndThenReleaseLock,
  RestoreAppStateSuccessAndThenReleaseLock,
  SaveEvents,
  ToBeRectifiedSaveEvents,
  RestoreToBeRectifiedCountsAndThenReleaseLock,
  RestoreToBeRectifiedCountsSuccessAndThenReleaseLock,
  InitializeUserAndBgDBsAndThenReleaseLock,
  CheckStationOrShiftChange,
  SyncStyleInfoAndThenReleaseUserDBLock,
  ClearToBeRectifiedListingAndReleaseLockAndThenDismissModal,
  SyncStyleInfoSuccessAndThenReleaseLock,
  UpdateUserDBAndThenReleaseLockAndThenRestoreActualsForNewStyles,
  InputAppNoAction,
  SyncEventsAndThenReleaseBgDBLock,
  reSyncPastDaysFailedEventsAndThenReleaseBgDBLock,
  reSyncTodayFailedEventsAndThenReleaseUserAndBgDBLock,
  updateNextEventIDandThenReleaseBgDBLock,
  updateNextEventIDandThenReleaseUserAndBgDBLock,
  updateActualsAndbgDBEventsListandNextEventId,
  UpdateUserDBAndBgDBEventListWithNextEventIdAndThenReleaseLocks,
  AddBulkEventsAndThenReleaseUserDBLockAndThenSyncEvents,
  UpdateUserDBAndThenReleaseUserDBLockAndThenSyncEvents,
  UpdateToBeRectifiedDataAndReleaseLockAndThenDismissLoader,
  ValidateUndoBulkEventAndReleaseLockAndThenAddEvents,
  UndoBulkEvent,
  AcquireUserDBLockAndAddBulkEvents,
  SyncEventsForOnlineAppsAndReleaseLock,
  AddBulkEventForOnlineApps,
  AcquireBgDBLockAndThenSyncEvents,
  AcquireLockAndNotifyBctxChangeAndDismissModalAndReleaseLock,
  AcquireLockAndClearSelectedBctxAndReleaseLock,
  SetUserDBAndReleaseLock,
  AcquireUserDBLockAndSyncStyleInfo,
  AcquireLockAndThenRestoreActuals,
  SetClientDBAndReleaseLockAndThenRestoreToBeRectifiedCounts,
  SetUserDBAndReleaseLockAndThenLoadMasterdataLists,
  AcquireLockAndRestoreToBeRectifiedCounts,
  ReleaseUserDBLockAndShowPopupAndDismissLoader,
  UpdateSelectedBctxItemAndReleaseLockAndThenAddEvent,
  ReleaseUserDBLock,
  AcquireLockAndThenInitializeUserAndBgDBs,
  BackUpBctxData,
  AcquireUserDBLockAndThenRestoreActualsForBackedUpBctx,
  RestoreAppStateForBackedUpBctxAndThenReleaseUserDBLock,
  RestoreAppStateSuccessForBackedUpBctxAndThenReleaseUserDBLock,
  UpdateUserDBAndThenReleaseLockAndThenRestoreActualsForBackedUpBctx,
  UpdateToBeRectifiedListingAndClientDBAndReleaseLockForSyncEventsForOnlineApps,
  AddBctxChangeEventForOnlineApps,
  SyncBctxChangeEventForOnlineAppsAndThenReleaseLock,
  UpdatedSelectedBctxAndReleaseLockAndThenDismissModal,
  SyncDefectiveResolutionEventsForOnlineAppsAndReleaseLock,
  UpdateUserDBAndReleaseLockForSyncEventsForOnlineApps,
  AddDefectiveResolutionBulkEventForOnlineApps,
  UpdateBgDBAndReleaseLockForSyncEvents,
  AcquireUserDBLockAndBgDBLockAndReconcile,
  ReconcileUserDBAndBgDBAndThenReleaseLocks,
  SetUserDBAndBgDBAndReleaseLocksWithChains,
  ReleaseBgDBLock,
  AcquireUserDBLockAndLoadToBeRectifiedData,
  AcquireUserDBLockAndClearToBeRectifiedList,
  AcquireUserDBLockAndValidateUndoBulkEventAndAddEvents,
  ClearAndReFetchPerPieceLineInTransactions,
  UpdatePerPieceLineInTransactions,
  ClearPerPieceLineInTransactions,
  SetUserDBAndClientDBAndReleaseLockAndEmitInitInfo,
  ShowFailedEventsAction,
  AcquireUserDBLockAndFetchIncompleteBundles,
  UpdateUserDBAndReleaseLockAndSyncStyleInfo,
  AcquireUserDBLockAndUpdateIncompleteBundlesInfo,
  UpdateIncompleteBundlesInfoAndReleaseLock,
  FetchIncompleteBundlesAndReleaseLock,
  AcquireUserBgDBLockAndCheckEventsValidAndThenAddBulkEvents,
  CheckEventsValidAndThenAddBulkEvents,
  AddDataToDbThenReleaseBgAndUserDbLockAndHandleSideEffects,
  ReleaseBgAndUserDbLockAndShowFailedEventsAction,
  FetchNewBctxSizeList,
  AcquireLockAndFetchNewBctxSizeList,
  InsertNewBctxSizeListIntoDB,
  InsertNewBctxSizeListIntoDBSuccessAndReleaseLock,
  AcquireLockAndUpdateBctxWithoutChangeEvent,
  UpdateBctxWithoutChangeEvent,
  UpdateBctxWithoutChangeEventSuccessAndReleaseLock,
  AcquireUserDBLockAndSyncStyleInfoForPlanBased,
  SyncStyleInfoAndThenReleaseUserDBLockPlanBased,
  SyncStyleInfoSuccessAndThenReleaseLockPlanBased,
  PopulateLineMapForPlanBasedAndThenReleaseUserDbLock,
  AcquireUserDBLockAndPopulateLineMapForPlanBased,
  SetUserDBAndReleaseLockAndThenFetchNewSizeList,
  SetUserDbAndAcquireUserDBLockAndThenRestoreActualsForBackedUpBctx,
  AcquireLockAndUpdateFilteredSizesListInLineMap,
  AcquireUserDBLockAndHandleSideActions,
  AcquireUserDBLockAndHandleSideActionsAndMoreActions,
  UpdateUserDBAndThenReleaseUserDBLockAndThenHandleSideActions,
  updatebgDBEventsListandNextEventIdAndReleaseUserAndBgDBLock,
  SetUserDBAndReleaseLockAndThenEmitBctxChangeEvent,
  CaptureSnapShotOfDbs,
} from './input-app-client-db.action';
import { catchError, map, switchMap, take } from 'rxjs/operators';
import { forkJoin, from, of, throwError } from 'rxjs';
import {
  AppMasterDBActionTypes,
  AppMasterDBFacade,
  ChangeStation,
  InitStoreFacade,
  InputAppMetadataDBFacade,
  MasterdataListDBFacade,
  PersistentStorageService,
} from '@monorepo/core-data';
import { CustomLoggerService, InputAppDataService } from '@monorepo/services';
import {
  TCountEvent,
  TBctxWithMultipleSize,
  TForwardSingleEvent,
  TUndoBulkEventMetadata,
  TSingleRejectedEvent,
  TSingleRejectedEventFromDefectives,
  TSingleReworkedEventFromDefectives,
  TSingleDefectiveEvent,
  TDefectiveReleatedEvent,
  TBCTXKeysWithoutSize,
  TShiftWiseBctx,
  TAgentToShiftWiseBctx,
  TForwardEventActionType,
  TForwardBulkEvent,
  TRoamingQcEventWithoutStatus,
  BCTX_SYNCING_KEY,
  TBctxItemWithoutSize,
  TEventBctxDetails,
  TUserActualsDB,
  TBctxMinMaxDateTime,
  TBulkEvent,
  TActivityLogEvent,
  TBulkEventWithoutStatus,
} from '@monorepo/types';
import { getInputAppInitialState, DEFAULT_BCTX_KEY, DEFAULT_SELECTED_BCTX_INFO } from './input-app-client-db.reducer';
import { InputAppClientDBFacade } from './input-app-client-db.facade';
import {
  BCTXComputationHelper,
  EventUtil,
  InputAppAPIHelperUtil,
  InputAppErrorDisplay,
  PerPieceComputationHelper,
} from '@monorepo/utils';
import { ModalController, ToastController } from '@ionic/angular';
import produce from 'immer';
import moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { cloneDeep } from 'lodash';

@Injectable({
  providedIn: 'root',
})
export class InputAppClientDBEffects {
  constructor(
    private action$: Actions,
    private modalCtrl: ModalController,
    private inputAppClientDBFacade: InputAppClientDBFacade,
    private inputAppDataService: InputAppDataService,
    private inputAppAPIHelperUtil: InputAppAPIHelperUtil,
    private persistentStorageService: PersistentStorageService,
    private appMasterDBFacade: AppMasterDBFacade,
    private toastCtrl: ToastController,
    private initStoreFacade: InitStoreFacade,
    private metadataFacade: InputAppMetadataDBFacade,
    private translate: TranslateService,
    private inputAppErrorUtil: InputAppErrorDisplay,
    private masterDataListDbFacade: MasterdataListDBFacade,
    private customLoggerService: CustomLoggerService,
  ) {}

  AcquireUserDBLockAndUpdateIncompleteBundlesInfo$ = createEffect(() =>
    this.action$.pipe(
      ofType<AcquireUserDBLockAndUpdateIncompleteBundlesInfo>(
        InputAppClientDBActionTypes.AcquireUserDBLockAndUpdateIncompleteBundlesInfo,
      ),
      switchMap((action) => {
        return this.inputAppClientDBFacade.getSelectedStationIdAndShiftId().pipe(
          take(1),
          map(({ stationId, shiftId }) => [stationId, shiftId, action] as const),
        );
      }),
      switchMap(([stationId, shiftId, action]) => {
        return this.inputAppClientDBFacade.acquireUserDBLock('UPDATING_INCOMPLETE_BUNDLES').pipe(
          switchMap((res) => {
            if (res.status === 'SUCCESS') {
              return from(this.persistentStorageService.get('[APP][INPUT_APP_CLIENT_DB]')).pipe(
                take(1),
                switchMap((currentDB) => {
                  const updatedDB = produce(currentDB, (draft) => {
                    if (!draft.persistanceCache.incompleteBundlesInfo[stationId]) {
                      draft.persistanceCache.incompleteBundlesInfo[stationId] = {
                        [shiftId]: action.incompleteBundlesInfo,
                      };
                    } else {
                      draft.persistanceCache.incompleteBundlesInfo[stationId][shiftId] = action.incompleteBundlesInfo;
                    }
                  });
                  return from(this.persistentStorageService.set('[APP][INPUT_APP_CLIENT_DB]', updatedDB)).pipe(
                    take(1),
                    map(() => {
                      return new UpdateIncompleteBundlesInfoAndReleaseLock(updatedDB);
                    }),
                  );
                }),
              );
            } else {
              this.inputAppAPIHelperUtil.showPopup('Error', res.message);
              return of(new InputAppNoAction());
            }
          }),
        );
      }),
    ),
  );

  UpdateIncompleteBundlesInfoAndReleaseLock$ = createEffect(() =>
    this.action$.pipe(
      ofType<UpdateIncompleteBundlesInfoAndReleaseLock>(
        InputAppClientDBActionTypes.UpdateIncompleteBundlesInfoAndReleaseLock,
      ),
      map((action) => {
        this.inputAppClientDBFacade.emitSyncIncompleteBundlesSubscription();
        return new InputAppNoAction();
      }),
    ),
  );

  FetchPerPieceLineInTransactions$ = createEffect(() =>
    this.action$.pipe(
      ofType<ClearAndReFetchPerPieceLineInTransactions>(
        InputAppClientDBActionTypes.ClearAndReFetchPerPieceLineInTransactions,
      ),
      switchMap((action) => {
        return from(
          this.inputAppErrorUtil.presentLoadingWithId(
            'FETCH_PER_PIECE_LINE_IN_TRANSACTIONS',
            this.translate.instant('input_app_db_effects.loadingTransactions'),
          ),
        ).pipe(
          take(1),
          map(() => action),
        );
      }),
      switchMap((action) => {
        return this.inputAppClientDBFacade.getPerPieceLineInTransactionsPayload(action.startTime, action.endTime).pipe(
          take(1),
          switchMap((res) => {
            return this.appMasterDBFacade.isStationTypeWipEnd().pipe(
              take(1),
              map((isStationTypeWipEnd) => [res, isStationTypeWipEnd] as const),
            );
          }),
          switchMap(([res, isStationTypeWipEnd]) => {
            return this.inputAppDataService.getPerPieceLineInTransaction(res, isStationTypeWipEnd).pipe(
              take(1),
              switchMap((transactionRecords) => {
                return from(this.inputAppErrorUtil.dismissLoadingWithId('FETCH_PER_PIECE_LINE_IN_TRANSACTIONS')).pipe(
                  take(1),
                  map(() => {
                    return new UpdatePerPieceLineInTransactions(transactionRecords);
                  }),
                );
              }),
              catchError((error) => {
                return from(this.inputAppErrorUtil.dismissLoadingWithId('FETCH_PER_PIECE_LINE_IN_TRANSACTIONS')).pipe(
                  take(1),
                  map(() => {
                    this.customLoggerService.log(
                      'INPUT APP CLIENT DB EFFECT FetchPerPieceLineInTransactions - getPerPieceLineInTransaction API call failed',
                      JSON.stringify(error),
                    );
                    this.inputAppAPIHelperUtil.showPopup(
                      this.translate.instant('input_app_common.error'),
                      this.translate.instant('input_app_db_effects.fetchingTransactionsError'),
                    );
                    return new InputAppNoAction();
                  }),
                );
              }),
            );
          }),
        );
      }),
    ),
  );

  ClearPerPieceLineInTransactions$ = createEffect(() =>
    this.action$.pipe(
      ofType<ClearPerPieceLineInTransactions>(InputAppClientDBActionTypes.ClearPerPieceLineInTransactions),
      map((action) => {
        this.modalCtrl.dismiss();
        return new InputAppNoAction();
      }),
    ),
  );

  BackUpBctxData$ = createEffect(() =>
    this.action$.pipe(
      ofType<BackUpBctxData>(InputAppClientDBActionTypes.BackUpBctxData),
      switchMap((action) =>
        this.inputAppClientDBFacade.getBctxItemsOrderForBackUp().pipe(
          take(1),
          map((res) => {
            return [res] as const;
          }),
        ),
      ),
      switchMap(([orderKeys]) =>
        this.inputAppClientDBFacade.getAppIdentifier().pipe(
          take(1),
          map((app_identifier) => {
            return [orderKeys, app_identifier] as const;
          }),
        ),
      ),
      switchMap(([orderKeys, app_identifier]) => {
        return this.inputAppClientDBFacade.getConfigurations().pipe(
          take(1),
          map(({ aggregatedLineMapForPerPiece }) => [orderKeys, app_identifier, aggregatedLineMapForPerPiece] as const),
        );
      }),
      switchMap(([orderKeys, app_identifier, aggregatedLineMapForPerPiece]) => {
        return this.inputAppClientDBFacade.getBackUpPayloadWithoutBctxInfoAndDate().pipe(
          take(1),
          switchMap((payloadWithoutBctxIfo) => {
            return this.inputAppClientDBFacade.getClientDB().pipe(
              take(1),
              switchMap((clientDB) => {
                const agentToShiftWiseBctx: TAgentToShiftWiseBctx[] = payloadWithoutBctxIfo.agents.map((agent) => {
                  const shiftWiseBctxs: TShiftWiseBctx[] = [];
                  if (aggregatedLineMapForPerPiece && BCTXComputationHelper.isPerPieceApp(app_identifier)) {
                    if (
                      clientDB.dailyCache.ppLineMap[agent.subject] &&
                      Object.keys(clientDB.dailyCache.ppLineMap[agent.subject].lineInfo).length > 0
                    ) {
                      Object.entries(clientDB.dailyCache.ppLineMap[agent.subject].lineInfo).map(
                        ([shiftId, lineData]) => {
                          shiftWiseBctxs.push({
                            shiftId,
                            bctx: lineData.bctx
                              .map((bctxDataWithSize) => {
                                return {
                                  preSizeLevelBctx: BCTXComputationHelper.getOrderedBctx(
                                    bctxDataWithSize.bctx,
                                    orderKeys,
                                  ),
                                  sizes: bctxDataWithSize.size,
                                };
                              })
                              .filter(({ preSizeLevelBctx }) =>
                                BCTXComputationHelper.isPerPieceApp(app_identifier)
                                  ? true
                                  : preSizeLevelBctx.length === orderKeys.length,
                              ),
                          });
                        },
                      );
                    }
                  } else {
                    if (
                      clientDB.dailyCache.lineMap[agent.subject] &&
                      Object.keys(clientDB.dailyCache.lineMap[agent.subject].shiftMap).length > 0
                    ) {
                      Object.entries(clientDB.dailyCache.lineMap[agent.subject].shiftMap).map(([shiftId, shiftMap]) => {
                        shiftWiseBctxs.push({
                          shiftId,
                          bctx: Object.keys(shiftMap.clientBctx)
                            .map((bctxKey) => {
                              return {
                                preSizeLevelBctx: BCTXComputationHelper.getOrderedBctx(
                                  clientDB.dailyCache.lineMap[agent.subject].bctxWipMap[bctxKey]
                                    .bctxItemListWithoutSize,
                                  orderKeys,
                                ),
                                sizes: Object.keys(
                                  clientDB.dailyCache.lineMap[agent.subject].bctxWipMap[bctxKey].sizeToWipMap,
                                ),
                              };
                            })
                            .filter(({ preSizeLevelBctx }) =>
                              BCTXComputationHelper.isPerPieceApp(app_identifier)
                                ? true
                                : preSizeLevelBctx.length === orderKeys.length,
                            ),
                        });
                      });
                    }
                  }
                  return {
                    agent,
                    shiftWiseBctxs,
                  };
                });
                return this.inputAppDataService
                  .backUpData({
                    ...payloadWithoutBctxIfo.payloadWithoutAgentAndShiftWiseBctx,
                    date: BCTXComputationHelper.dashFormateDate(),
                    agentToShiftWiseBctx: agentToShiftWiseBctx,
                  })
                  .pipe(
                    take(1),
                    map((res) => new InputAppNoAction()),
                    catchError((error) => {
                      // If status is 200, it was a successful request but failed JSON parsing
                      // Angular's HttpClient is trying to parse an empty or non-JSON response body as JSON (which is the default behavior). When the JSON parsing fails, it throws an error that falls into catchError
                      if (error?.status === 200) {
                        return of(new InputAppNoAction());
                      }
                      // Handle actual error
                      this.customLoggerService.log(
                        'INPUT APP CLIENT DB EFFECT BackUpBctxData - backUpData API call failed',
                        JSON.stringify(error),
                      );
                      return of(new InputAppNoAction());
                    }),
                  );
              }),
            );
          }),
        );
      }),
    ),
  );

  AcquireUserDBLockAndAddBulkEvents$ = createEffect(() =>
    this.action$.pipe(
      ofType<AcquireUserDBLockAndAddBulkEvents>(InputAppClientDBActionTypes.AcquireUserDBLockAndAddBulkEvents),
      switchMap((action) => {
        return this.inputAppClientDBFacade.acquireUserDBLock('EVENT_ADDITION').pipe(
          map((res) => {
            if (res.status === 'SUCCESS') {
              //Just ensuring that events array has atleast one event, ideally this check is not needed but to be on safe side adding this.
              if (EventUtil.isBulkEventsValidForAddition(action.events)) {
                return new AddBulkEventsAndThenReleaseUserDBLockAndThenSyncEvents(
                  action.events,
                  action.showLoader,
                  action.eventAddtionMoreActions,
                  action.eventAdditionSideActions,
                );
              } else {
                this.customLoggerService.log(
                  'INPUT APP CLIENT DB EFFECT AcquireUserDBLockAndAddBulkEvents - Invalid events for addition',
                  JSON.stringify(action.events),
                );
                this.inputAppAPIHelperUtil.showPopup(
                  this.translate.instant('input_app_common.error'),
                  this.translate.instant('input_app_db_effects.currentActionError'),
                );
                return new ReleaseUserDBLock();
              }
            } else {
              this.inputAppAPIHelperUtil.showPopup(this.translate.instant('input_app_common.error'), res.message);
              return new InputAppNoAction();
            }
          }),
        );
      }),
    ),
  );

  AcquireUserDBLockAndHandleSideActions$ = createEffect(() =>
    this.action$.pipe(
      ofType<AcquireUserDBLockAndHandleSideActions>(InputAppClientDBActionTypes.AcquireUserDBLockAndHandleSideActions),
      switchMap((action) => {
        return this.inputAppClientDBFacade.acquireUserDBLock('EVENT_ADDITION').pipe(
          map((res) => {
            if (res.status === 'SUCCESS') {
              return new AcquireUserDBLockAndHandleSideActionsAndMoreActions(
                action.eventAddtionMoreActions,
                action.eventAdditionSideActions,
              );
            } else {
              this.inputAppAPIHelperUtil.showPopup(this.translate.instant('input_app_common.error'), res.message);
              return new InputAppNoAction();
            }
          }),
        );
      }),
    ),
  );

  AcquireUserDBLockAndHandleSideActionsAndMoreActions$ = createEffect(() =>
    this.action$.pipe(
      ofType<AcquireUserDBLockAndHandleSideActionsAndMoreActions>(
        InputAppClientDBActionTypes.AcquireUserDBLockAndHandleSideActionsAndMoreActions,
      ),
      switchMap((action) => {
        return this.inputAppClientDBFacade.getSelectedStationIdAndShiftId().pipe(
          take(1),
          map(({ stationId, shiftId }) => [stationId, action] as const),
        );
      }),
      switchMap(([stationId, action]) => {
        return this.inputAppClientDBFacade.getConfigurations().pipe(
          take(1),
          map(({ aggregatedLineMapForPerPiece }) => [stationId, action, aggregatedLineMapForPerPiece] as const),
        );
      }),
      switchMap(([stationId, action, aggregatedLineMapForPerPiece]) =>
        this.inputAppClientDBFacade.getAppIdentifier().pipe(
          take(1),
          map((app_identifier) => {
            return [stationId, action, aggregatedLineMapForPerPiece, app_identifier] as const;
          }),
        ),
      ),
      switchMap(([stationId, action, aggregatedLineMapForPerPiece, app_identifier]) =>
        from(this.persistentStorageService.get('[APP][INPUT_APP_CLIENT_DB]')).pipe(
          take(1),
          map((currentDB) => {
            if (action.eventAddtionMoreActions.updateSelectedBctx) {
              const selectedBctxInfo = action.eventAddtionMoreActions.updateSelectedBctx;
              currentDB = produce(currentDB, (draft) => {
                if (aggregatedLineMapForPerPiece && BCTXComputationHelper.isPerPieceApp(app_identifier)) {
                  if (!draft.dailyCache.ppLineMap[stationId]) {
                    draft.dailyCache.ppLineMap[stationId] = {
                      lineInfo: {},
                      ps: [],
                      selectedBctxInfo: selectedBctxInfo,
                    };
                  } else {
                    draft.dailyCache.ppLineMap[stationId].selectedBctxInfo = selectedBctxInfo;
                  }
                } else {
                  draft.dailyCache.lineMap[stationId].selectedBctxInfo = selectedBctxInfo;
                }
              });
            } else if (action.eventAddtionMoreActions.clearSelectedBctx) {
              currentDB = produce(currentDB, (draft) => {
                if (aggregatedLineMapForPerPiece && BCTXComputationHelper.isPerPieceApp(app_identifier)) {
                  if (draft.dailyCache.ppLineMap[stationId]) {
                    draft.dailyCache.ppLineMap[stationId].selectedBctxInfo = DEFAULT_SELECTED_BCTX_INFO;
                  }
                } else {
                  if (draft.dailyCache.lineMap[stationId]) {
                    draft.dailyCache.lineMap[stationId].selectedBctxInfo = DEFAULT_SELECTED_BCTX_INFO;
                  }
                }
              });
            }
            return [currentDB, action] as const;
          }),
        ),
      ),
      switchMap(([updatedDB, action]) =>
        from(this.persistentStorageService.set('[APP][INPUT_APP_CLIENT_DB]', updatedDB)).pipe(
          take(1),
          switchMap(() => {
            return of(
              new UpdateUserDBAndThenReleaseUserDBLockAndThenHandleSideActions(
                updatedDB,
                action.eventAdditionSideActions,
              ),
            );
          }),
        ),
      ),
    ),
  );

  UpdateUserDBAndThenReleaseUserDBLockAndThenHandleSideActions$ = createEffect(() =>
    this.action$.pipe(
      ofType<UpdateUserDBAndThenReleaseUserDBLockAndThenHandleSideActions>(
        InputAppClientDBActionTypes.UpdateUserDBAndThenReleaseUserDBLockAndThenHandleSideActions,
      ),
      switchMap((action) => {
        this.inputAppClientDBFacade.emitRFIDDataProcessingSubscription(false);
        if (action.eventAdditionSideActions) {
          if (action.eventAdditionSideActions.perPieceDefectOrRejectAddition) {
            this.inputAppClientDBFacade.emitPerPieceQcDefectOrRejectAddition(
              action.eventAdditionSideActions.perPieceDefectOrRejectAddition,
            );
            return of(new InputAppNoAction());
          } else if (action.eventAdditionSideActions.showPerPieceDefective) {
            this.inputAppClientDBFacade.emitShowPerPieceDefectiveSubscription(
              action.eventAdditionSideActions.showPerPieceDefective,
            );
            return of(new InputAppNoAction());
          } else {
            return of(new InputAppNoAction());
          }
        } else {
          return of(new InputAppNoAction());
        }
      }),
    ),
  );

  AcquireUserBgDBLockAndCheckEventsValidAndThenAddBulkEvents$ = createEffect(() =>
    this.action$.pipe(
      ofType<AcquireUserBgDBLockAndCheckEventsValidAndThenAddBulkEvents>(
        InputAppClientDBActionTypes.AcquireUserBgDBLockAndCheckEventsValidAndThenAddBulkEvents,
      ),
      switchMap((action) => {
        return this.inputAppClientDBFacade.acquireBgDBLock('SYNC_EVENTS').pipe(
          take(1),
          switchMap((res) => {
            if (res.status === 'SUCCESS') {
              return this.inputAppClientDBFacade.acquireUserDBLock('SYNCING_EVENTS').pipe(
                take(1),
                map((userDBLockResult) => {
                  if (userDBLockResult.status === 'SUCCESS') {
                    return new CheckEventsValidAndThenAddBulkEvents(
                      action.events,
                      action.eventAddtionMoreActions,
                      action.eventAdditionSideActions,
                      action.rfidScannerBulkMode,
                    );
                  } else {
                    this.inputAppClientDBFacade.emitRFIDDataProcessingSubscription(false);
                    this.inputAppAPIHelperUtil.showPopup(
                      this.translate.instant('input_app_common.error'),
                      userDBLockResult.message,
                    );
                    return new ReleaseBgDBLock();
                  }
                }),
              );
            } else {
              this.inputAppClientDBFacade.emitRFIDDataProcessingSubscription(false);
              this.inputAppAPIHelperUtil.showPopup(this.translate.instant('input_app_common.error'), res.message);
              return of(new InputAppNoAction());
            }
          }),
        );
      }),
    ),
  );

  AddBulkEventsAndThenReleaseUserDBLockAndThenSyncEvents$ = createEffect(() =>
    this.action$.pipe(
      ofType<AddBulkEventsAndThenReleaseUserDBLockAndThenSyncEvents>(
        InputAppClientDBActionTypes.AddBulkEventsAndThenReleaseUserDBLockAndThenSyncEvents,
      ),
      switchMap((action) => {
        if (action.showLoader) {
          return from(this.inputAppErrorUtil.presentLoadingWithId('ADDING_EVENT', 'Saving events...')).pipe(
            take(1),
            map(() => [action] as const),
          );
        } else return of([action] as const);
      }),
      switchMap(([action]) => {
        return this.inputAppClientDBFacade.getSelectedStationIdAndShiftId().pipe(
          take(1),
          map(({ stationId, shiftId }) => [stationId, shiftId, action] as const),
        );
      }),
      switchMap(([stationId, shiftId, action]) => {
        return this.inputAppClientDBFacade.getBctxItemsOrderForBackUp().pipe(
          take(1),
          map((orderKeys) => [stationId, shiftId, orderKeys, action] as const),
        );
      }),
      switchMap(([stationId, shiftId, orderKeys, action]) => {
        return this.inputAppClientDBFacade.getConfigurations().pipe(
          take(1),
          map(
            ({ aggregatedLineMapForPerPiece }) =>
              [stationId, shiftId, orderKeys, action, aggregatedLineMapForPerPiece] as const,
          ),
        );
      }),
      switchMap(([stationId, shiftId, orderKeys, action, aggregatedLineMapForPerPiece]) =>
        this.inputAppClientDBFacade.getAppIdentifier().pipe(
          take(1),
          map((app_identifier) => {
            return [stationId, shiftId, orderKeys, action, aggregatedLineMapForPerPiece, app_identifier] as const;
          }),
        ),
      ),
      switchMap(([stationId, shiftId, orderKeys, action, aggregatedLineMapForPerPiece, app_identifier]) =>
        from(this.persistentStorageService.get('[APP][INPUT_APP_CLIENT_DB]')).pipe(
          take(1),
          map((currentDB) => {
            let dailyEventsUpdated = [...currentDB.dailyCache.events.list, ...action.events];
            let updatedDB: TUserActualsDB = {
              ...currentDB,
              dailyCache: {
                ...currentDB.dailyCache,
                events: {
                  ...currentDB.dailyCache.events,
                  list: dailyEventsUpdated,
                },
              },
            };
            if (aggregatedLineMapForPerPiece && BCTXComputationHelper.isPerPieceApp(app_identifier)) {
              updatedDB = PerPieceComputationHelper.updateActualsForBulkEventsForAllSingleEventsPerPiece(
                updatedDB,
                action.events,
                orderKeys,
              );
            } else {
              //don't change order, as updateWipAndActualsForBulkEventsForAllSingleEvents backfills linemap info
              updatedDB = BCTXComputationHelper.updateWipAndActualsForBulkEventsForAllSingleEvents(
                updatedDB,
                action.events,
                action.eventAddtionMoreActions.updateActualsOnly,
                orderKeys,
              );
            }
            if (action.eventAddtionMoreActions.clearSelectedBctxAndUpdateIncompleteBundles) {
              const incompleteBundlesInfo =
                action.eventAddtionMoreActions.clearSelectedBctxAndUpdateIncompleteBundles.incompleteBundlesInfo;
              updatedDB = produce(updatedDB, (draft) => {
                draft.dailyCache.lineMap[stationId].selectedBctxInfo = DEFAULT_SELECTED_BCTX_INFO;
                if (!draft.persistanceCache.incompleteBundlesInfo[stationId]) {
                  draft.persistanceCache.incompleteBundlesInfo[stationId] = {
                    [shiftId]: incompleteBundlesInfo,
                  };
                } else draft.persistanceCache.incompleteBundlesInfo[stationId][shiftId] = incompleteBundlesInfo;
              });
            } else if (action.eventAddtionMoreActions.updateIncompleteBundles) {
              const incompleteBundlesInfo = action.eventAddtionMoreActions.updateIncompleteBundles;
              updatedDB = produce(updatedDB, (draft) => {
                if (!draft.persistanceCache.incompleteBundlesInfo[stationId]) {
                  draft.persistanceCache.incompleteBundlesInfo[stationId] = {
                    [shiftId]: incompleteBundlesInfo,
                  };
                } else draft.persistanceCache.incompleteBundlesInfo[stationId][shiftId] = incompleteBundlesInfo;
              });
            } else if (action.eventAddtionMoreActions.updateSelectedBctx) {
              const selectedBctxInfo = action.eventAddtionMoreActions.updateSelectedBctx;
              updatedDB = produce(updatedDB, (draft) => {
                if (aggregatedLineMapForPerPiece && BCTXComputationHelper.isPerPieceApp(app_identifier)) {
                  draft.dailyCache.ppLineMap[stationId].selectedBctxInfo = selectedBctxInfo;
                } else {
                  draft.dailyCache.lineMap[stationId].selectedBctxInfo = selectedBctxInfo;
                }
              });
            } else if (action.eventAddtionMoreActions.clearSelectedBctx) {
              updatedDB = produce(updatedDB, (draft) => {
                if (aggregatedLineMapForPerPiece && BCTXComputationHelper.isPerPieceApp(app_identifier)) {
                  draft.dailyCache.ppLineMap[stationId].selectedBctxInfo = DEFAULT_SELECTED_BCTX_INFO;
                } else {
                  draft.dailyCache.lineMap[stationId].selectedBctxInfo = DEFAULT_SELECTED_BCTX_INFO;
                }
              });
            }
            return [updatedDB, action] as const;
          }),
        ),
      ),
      switchMap(([updatedDB, action]) =>
        from(this.persistentStorageService.set('[APP][INPUT_APP_CLIENT_DB]', updatedDB)).pipe(
          take(1),
          switchMap(() => {
            if (action.showLoader) {
              return from(this.inputAppErrorUtil.dismissLoadingWithId('ADDING_EVENT')).pipe(
                take(1),
                map(() => [updatedDB, action] as const),
              );
            } else return of([updatedDB, action] as const);
          }),
          switchMap(([updatedDB, action]) => {
            return of(
              new UpdateUserDBAndThenReleaseUserDBLockAndThenSyncEvents(
                action.eventAddtionMoreActions.updateActualsOnly,
                updatedDB,
                action.events,
                action.eventAdditionSideActions,
              ),
            );
          }),
        ),
      ),
    ),
  );

  updateActualsAndbgDBEventsListandNextEventId$ = createEffect(() =>
    this.action$.pipe(
      ofType<updateActualsAndbgDBEventsListandNextEventId>(
        InputAppClientDBActionTypes.updateActualsAndbgDBEventsListandNextEventId,
      ),
      switchMap((action) => {
        return from(
          this.inputAppErrorUtil.presentLoadingWithId(
            'UPDATING_ACTUALS',
            this.translate.instant('input_app_db_effects.reSync.wip_actuals'),
          ),
        ).pipe(
          take(1),
          map(() => [action] as const),
        );
      }),
      switchMap(([action]) => {
        return this.inputAppClientDBFacade.getBctxItemsOrderForBackUp().pipe(
          take(1),
          map((orderKeys) => [orderKeys, action] as const),
        );
      }),
      switchMap(([orderKeys, action]) => {
        return this.inputAppClientDBFacade.getConfigurations().pipe(
          take(1),
          map(({ aggregatedLineMapForPerPiece }) => [orderKeys, action, aggregatedLineMapForPerPiece] as const),
        );
      }),
      switchMap(([orderKeys, action, aggregatedLineMapForPerPiece]) =>
        this.inputAppClientDBFacade.getAppIdentifier().pipe(
          take(1),
          map((app_identifier) => {
            return [orderKeys, action, aggregatedLineMapForPerPiece, app_identifier] as const;
          }),
        ),
      ),
      switchMap(([orderKeys, action, aggregatedLineMapForPerPiece, app_identifier]) =>
        from(this.persistentStorageService.get('[APP][INPUT_APP_CLIENT_DB]')).pipe(
          take(1),
          map((currentUserDB) => {
            if (aggregatedLineMapForPerPiece && BCTXComputationHelper.isPerPieceApp(app_identifier)) {
              currentUserDB = PerPieceComputationHelper.updateActualsForBulkEventsForAllSingleEventsPerPiece(
                currentUserDB,
                action.reSyncedSuccessEvents as TBulkEventWithoutStatus[],
                orderKeys,
              );
            } else {
              currentUserDB = BCTXComputationHelper.updateWipAndActualsForBulkEventsForAllSingleEvents(
                currentUserDB,
                action.reSyncedSuccessEvents as TBulkEventWithoutStatus[],
                true,
                orderKeys,
              );
            }
            return [currentUserDB, action] as const;
          }),
        ),
      ),
      switchMap(([updatedDB, action]) =>
        from(this.persistentStorageService.set('[APP][INPUT_APP_CLIENT_DB]', updatedDB)).pipe(
          take(1),
          switchMap(() => {
            return from(this.inputAppErrorUtil.dismissLoadingWithId('UPDATING_ACTUALS')).pipe(
              take(1),
              map(() => [updatedDB, action] as const),
            );
          }),
          switchMap(([updatedDB, action]) => {
            const finalMessage = `${action.failedCount} ${this.translate.instant(
              'input_app_db_effects.reSync.validation_error',
            )} 
            ${action.reSyncedSuccessEvents.length} ${this.translate.instant(
              'input_app_db_effects.reSync.synced_success',
            )}`;
            this.inputAppAPIHelperUtil.showPopup(action.reSyncStatus, finalMessage);
            return of(
              new UpdateUserDBAndBgDBEventListWithNextEventIdAndThenReleaseLocks(
                updatedDB,
                action.bgDBEventsList,
                action.nextEventID,
              ),
            );
          }),
        ),
      ),
    ),
  );

  UpdateUserDBAndThenReleaseUserDBLockAndThenSyncEvents$ = createEffect(() =>
    this.action$.pipe(
      ofType<UpdateUserDBAndThenReleaseUserDBLockAndThenSyncEvents>(
        InputAppClientDBActionTypes.UpdateUserDBAndThenReleaseUserDBLockAndThenSyncEvents,
      ),
      switchMap((action) => {
        if (action.eventAdditionSideActions) {
          if (action.eventAdditionSideActions.perPieceDefectOrRejectAddition) {
            this.inputAppClientDBFacade.emitPerPieceQcDefectOrRejectAddition(
              action.eventAdditionSideActions.perPieceDefectOrRejectAddition,
            );
            this.inputAppClientDBFacade.backgroundSyncEventsJustAfterEventAdditionOrBgSyncing(action.updateActualsOnly);
            return of(new InputAppNoAction());
          } else if (action.eventAdditionSideActions.showPerPieceDefective) {
            this.inputAppClientDBFacade.emitShowPerPieceDefectiveSubscription(
              action.eventAdditionSideActions.showPerPieceDefective,
            );
            this.inputAppClientDBFacade.backgroundSyncEventsJustAfterEventAdditionOrBgSyncing(action.updateActualsOnly);
            return of(new InputAppNoAction());
          } else if (action.eventAdditionSideActions.showToastForEventsAddition) {
            const count = action.addedEvents.reduce((acc, curr) => {
              curr.events.forEach((event) => {
                if (event.type === 'FORWARD_EVENT' || event.type === 'UNDO_EVENT') {
                  acc += event.eventInfo.bctxDetails.count;
                }
              });
              return acc;
            }, 0);
            const message = `${count} ${
              count > 1
                ? this.translate.instant('input_app_db_effects.pieces')
                : this.translate.instant('input_app_db_effects.piece') +
                  ' ' +
                  this.translate.instant('input_app_db_effects.added')
            }`;
            this.inputAppClientDBFacade.speakOut(message);
            const toast = this.toastCtrl.create({
              message: message,
              duration: 1000,
              position: 'top',
              cssClass: 'success-toast',
            });
            toast.then((x) => x.present());
            this.inputAppClientDBFacade.backgroundSyncEventsJustAfterEventAdditionOrBgSyncing(action.updateActualsOnly);
            return of(new InputAppNoAction());
          } else if (action.eventAdditionSideActions.closeModal) {
            return from(this.modalCtrl.dismiss()).pipe(
              take(1),
              map(() => {
                this.inputAppClientDBFacade.backgroundSyncEventsJustAfterEventAdditionOrBgSyncing(
                  action.updateActualsOnly,
                );
                return new InputAppNoAction();
              }),
            );
          } else if (action.eventAdditionSideActions.roamingQcAuditAddition) {
            this.inputAppClientDBFacade.emitShowRoamingQcSuccessAndSyncEventsForWebSubscription(
              action.addedEvents[0] as TRoamingQcEventWithoutStatus,
              action.eventAdditionSideActions.roamingQcAuditAddition.toBeClosedModals,
            );
            return of(new InputAppNoAction());
          } else if (action.eventAdditionSideActions.syncIncompleteBundles) {
            if (action.eventAdditionSideActions.syncIncompleteBundles.closeModal) {
              return from(this.modalCtrl.dismiss()).pipe(
                take(1),
                map(() => {
                  this.inputAppClientDBFacade.emitSyncIncompleteBundlesSubscription();
                  this.inputAppClientDBFacade.backgroundSyncEventsJustAfterEventAdditionOrBgSyncing(
                    action.updateActualsOnly,
                  );
                  return new InputAppNoAction();
                }),
              );
            } else {
              this.inputAppClientDBFacade.emitSyncIncompleteBundlesSubscription();
              this.inputAppClientDBFacade.backgroundSyncEventsJustAfterEventAdditionOrBgSyncing(
                action.updateActualsOnly,
              );
              return of(new InputAppNoAction());
            }
          } else {
            this.inputAppClientDBFacade.backgroundSyncEventsJustAfterEventAdditionOrBgSyncing(action.updateActualsOnly);
            return of(new InputAppNoAction());
          }
        } else {
          this.inputAppClientDBFacade.backgroundSyncEventsJustAfterEventAdditionOrBgSyncing(action.updateActualsOnly);
          return of(new InputAppNoAction());
        }
      }),
    ),
  );

  AcquireBgDBLockAndThenSyncEvents$ = createEffect(() => {
    return this.action$.pipe(
      ofType<AcquireBgDBLockAndThenSyncEvents>(InputAppClientDBActionTypes.AcquireBgDBLockAndThenSyncEvents),
      switchMap((action) => {
        return this.inputAppClientDBFacade.acquireBgDBLock('SYNC_EVENTS').pipe(
          take(1),
          switchMap((res) => {
            if (res.status === 'SUCCESS') {
              if (action.chainAction) {
                return this.inputAppClientDBFacade.acquireUserDBLock('SYNCING_EVENTS').pipe(
                  take(1),
                  map((userDBLockResult) => {
                    if (userDBLockResult.status === 'SUCCESS') {
                      return new SyncEventsAndThenReleaseBgDBLock(
                        action.updateActualsOnly,
                        action.showLockFailure,
                        action.batchCount,
                        action.chainAction,
                      );
                    } else {
                      this.inputAppAPIHelperUtil.showPopup(
                        this.translate.instant('input_app_common.error'),
                        userDBLockResult.message,
                      );
                      return new ReleaseBgDBLock();
                    }
                  }),
                );
              } else {
                return of(
                  new SyncEventsAndThenReleaseBgDBLock(
                    action.updateActualsOnly,
                    action.showLockFailure,
                    action.batchCount,
                    action.chainAction,
                  ),
                );
              }
            } else {
              if (action.showLockFailure) {
                this.inputAppAPIHelperUtil.showPopup(this.translate.instant('input_app_common.error'), res.message);
              }
              return of(new InputAppNoAction());
            }
          }),
        );
      }),
    );
  });

  reSyncTodayFailedEventsAndThenReleaseUserAndBgDBLock$ = createEffect(() =>
    this.action$.pipe(
      ofType<reSyncTodayFailedEventsAndThenReleaseUserAndBgDBLock>(
        InputAppClientDBActionTypes.reSyncTodayFailedEventsAndThenReleaseUserAndBgDBLock,
      ),
      switchMap((action) =>
        from(
          this.inputAppErrorUtil.presentLoadingWithId(
            'RESYNC_FAILED_EVENTS',
            this.translate.instant('input_app_db_effects.reSync.in_progress'),
          ),
        ).pipe(
          take(1),
          map(() => action),
        ),
      ),
      switchMap((action) =>
        forkJoin({
          bgDB: from(this.persistentStorageService.get('[APP][INPUT_APP_BACKGROUND_EVENTS_SYNCING_DB]')).pipe(take(1)),
          userDB: from(this.persistentStorageService.get('[APP][INPUT_APP_CLIENT_DB]')).pipe(take(1)),
        }).pipe(map(({ bgDB, userDB }) => ({ action, bgDB, userDB }))),
      ),
      switchMap(({ action, bgDB, userDB }) =>
        this.inputAppClientDBFacade.getConfigurations().pipe(
          take(1),
          map((config) => ({
            selectedEvents: action.events,
            bgDB,
            userDB,
            retryCount: config.retryCount,
          })),
        ),
      ),
      switchMap(({ selectedEvents, userDB, bgDB, retryCount }) => {
        const TotalBulkEvents = BCTXComputationHelper.getBulkEventsWithStatus(
          userDB.dailyCache.events.list,
          bgDB.dailyCache.events.list,
          retryCount,
          bgDB.persistanceCache.nextEventId,
        )[0] as TBulkEvent[];
        const bulkeventsToSync = selectedEvents
          .map((event) => EventUtil.findMatchingBulkEventByVId(event.eventBackgroundMetadata.v_id, TotalBulkEvents))
          .filter(Boolean) as TBulkEvent[];
        const { updatedBulkEvents, updatedNextEventId } = EventUtil.updateEventIds(
          bulkeventsToSync,
          bgDB.persistanceCache.nextEventId,
        );
        return this.inputAppClientDBFacade
          .syncAllBulkEvent({
            bulkEvents: updatedBulkEvents,
            lastBatchSyncStatus: 'YET_TO_BE_SYNCED',
            failedBulkEventsIndexes: [],
          })
          .pipe(
            map((res) => ({
              res,
              TotalBulkEvents,
              updatedNextEventId,
              bgDB,
            })),
          );
      }),
      switchMap(({ res, TotalBulkEvents, updatedNextEventId, bgDB }) => {
        const isAllSynced = res.lastBatchSyncStatus === 'ALL_SYNCED';
        const updatedBulkEvents = isAllSynced
          ? EventUtil.updateBgDBEventsList(res.bulkEvents as TBulkEvent[], TotalBulkEvents)
          : TotalBulkEvents;
        bgDB = produce(bgDB, (draft) => {
          if (isAllSynced) {
            draft.dailyCache.events.list = BCTXComputationHelper.getStatusInfoFromBulkEvents(updatedBulkEvents);
          }
          draft.persistanceCache.nextEventId = updatedNextEventId;
        });
        return from(this.persistentStorageService.set('[APP][INPUT_APP_BACKGROUND_EVENTS_SYNCING_DB]', bgDB)).pipe(
          take(1),
          map(() => ({
            bgDB,
            isAllSynced,
            lastBatchSyncStatus: res.lastBatchSyncStatus,
            syncedEvents: res.bulkEvents,
          })),
        );
      }),
      switchMap(({ bgDB, isAllSynced, lastBatchSyncStatus, syncedEvents }) =>
        from(this.inputAppErrorUtil.dismissLoadingWithId('RESYNC_FAILED_EVENTS')).pipe(
          take(1),
          map(() => {
            if (isAllSynced) {
              this.modalCtrl.dismiss(); //this will close the activity log
              const eventsSyncesdWithSuccess = syncedEvents.filter(
                (event) => event.backgroundMetadata.bulkEventStatus === 'SYNCED',
              );
              const successCount = eventsSyncesdWithSuccess.length;
              const failedCount = syncedEvents.length - successCount;
              if (successCount > 0) {
                return new updateActualsAndbgDBEventsListandNextEventId(
                  eventsSyncesdWithSuccess,
                  failedCount,
                  lastBatchSyncStatus,
                  bgDB.dailyCache.events.list,
                  bgDB.persistanceCache.nextEventId,
                );
              } else {
                const finalMessage = `${failedCount} ${this.translate.instant(
                  'input_app_db_effects.reSync.validation_error',
                )} 
                ${successCount} ${this.translate.instant('input_app_db_effects.reSync.synced_success')}`;
                this.inputAppAPIHelperUtil.showPopup(lastBatchSyncStatus, finalMessage);
                return new updatebgDBEventsListandNextEventIdAndReleaseUserAndBgDBLock(
                  bgDB.dailyCache.events.list,
                  bgDB.persistanceCache.nextEventId,
                );
              }
            } else {
              this.inputAppAPIHelperUtil.showPopup(
                lastBatchSyncStatus,
                this.translate.instant('input_app_db_effects.reSync.failed'),
              );
              return new updateNextEventIDandThenReleaseUserAndBgDBLock(bgDB.persistanceCache.nextEventId);
            }
          }),
        ),
      ),
    ),
  );

  reSyncPastDaysFailedEventsAndThenReleaseBgDBLock$ = createEffect(() =>
    this.action$.pipe(
      ofType<reSyncPastDaysFailedEventsAndThenReleaseBgDBLock>(
        InputAppClientDBActionTypes.reSyncPastDaysFailedEventsAndThenReleaseBgDBLock,
      ),
      switchMap((action) => {
        return from(
          this.inputAppErrorUtil.presentLoadingWithId(
            'RESYNC_FAILED_EVENTS',
            this.translate.instant('input_app_db_effects.reSync.in_progress'),
          ),
        ).pipe(
          take(1),
          map(() => [action] as const),
        );
      }),
      switchMap(([action]) =>
        from(this.persistentStorageService.get('[APP][INPUT_APP_BACKGROUND_EVENTS_SYNCING_DB]')).pipe(
          take(1),
          switchMap((bgDb) =>
            from(this.persistentStorageService.get('[APP][INPUT_APP_PAST_DAY_SYNCED_EVENTS_DB]')).pipe(
              take(1),
              map(
                (inputAppBackupDB) =>
                  [action.events, inputAppBackupDB.listOfPastDaysEventsWhichAreSynced, bgDb, inputAppBackupDB] as const,
              ),
            ),
          ),
        ),
      ),
      switchMap(([selectedEvents, originalBulkEvents, bgDb, inputAppBackupDB]) => {
        const bulkeventsToSync: TBulkEvent[] = selectedEvents
          .map((event) => EventUtil.findMatchingBulkEventByVId(event.eventBackgroundMetadata.v_id, originalBulkEvents))
          .filter(Boolean) as TBulkEvent[];
        const { updatedBulkEvents, updatedNextEventId } = EventUtil.updateEventIds(
          bulkeventsToSync,
          bgDb.persistanceCache.nextEventId,
        );
        const updatedBgDB = produce(bgDb, (draft) => {
          draft.persistanceCache.nextEventId = updatedNextEventId;
        });
        return this.inputAppClientDBFacade
          .syncAllBulkEvent({
            bulkEvents: updatedBulkEvents,
            lastBatchSyncStatus: 'YET_TO_BE_SYNCED',
            failedBulkEventsIndexes: [],
          })
          .pipe(map((res) => [res, updatedBgDB, inputAppBackupDB] as const));
      }),
      switchMap(([res, updatedBgDB, inputAppBackupDB]) => {
        if (res.lastBatchSyncStatus === 'ALL_SYNCED') {
          const resBulkEvents = res.bulkEvents as TActivityLogEvent[];
          const updatedInputAppBackupDB = EventUtil.updatePastDaySyncedEventsDB(resBulkEvents, inputAppBackupDB);
          const eventsSyncesdWithSuccess = resBulkEvents.filter(
            (event) => event.backgroundMetadata.bulkEventStatus === 'SYNCED',
          );
          const successCount = eventsSyncesdWithSuccess.length;
          const failedCount = resBulkEvents.length - successCount;
          return of([
            updatedInputAppBackupDB,
            updatedBgDB,
            res.lastBatchSyncStatus,
            true,
            successCount,
            failedCount,
          ] as const);
        } else {
          return of([inputAppBackupDB, updatedBgDB, res.lastBatchSyncStatus, false, 0, 0] as const);
        }
      }),
      switchMap(
        ([updatedInputAppBackupDB, updatedBgDB, lastBatchSyncStatus, isAllSynced, successCount, failedCount]) => {
          const persistBgDB$ = from(
            this.persistentStorageService.set('[APP][INPUT_APP_BACKGROUND_EVENTS_SYNCING_DB]', updatedBgDB),
          ).pipe(take(1));
          if (isAllSynced) {
            const persistInputAppBackupDB$ = from(
              this.persistentStorageService.set('[APP][INPUT_APP_PAST_DAY_SYNCED_EVENTS_DB]', updatedInputAppBackupDB),
            ).pipe(take(1));
            return persistBgDB$.pipe(
              switchMap(() => persistInputAppBackupDB$),
              switchMap(() =>
                from(this.inputAppErrorUtil.dismissLoadingWithId('RESYNC_FAILED_EVENTS')).pipe(
                  take(1),
                  map(() => {
                    const finalMessage = `${failedCount} ${this.translate.instant(
                      'input_app_db_effects.reSync.validation_error',
                    )} 
                    ${successCount} ${this.translate.instant('input_app_db_effects.reSync.synced_success')}`;
                    this.inputAppAPIHelperUtil.showPopup(lastBatchSyncStatus, finalMessage);
                    this.modalCtrl.dismiss();
                    return new updateNextEventIDandThenReleaseBgDBLock(updatedBgDB.persistanceCache.nextEventId);
                  }),
                ),
              ),
            );
          } else {
            return persistBgDB$.pipe(
              switchMap(() =>
                from(this.inputAppErrorUtil.dismissLoadingWithId('RESYNC_FAILED_EVENTS')).pipe(
                  take(1),
                  map(() => {
                    this.inputAppAPIHelperUtil.showPopup(
                      lastBatchSyncStatus,
                      this.translate.instant('input_app_db_effects.reSync.failed'),
                    );
                    return new updateNextEventIDandThenReleaseBgDBLock(updatedBgDB.persistanceCache.nextEventId);
                  }),
                ),
              ),
            );
          }
        },
      ),
    ),
  );

  SyncEventsAndThenReleaseBgDBLock$ = createEffect(() =>
    this.action$.pipe(
      ofType<SyncEventsAndThenReleaseBgDBLock>(InputAppClientDBActionTypes.SyncEventsAndThenReleaseBgDBLock),
      switchMap((action) => {
        if (action.showLoader) {
          return from(
            this.inputAppErrorUtil.presentLoadingWithId(
              'SYNCING_PENDING_EVENTS',
              this.translate.instant('input_app_db_effects.syncingPendingEvents'),
            ),
          ).pipe(
            take(1),
            map(() => [action] as const),
          );
        } else return of([action] as const);
      }),
      switchMap(([action]) => {
        return from(this.persistentStorageService.get('[APP][INPUT_APP_BACKGROUND_EVENTS_SYNCING_DB]')).pipe(
          take(1),
          switchMap((bgDb) => {
            return from(this.persistentStorageService.get('[APP][INPUT_APP_CLIENT_DB]')).pipe(
              take(1),
              switchMap((userDb) => {
                return this.inputAppClientDBFacade
                  .addMissingEventsStatusInBgDB(userDb.dailyCache.events.list, bgDb, false)
                  .pipe(
                    take(1),
                    map(([updatedBgDb, todaysEvents]) => {
                      return [updatedBgDb, todaysEvents, action] as const;
                    }),
                  );
              }),
            );
          }),
        );
      }),
      switchMap(([bgDb, todaysEvents, action]) => {
        return this.inputAppClientDBFacade.getAppIdentifier().pipe(
          take(1),
          map((appIdentifier) => [bgDb, todaysEvents, action, appIdentifier] as const),
        );
      }),
      switchMap(([bgDb, todaysEvents, action, appIdentifier]) => {
        return this.inputAppClientDBFacade.getBctxItemsOrderForBackUp().pipe(
          take(1),
          map((orderKeys) => [bgDb, todaysEvents, action, appIdentifier, orderKeys] as const),
        );
      }),
      switchMap(([bgDb, todaysEvents, action, appIdentifier, orderKeys]) => {
        return this.inputAppClientDBFacade.getConfigurations().pipe(
          take(1),
          map(
            ({ aggregatedLineMapForPerPiece, pastDaysEventsStorePerPieceEnabled }) =>
              [
                bgDb,
                todaysEvents,
                action,
                appIdentifier,
                orderKeys,
                aggregatedLineMapForPerPiece,
                pastDaysEventsStorePerPieceEnabled,
              ] as const,
          ),
        );
      }),
      switchMap(
        ([
          bgDb,
          todaysEvents,
          action,
          appIdentifier,
          orderKeys,
          aggregatedLineMapForPerPiece,
          isPastDaysEventsStorePerPieceEnabled,
        ]) => {
          const pastDaysEventsInfo = bgDb.persistanceCache.pastDaysList;
          return this.inputAppClientDBFacade
            .syncAtLeastOnePendingBulkEventWithBatchCountWrapper(
              pastDaysEventsInfo.length > 0 ? pastDaysEventsInfo : todaysEvents,
              action.batchCount,
              appIdentifier ? appIdentifier : undefined,
            )
            .pipe(
              switchMap((res) => {
                if (pastDaysEventsInfo.length > 0) {
                  const lastSyncedIndex = EventUtil.getLastSyncedIndex(res.bulkEvents);
                  if (appIdentifier === 'endline_qc_v2' || appIdentifier === 'bundle_qc_v2') {
                    const updatedPastDaysDefectives = EventUtil.updateBulkQcPastDefectivesStatus(
                      bgDb.persistanceCache.bulkQcPastDaysDefectives,
                      res.bulkEvents.slice(0, lastSyncedIndex + 1),
                    );
                    const updatedPastDaysBackgroundEventsSyncInfo = EventUtil.updatePastDaysBackgroundEventsSyncInfo(
                      bgDb.persistanceCache.pastDaysBackgroundEventsSyncInfo,
                      res.bulkEvents.slice(0, lastSyncedIndex + 1),
                    );
                    bgDb = produce(bgDb, (draft) => {
                      draft.persistanceCache.bulkQcPastDaysDefectives = updatedPastDaysDefectives;
                      draft.persistanceCache.pastDaysBackgroundEventsSyncInfo = updatedPastDaysBackgroundEventsSyncInfo;
                    });
                  }
                  //here update new DB store
                  if (isPastDaysEventsStorePerPieceEnabled === true) {
                    return this.inputAppClientDBFacade
                      .handleInputAppBackupDBforPastDayEventsUpdate(res.bulkEvents.slice(0, lastSyncedIndex + 1))
                      .pipe(
                        map((isUpdated) => {
                          if (isUpdated) {
                            console.log('BackupDB updated successfully with new synced events from pastdayList');
                          }
                          bgDb = produce(bgDb, (draft) => {
                            draft.persistanceCache.pastDaysList = res.bulkEvents.slice(lastSyncedIndex + 1);
                          });
                          return [bgDb, res, action, true] as const;
                        }),
                      );
                  }
                  bgDb = produce(bgDb, (draft) => {
                    draft.persistanceCache.pastDaysList = res.bulkEvents.slice(lastSyncedIndex + 1);
                  });
                  // bgDb = BCTXComputationHelper.updateWipAndActualsForFailedBulkEventsWithFilteredSingleEvents(
                  //   bgDb,
                  //   res.failedBulkEventsIndexes.map((index) => res.bulkEvents[index]),
                  //   ['VALIDATION_ERROR', 'SERVER_ERROR'],
                  //   true,
                  // );
                  return of([bgDb, res, action, true] as const);
                } else {
                  bgDb = produce(bgDb, (draft) => {
                    draft.dailyCache.events.list = BCTXComputationHelper.getStatusInfoFromBulkEvents(res.bulkEvents);
                  });
                  if (aggregatedLineMapForPerPiece && BCTXComputationHelper.isPerPieceApp(appIdentifier)) {
                    bgDb =
                      PerPieceComputationHelper.updateActualsForFailedBulkEventsWithFilteredSingleEventsForPerPiece(
                        bgDb,
                        res.failedBulkEventsIndexes.map((index) => res.bulkEvents[index]),
                        ['VALIDATION_ERROR', 'SERVER_ERROR'],
                      );
                  } else {
                    bgDb = BCTXComputationHelper.updateWipAndActualsForFailedBulkEventsWithFilteredSingleEvents(
                      bgDb,
                      res.failedBulkEventsIndexes.map((index) => res.bulkEvents[index]),
                      ['VALIDATION_ERROR', 'SERVER_ERROR'],
                      action.updateActualsOnly,
                      orderKeys,
                    );
                  }
                  return of([bgDb, res, action, false] as const);
                }
              }),
            );
        },
      ),
      switchMap(([currentDB, syncEventsDTO, action, pastEventsSynced]) => {
        if (action.showLoader) {
          return from(this.inputAppErrorUtil.dismissLoadingWithId('SYNCING_PENDING_EVENTS')).pipe(
            take(1),
            map(() => [currentDB, syncEventsDTO, action, pastEventsSynced] as const),
          );
        } else return of([currentDB, syncEventsDTO, action, pastEventsSynced] as const);
      }),
      switchMap(([currentDB, syncEventsDTO, action, pastEventsSynced]) =>
        from(this.persistentStorageService.set('[APP][INPUT_APP_BACKGROUND_EVENTS_SYNCING_DB]', currentDB)).pipe(
          map(() => {
            return new UpdateBgDBAndReleaseLockForSyncEvents(
              action.updateActualsOnly,
              pastEventsSynced,
              currentDB,
              syncEventsDTO,
              action.chainAction,
            );
          }),
        ),
      ),
    ),
  );

  CheckEventsValidAndThenAddBulkEvents$ = createEffect(() =>
    this.action$.pipe(
      ofType<CheckEventsValidAndThenAddBulkEvents>(InputAppClientDBActionTypes.CheckEventsValidAndThenAddBulkEvents),
      switchMap((action) => {
        return from(
          this.inputAppErrorUtil.presentLoadingWithId(
            'ADDING_EVENT',
            this.translate.instant('input_app_db_effects.syncingEvents'),
          ),
        ).pipe(
          take(1),
          map(() => [action] as const),
        );
      }),
      switchMap(([action]) => {
        return from(this.persistentStorageService.get('[APP][INPUT_APP_BACKGROUND_EVENTS_SYNCING_DB]')).pipe(
          take(1),
          switchMap((bgDb) => {
            return from(this.persistentStorageService.get('[APP][INPUT_APP_CLIENT_DB]')).pipe(
              take(1),
              switchMap((userDb) => {
                return this.inputAppClientDBFacade.getConfigurations().pipe(
                  take(1),
                  map(({ retryCount, aggregatedLineMapForPerPiece }) => {
                    const currentTempUserDbItems = cloneDeep(userDb.dailyCache.events.list);
                    currentTempUserDbItems.push(...action.events);
                    const [bulkEvents, newNextEventId] = BCTXComputationHelper.getBulkEventsWithStatus(
                      currentTempUserDbItems,
                      bgDb.dailyCache.events.list,
                      retryCount,
                      bgDb.persistanceCache.nextEventId,
                    );
                    const filterGroupId = action.events.map((ele) => ele.metadata.groupId);
                    const bulkEventswithBackgroundDataMapped = bulkEvents.filter((ele) =>
                      filterGroupId.includes(ele.metadata.groupId),
                    );
                    return [
                      userDb,
                      bgDb,
                      bulkEventswithBackgroundDataMapped,
                      bulkEvents,
                      newNextEventId,
                      aggregatedLineMapForPerPiece,
                      action,
                    ] as const;
                  }),
                );
              }),
            );
          }),
        );
      }),
      switchMap(
        ([userDb, bgDb, bulkEvents, allBulkEventsWithStatus, newNextEventId, aggregatedLineMapForPerPiece, action]) => {
          return this.inputAppClientDBFacade.getSelectedStationIdAndShiftId().pipe(
            take(1),
            map(
              ({ stationId }) =>
                [
                  userDb,
                  bgDb,
                  bulkEvents,
                  allBulkEventsWithStatus,
                  newNextEventId,
                  stationId,
                  aggregatedLineMapForPerPiece,
                  action,
                ] as const,
            ),
          );
        },
      ),
      switchMap(
        ([
          userDb,
          bgDb,
          bulkEvents,
          allBulkEventsWithStatus,
          newNextEventId,
          stationId,
          aggregatedLineMapForPerPiece,
          action,
        ]) => {
          return this.inputAppClientDBFacade.getBctxItemsOrderForBackUp().pipe(
            take(1),
            map(
              (orderKeys) =>
                [
                  userDb,
                  bgDb,
                  bulkEvents,
                  allBulkEventsWithStatus,
                  newNextEventId,
                  stationId,
                  orderKeys,
                  aggregatedLineMapForPerPiece,
                  action,
                ] as const,
            ),
          );
        },
      ),
      switchMap(
        ([
          userDb,
          bgDb,
          bulkEvents,
          allBulkEventsWithStatus,
          newNextEventId,
          stationId,
          orderKeys,
          aggregatedLineMapForPerPiece,
          action,
        ]) =>
          this.inputAppClientDBFacade.getAppIdentifier().pipe(
            take(1),
            map((app_identifier) => {
              return [
                userDb,
                bgDb,
                bulkEvents,
                allBulkEventsWithStatus,
                newNextEventId,
                stationId,
                orderKeys,
                aggregatedLineMapForPerPiece,
                app_identifier,
                action,
              ] as const;
            }),
          ),
      ),
      switchMap(
        ([
          userDb,
          bgDb,
          bulkEvents,
          allBulkEventsWithStatus,
          newNextEventId,
          stationId,
          orderKeys,
          aggregatedLineMapForPerPiece,
          app_identifier,
          action,
        ]) => {
          return this.inputAppClientDBFacade
            .syncAllBulkEvent({
              bulkEvents: bulkEvents,
              lastBatchSyncStatus: 'YET_TO_BE_SYNCED',
              failedBulkEventsIndexes: [],
            })
            .pipe(
              map((res) => {
                if (res.lastBatchSyncStatus === 'ALL_SYNCED') {
                  const isAnyEventMissing = bgDb.dailyCache.events.list.length !== userDb.dailyCache.events.list.length;
                  bgDb = produce(bgDb, (draft) => {
                    if (!isAnyEventMissing) {
                      draft.dailyCache.events.list.push(
                        ...BCTXComputationHelper.getStatusInfoFromBulkEvents(res.bulkEvents),
                      );
                    } else {
                      const syncedBulkEventsByGroupId = new Map(
                        res.bulkEvents.map((event) => [event.metadata.groupId, event]),
                      );
                      draft.dailyCache.events.list = BCTXComputationHelper.getStatusInfoFromBulkEvents(
                        allBulkEventsWithStatus.map(
                          (event) => syncedBulkEventsByGroupId.get(event.metadata.groupId) ?? event,
                        ),
                      );
                    }
                    draft.persistanceCache.nextEventId = newNextEventId;
                  });

                  userDb = produce(userDb, (draft) => {
                    action.events.forEach((event) => draft.dailyCache.events.list.push(event));
                  });
                  const allSyncedGroupIds = res.bulkEvents
                    .filter((event) => event.backgroundMetadata.bulkEventStatus === 'SYNCED')
                    .map((event) => event.metadata.groupId);
                  const allSuccessfullySyncedToBackendEvents = action.events.filter((event) =>
                    allSyncedGroupIds.includes(event.metadata.groupId),
                  );
                  if (allSuccessfullySyncedToBackendEvents.length !== action.events.length) {
                    this.customLoggerService.log('INPUT_APP_CLIENT_DB_EFFECT', 'Some events were not successful', {
                      actionEventsCount: action.events.length,
                      syncedCount: allSuccessfullySyncedToBackendEvents.length,
                    });
                  }
                  if (aggregatedLineMapForPerPiece && BCTXComputationHelper.isPerPieceApp(app_identifier)) {
                    userDb = PerPieceComputationHelper.updateActualsForBulkEventsForAllSingleEventsPerPiece(
                      userDb,
                      action.events,
                      orderKeys,
                    );
                  } else {
                    userDb = BCTXComputationHelper.updateWipAndActualsForBulkEventsForAllSingleEvents(
                      userDb,
                      allSuccessfullySyncedToBackendEvents,
                      action.eventAddtionMoreActions.updateActualsOnly,
                      orderKeys,
                    );
                  }

                  if (action.eventAddtionMoreActions.updateSelectedBctx) {
                    const selectedBctxInfo = action.eventAddtionMoreActions.updateSelectedBctx;
                    userDb = produce(userDb, (draft) => {
                      if (aggregatedLineMapForPerPiece && BCTXComputationHelper.isPerPieceApp(app_identifier)) {
                        draft.dailyCache.ppLineMap[stationId] &&
                          (draft.dailyCache.ppLineMap[stationId].selectedBctxInfo = selectedBctxInfo);
                      } else {
                        draft.dailyCache.lineMap[stationId] &&
                          (draft.dailyCache.lineMap[stationId].selectedBctxInfo = selectedBctxInfo);
                      }
                    });
                  } else if (action.eventAddtionMoreActions.clearSelectedBctx) {
                    userDb = produce(userDb, (draft) => {
                      if (aggregatedLineMapForPerPiece && BCTXComputationHelper.isPerPieceApp(app_identifier)) {
                        draft.dailyCache.ppLineMap[stationId] &&
                          (draft.dailyCache.ppLineMap[stationId].selectedBctxInfo = DEFAULT_SELECTED_BCTX_INFO);
                      } else {
                        draft.dailyCache.lineMap[stationId] &&
                          (draft.dailyCache.lineMap[stationId].selectedBctxInfo = DEFAULT_SELECTED_BCTX_INFO);
                      }
                    });
                  }

                  return new AddDataToDbThenReleaseBgAndUserDbLockAndHandleSideEffects(
                    action.events,
                    res,
                    userDb,
                    bgDb,
                    action.rfidScannerBulkMode,
                    action.eventAddtionMoreActions.updateActualsOnly,
                    action.eventAdditionSideActions,
                  );
                } else {
                  this.customLoggerService.log('INPUT_APP_CLIENT_DB_EFFECT', 'lastBatchSyncStatus is not ALL_SYNCED', {
                    events: action.events,
                    res: res,
                  });
                  this.inputAppClientDBFacade.releaseBgDBLock();
                  this.inputAppClientDBFacade.releaseUserDBLock();
                  this.inputAppClientDBFacade.emitRFIDDataProcessingSubscription(false);
                  this.inputAppErrorUtil.dismissLoadingWithId('ADDING_EVENT');
                  return new InputAppNoAction();
                }
              }),
              catchError((error) => {
                // Failsafe catch block to prevent the overall Effect from dying
                this.customLoggerService.log(
                  'INPUT_APP_CLIENT_DB_EFFECT',
                  'UNHANDLED EXCEPTION in CheckEventsValidAndThenAddBulkEvents stream',
                  {
                    error: JSON.stringify(error),
                    events: action.events,
                  },
                );
                // Release DB locks and dismiss loadings to avoid app freeze so that user dont need to close and reopen the app in case of such unhandled exceptions.
                // [PBI-2909]: In some scenarios, api is successfully syncing events but writing to DB is failing which is causing Tab and dashboard mismatch.
                this.inputAppClientDBFacade.releaseBgDBLock();
                this.inputAppClientDBFacade.releaseUserDBLock();
                this.inputAppClientDBFacade.emitRFIDDataProcessingSubscription(false);
                this.inputAppErrorUtil.dismissLoadingWithId('ADDING_EVENT');
                return of(new InputAppNoAction());
              }),
            );
        },
      ),
    ),
  );

  AddDataToDbThenReleaseBgAndUserDbLockAndHandleSideEffects$ = createEffect(() =>
    this.action$.pipe(
      ofType<AddDataToDbThenReleaseBgAndUserDbLockAndHandleSideEffects>(
        InputAppClientDBActionTypes.AddDataToDbThenReleaseBgAndUserDbLockAndHandleSideEffects,
      ),
      switchMap((action) => {
        return from(this.inputAppErrorUtil.dismissLoadingWithId('ADDING_EVENT')).pipe(
          take(1),
          map(() => {
            return [action] as const;
          }),
        );
      }),

      switchMap(([action]) =>
        from(this.persistentStorageService.set('[APP][INPUT_APP_BACKGROUND_EVENTS_SYNCING_DB]', action.bgDb)).pipe(
          map(() => [action] as const),
        ),
      ),
      switchMap(([action]) =>
        from(this.persistentStorageService.set('[APP][INPUT_APP_CLIENT_DB]', action.userDb)).pipe(
          map(() => {
            return [action] as const;
          }),
        ),
      ),
      switchMap(([action]) => {
        return this.appMasterDBFacade.getAppIdentifier().pipe(
          take(1),
          map((appIdentifier) => {
            return [action, appIdentifier] as const;
          }),
        );
      }),
      switchMap(([action, appIdentifier]) => {
        return this.inputAppClientDBFacade.getBctxKeysToDisplayMap().pipe(
          take(1),
          map((bctxKeysToDisplayMap) => {
            return [action, appIdentifier, bctxKeysToDisplayMap] as const;
          }),
        );
      }),
      switchMap(([action, appIdentifier, bctxKeysToDisplayMap]) => {
        this.inputAppClientDBFacade.emitRFIDDataProcessingSubscription(false);
        if (action.eventAdditionSideActions) {
          if (action.eventAdditionSideActions.perPieceDefectOrRejectAddition) {
            this.inputAppClientDBFacade.emitPerPieceQcDefectOrRejectAddition(
              action.eventAdditionSideActions.perPieceDefectOrRejectAddition,
            );
          } else if (action.eventAdditionSideActions.showPerPieceDefective) {
            this.inputAppClientDBFacade.emitShowPerPieceDefectiveSubscription(
              action.eventAdditionSideActions.showPerPieceDefective,
            );
          } else if (action.eventAdditionSideActions.closeModal) {
            this.modalCtrl.dismiss();
          }
        }

        return of(
          new ReleaseBgAndUserDbLockAndShowFailedEventsAction(
            action.userDb,
            action.bgDb,
            appIdentifier,
            action.updateActualsOnly,
            action.syncEventsDTO.bulkEvents,
            action.syncEventsDTO.failedBulkEventsIndexes,
            bctxKeysToDisplayMap,
            action.rfidScannerBulkMode,
          ),
        );
      }),
    ),
  );

  UpdateBgDBAndReleaseLockForSyncEvents$ = createEffect(() =>
    this.action$.pipe(
      ofType<UpdateBgDBAndReleaseLockForSyncEvents>(InputAppClientDBActionTypes.UpdateBgDBAndReleaseLockForSyncEvents),
      switchMap((action) => {
        return this.appMasterDBFacade.getAppIdentifier().pipe(
          take(1),
          map((appIdentifier) => {
            return [action, appIdentifier] as const;
          }),
        );
      }),
      switchMap(([action, appIdentifier]) => {
        return this.inputAppClientDBFacade.getBctxKeysToDisplayMap().pipe(
          take(1),
          map((bctxKeysToDisplayMap) => {
            return [action, appIdentifier, bctxKeysToDisplayMap] as const;
          }),
        );
      }),
      switchMap(([action, appIdentifier, bctxKeysToDisplayMap]) => {
        if (action.chainAction) {
          if (action.syncEventsDTO.lastBatchSyncStatus === 'ALL_SYNCED') {
            this.inputAppClientDBFacade.releaseUserDBLock();
            if (action.chainAction.chainWithUndo)
              this.inputAppClientDBFacade.forceUndoEventAfterSyncingAllPendingEvents(
                action.updateActualsOnly,
                action.chainAction.chainWithUndo,
                true,
                false,
              );
            else if (action.chainAction.chainWithPerPieceLineInUndo) {
              this.inputAppClientDBFacade.forcePerPieceLineInUndoAfterSyncingAllPendingEvents(
                action.updateActualsOnly,
                action.chainAction.chainWithPerPieceLineInUndo,
                true,
                false,
              );
            } else if (action.chainAction.chainWithPerPieceQcUndo) {
              this.inputAppClientDBFacade.forcePerPieceQcUndoEventAfterSyncingAllPendingEvents(
                action.updateActualsOnly,
                action.chainAction.chainWithPerPieceQcUndo,
                true,
                false,
              );
            } else if (action.chainAction.chainWithReFetchWip)
              this.inputAppClientDBFacade.forceSyncWipAfterSyncingAllPendingEvents(
                action.updateActualsOnly,
                true,
                false,
              );
            else if (action.chainAction.chainWithRestoreWipAndActualsForBackedUpBctx)
              this.inputAppClientDBFacade.restoreAppStateForBackedUpBctx(
                action.updateActualsOnly,
                action.chainAction.chainWithRestoreWipAndActualsForBackedUpBctx,
                true,
                false,
              );
            else if (action.chainAction.chainWithInitForLineChange) {
              this.inputAppClientDBFacade.forceInitLineChangeAfterSyncingAllPendingEvents(
                action.updateActualsOnly,
                true,
                false,
                action.chainAction.chainWithInitForLineChange,
              );
            } else if (action.chainAction.chainWithReFetchServerDefectives) {
              this.inputAppClientDBFacade.fetchServerDefectivesAfterSyncingAllPendingEvents(
                action.updateActualsOnly,
                true,
              );
            } else if (action.chainAction.chainWithLoadBctxAndChainActions) {
              this.inputAppClientDBFacade.loadBctxWithChainActions(
                action.chainAction.chainWithLoadBctxAndChainActions.moreActions,
                action.chainAction.chainWithLoadBctxAndChainActions.chainActions,
              );
            } else if (action.chainAction.chainWithLogout) {
              if (action.syncEventsDTO.failedBulkEventsIndexes.length === 0) {
                this.inputAppClientDBFacade.forceLogoutAfterSyncingAllPendingEvents(
                  action.updateActualsOnly,
                  true,
                  false,
                );
              }
            } else if (action.chainAction.chainWithAppUpdate) {
              //There is a race condition between the validation error events and app update retry pop-up,
              //but this won't cause any problem, as both the callbacks in these two popups are safe
              this.inputAppClientDBFacade.reconcileAndShowErrorForAppUpdates(action.updateActualsOnly, {
                remoteDeploymentcheck: action.chainAction.chainWithAppUpdate,
                syncResult: {
                  status:
                    action.syncEventsDTO.failedBulkEventsIndexes.length === 0
                      ? 'ALL_SYNCED'
                      : 'ALL_SYNCED_WITH_VALIDATION_ERRORS',
                },
              });
            }
            return of(
              new ShowFailedEventsAction(
                appIdentifier,
                action.updateActualsOnly,
                action.syncEventsDTO.bulkEvents,
                action.syncEventsDTO.failedBulkEventsIndexes,
                bctxKeysToDisplayMap,
                action.rfidScannerBulkMode,
              ),
            );
          } else {
            if (action.chainAction.chainWithLogout) {
              this.inputAppClientDBFacade.releaseUserDBLock();
              if (action.pastEventsSynced) {
                this.inputAppAPIHelperUtil.showLogoutFailurePopup(action.updateActualsOnly);
                return of(new InputAppNoAction());
              } else if (action.syncEventsDTO.failedBulkEventsIndexes.length === 0) {
                this.inputAppAPIHelperUtil.showLogoutFailurePopup(action.updateActualsOnly);
                return of(new InputAppNoAction());
              } else {
                return of(
                  new ShowFailedEventsAction(
                    appIdentifier,
                    action.updateActualsOnly,
                    action.syncEventsDTO.bulkEvents,
                    action.syncEventsDTO.failedBulkEventsIndexes,
                    bctxKeysToDisplayMap,
                    action.rfidScannerBulkMode,
                  ),
                );
              }
            } else if (action.chainAction.chainWithAppUpdate) {
              this.inputAppClientDBFacade.releaseUserDBLock();
              this.inputAppClientDBFacade.reconcileAndShowErrorForAppUpdates(action.updateActualsOnly, {
                remoteDeploymentcheck: action.chainAction.chainWithAppUpdate,
                syncResult: {
                  status: 'SYNCING_PENDING_EVENTS_FAILED',
                },
              });
              return of(
                new ShowFailedEventsAction(
                  appIdentifier,
                  action.updateActualsOnly,
                  action.syncEventsDTO.bulkEvents,
                  action.syncEventsDTO.failedBulkEventsIndexes,
                  bctxKeysToDisplayMap,
                  action.rfidScannerBulkMode,
                ),
              );
            } else {
              return from(
                this.inputAppAPIHelperUtil.showPopup(
                  this.translate.instant('input_app_common.error'),
                  `${this.translate.instant('input_app_db_effects.cannotProcess')} ${
                    action.pastEventsSynced
                      ? this.translate.instant('input_app_db_effects.syncingPastEvents')
                      : this.translate.instant('input_app_db_effects.syncingPendingEventsE')
                  } ${this.translate.instant('input_app_db_effects.failedDueTo')} ${
                    action.syncEventsDTO.lastBatchSyncStatus
                  }`,
                ),
              ).pipe(
                take(1),
                map(() => {
                  this.inputAppClientDBFacade.releaseUserDBLock();
                  if (action.pastEventsSynced) {
                    return new InputAppNoAction();
                  } else {
                    return new ShowFailedEventsAction(
                      appIdentifier,
                      action.updateActualsOnly,
                      action.syncEventsDTO.bulkEvents,
                      action.syncEventsDTO.failedBulkEventsIndexes,
                      bctxKeysToDisplayMap,
                      action.rfidScannerBulkMode,
                    );
                  }
                }),
              );
            }
          }
        } else if (action.pastEventsSynced) {
          if (action.syncEventsDTO.lastBatchSyncStatus === 'ALL_SYNCED')
            this.inputAppClientDBFacade.backgroundSyncEventsJustAfterEventAdditionOrBgSyncing(action.updateActualsOnly);
          return of(new InputAppNoAction());
        } else {
          if (action.syncEventsDTO.lastBatchSyncStatus === 'ALL_SYNCED')
            this.inputAppClientDBFacade.backgroundSyncEventsJustAfterEventAdditionOrBgSyncing(action.updateActualsOnly);
          return of(
            new ShowFailedEventsAction(
              appIdentifier,
              action.updateActualsOnly,
              action.syncEventsDTO.bulkEvents,
              action.syncEventsDTO.failedBulkEventsIndexes,
              bctxKeysToDisplayMap,
              action.rfidScannerBulkMode,
            ),
          );
        }
      }),
    ),
  );

  ReleaseBgAndUserDbLockAndShowFailedEventsAction$ = createEffect(() => {
    return this.action$.pipe(
      ofType<ReleaseBgAndUserDbLockAndShowFailedEventsAction>(
        InputAppClientDBActionTypes.ReleaseBgAndUserDbLockAndShowFailedEventsAction,
      ),
      switchMap((action) => {
        return of(
          new ShowFailedEventsAction(
            action.appIdentifier,
            action.updateActualsOnly,
            action.bulkEvents,
            action.failedBulkEventsIndexes,
            action.bctxKeysToDisplayMap,
            action.rfidScannerBulkMode,
          ),
        );
      }),
    );
  });

  ShowFailedEventsAction$ = createEffect(() => {
    return this.action$.pipe(
      ofType<ShowFailedEventsAction>(InputAppClientDBActionTypes.ShowFailedEventsAction),
      switchMap((action) => {
        return from(
          this.inputAppAPIHelperUtil.showFailedEvents(
            action.appIdentifier,
            action.updateActualsOnly,
            action.bulkEvents,
            action.failedBulkEventsIndexes,
            action.bctxKeysToDisplayMap,
            action.rfidScannerBulkMode,
          ),
        ).pipe(
          map(() => {
            return new InputAppNoAction();
          }),
        );
      }),
    );
  });

  AcquireUserDBLockAndBgDBLockAndReconcile$ = createEffect(() => {
    return this.action$.pipe(
      ofType<AcquireUserDBLockAndBgDBLockAndReconcile>(
        InputAppClientDBActionTypes.AcquireUserDBLockAndBgDBLockAndReconcile,
      ),
      switchMap((action) => {
        return this.inputAppClientDBFacade.acquireUserAndBgDBLock('RECONCILE').pipe(
          take(1),
          switchMap(([bgLockResult, userLockResult]) => {
            if (bgLockResult.status === 'SUCCESS' && userLockResult.status === 'SUCCESS') {
              return of(new ReconcileUserDBAndBgDBAndThenReleaseLocks(action.updateActualsOnly, action.chainAction));
            } else {
              if (action.showLockFailure) {
                if (userLockResult.status === 'FAILURE')
                  this.inputAppAPIHelperUtil.showPopup(
                    this.translate.instant('input_app_common.error'),
                    userLockResult.message,
                  );
                else if (bgLockResult.status === 'FAILURE')
                  this.inputAppAPIHelperUtil.showPopup(
                    this.translate.instant('input_app_common.error'),
                    bgLockResult.message,
                  );
              }
              if (bgLockResult.status === 'SUCCESS') return of(new ReleaseBgDBLock());
              else if (userLockResult.status === 'SUCCESS') return of(new ReleaseUserDBLock());
              return of(new InputAppNoAction());
            }
          }),
        );
      }),
    );
  });

  ReconcileUserDBAndBgDBAndThenReleaseLocks$ = createEffect(() =>
    this.action$.pipe(
      ofType<ReconcileUserDBAndBgDBAndThenReleaseLocks>(
        InputAppClientDBActionTypes.ReconcileUserDBAndBgDBAndThenReleaseLocks,
      ),
      switchMap((action) =>
        from(this.persistentStorageService.get('[APP][INPUT_APP_CLIENT_DB]')).pipe(
          map((localStorageDb) => {
            return [localStorageDb, action] as const;
          }),
        ),
      ),
      switchMap(([userDB, action]) =>
        from(this.persistentStorageService.get('[APP][INPUT_APP_BACKGROUND_EVENTS_SYNCING_DB]')).pipe(
          map((bgDB) => {
            return [userDB, bgDB, action] as const;
          }),
        ),
      ),
      switchMap(([userDB, bgDB, action]) => {
        return this.inputAppClientDBFacade
          .reconcileUserAndBgEventsDB(userDB, bgDB, userDB.dailyCache.nextCacheResetTimestamp)
          .pipe(
            take(1),
            map(([updatedUserDB, updatedBgDB]) => {
              return [updatedUserDB, updatedBgDB, action] as const;
            }),
          );
      }),
      switchMap(([updatedUserDB, updatedBgDB, action]) => {
        return from(
          this.persistentStorageService.set('[APP][INPUT_APP_BACKGROUND_EVENTS_SYNCING_DB]', updatedBgDB),
        ).pipe(
          take(1),
          switchMap(() => {
            return from(this.persistentStorageService.set('[APP][INPUT_APP_CLIENT_DB]', updatedUserDB)).pipe(
              take(1),
              map(() => [updatedUserDB, updatedBgDB, action] as const),
            );
          }),
        );
      }),
      switchMap(([updatedUserDB, updatedBgDB, action]) => {
        return of(
          new SetUserDBAndBgDBAndReleaseLocksWithChains(
            action.updateActualsOnly,
            updatedUserDB,
            updatedBgDB,
            action.chainAction,
          ),
        );
      }),
    ),
  );

  SetUserDBAndBgDBAndReleaseLocksWithChains$ = createEffect(() =>
    this.action$.pipe(
      ofType<SetUserDBAndBgDBAndReleaseLocksWithChains>(
        InputAppClientDBActionTypes.SetUserDBAndBgDBAndReleaseLocksWithChains,
      ),
      switchMap((action) => {
        if (action.chainAction.chainWithUndo)
          this.inputAppClientDBFacade.forceUndoEventAfterSyncingAllPendingEvents(
            action.updateActualsOnly,
            action.chainAction.chainWithUndo,
            true,
            true,
          );
        else if (action.chainAction.chainWithPerPieceLineInUndo) {
          this.inputAppClientDBFacade.forcePerPieceLineInUndoAfterSyncingAllPendingEvents(
            action.updateActualsOnly,
            action.chainAction.chainWithPerPieceLineInUndo,
            true,
            true,
          );
        } else if (action.chainAction.chainWithPerPieceQcUndo) {
          this.inputAppClientDBFacade.forcePerPieceQcUndoEventAfterSyncingAllPendingEvents(
            action.updateActualsOnly,
            action.chainAction.chainWithPerPieceQcUndo,
            true,
            true,
          );
        } else if (action.chainAction.chainWithReFetchWip)
          this.inputAppClientDBFacade.forceSyncWipAfterSyncingAllPendingEvents(action.updateActualsOnly, true, true);
        else if (action.chainAction.chainWithRestoreWipAndActualsForBackedUpBctx)
          this.inputAppClientDBFacade.restoreAppStateForBackedUpBctx(
            action.updateActualsOnly,
            action.chainAction.chainWithRestoreWipAndActualsForBackedUpBctx,
            true,
            true,
          );
        else if (action.chainAction.chainWithInitForLineChange) {
          this.inputAppClientDBFacade.forceInitLineChangeAfterSyncingAllPendingEvents(
            action.updateActualsOnly,
            true,
            true,
            action.chainAction.chainWithInitForLineChange,
          );
        } else if (action.chainAction.chainWithSyncWipForBackground) {
          this.inputAppClientDBFacade.reconcileAndSyncWipForBackground(
            action.chainAction.chainWithSyncWipForBackground,
            action.updateActualsOnly,
            true,
          );
        } else if (action.chainAction.chainWithLogout) {
          this.inputAppClientDBFacade.forceLogoutAfterSyncingAllPendingEvents(action.updateActualsOnly, true, true);
        } else if (action.chainAction.chainWithAppUpdate) {
          this.inputAppClientDBFacade.forceSyncEventsAndUpdateApp(
            action.updateActualsOnly,
            action.chainAction.chainWithAppUpdate,
            true,
          );
        } else if (action.chainAction.reconcileAndShowAppUpdateError) {
          this.inputAppClientDBFacade.emitAppUpdateSubscription(action.chainAction.reconcileAndShowAppUpdateError);
        }
        return of(new InputAppNoAction());
      }),
    ),
  );

  AcquireLockAndThenInitializeUserAndBgDBs$ = createEffect(() => {
    return this.action$.pipe(
      ofType<AcquireLockAndThenInitializeUserAndBgDBs>(
        InputAppClientDBActionTypes.AcquireLockAndThenInitializeUserAndBgDBs,
      ),
      switchMap((action) => {
        return this.inputAppClientDBFacade.acquireUserAndBgDBLock('INIT_PENDING').pipe(
          take(1),
          switchMap(([bgLockResult, userLockResult]) => {
            if (bgLockResult.status === 'SUCCESS' && userLockResult.status === 'SUCCESS') {
              return of(new InitializeUserAndBgDBsAndThenReleaseLock());
            } else {
              // No popup: for lockFor='INIT_PENDING', acquireUserDBLock/acquireBgDBLock skip the
              // factory-end-time check entirely, so the only reachable failure here is the lock
              // being held by another in-progress startup operation (e.g. BCTX_SYNCING) — the
              // race this fix targets, not a genuine error.
              if (bgLockResult.status === 'SUCCESS') return of(new ReleaseBgDBLock());
              else if (userLockResult.status === 'SUCCESS') return of(new ReleaseUserDBLock());
              return of(new InputAppNoAction());
            }
          }),
        );
      }),
    );
  });

  InitializeUserAndBgDBsAndThenReleaseLock$ = createEffect(() =>
    this.action$.pipe(
      ofType<InitializeUserAndBgDBsAndThenReleaseLock>(
        InputAppClientDBActionTypes.InitializeUserAndBgDBsAndThenReleaseLock,
      ),
      switchMap((action) =>
        from(this.persistentStorageService.get('[APP][INPUT_APP_CLIENT_DB]')).pipe(
          map((localStorageDb) => {
            return [localStorageDb] as const;
          }),
        ),
      ),
      switchMap(([userDB]) =>
        from(this.persistentStorageService.get('[APP][INPUT_APP_BACKGROUND_EVENTS_SYNCING_DB]')).pipe(
          map((bgDB) => {
            return [userDB, bgDB] as const;
          }),
        ),
      ),
      switchMap(([userDB, bgDB]) => {
        return this.initStoreFacade.getNextCacheResetTimestamp().pipe(
          take(1),
          map((nextCacheResetTimestamp) => [userDB, bgDB, nextCacheResetTimestamp] as const),
        );
      }),
      switchMap(([userDB, bgDB, nextCacheResetTimestamp]) => {
        return this.inputAppClientDBFacade.getConfigurations().pipe(
          take(1),
          map(({ enableTabDataCapture }) => [userDB, bgDB, nextCacheResetTimestamp, enableTabDataCapture] as const),
        );
      }),
      switchMap(([userDB, bgDB, nextCacheResetTimestamp, enableTabDataCapture]) => {
        const isInit = !userDB;
        const isReload = !isInit && userDB.dailyCache.nextCacheResetTimestamp === nextCacheResetTimestamp;
        const inputAppInitialState = getInputAppInitialState(nextCacheResetTimestamp);
        userDB = userDB || inputAppInitialState.userDB;
        bgDB = bgDB || inputAppInitialState.bgDB;
        // TODO : NISHA temp logs for debugging
        if (enableTabDataCapture) {
          this.customLoggerService.sendDirectLogsToBackend('INPUT_APP_CLIENT_DB_REDUX_STORE - InitializeUserAndBgDBsAndThenReleaseLock', {
            userDB,
            bgDB,
            nextCacheResetTimestamp,
            isInit,
            isReload,
          });
        }

        if (!isInit && userDB.dailyCache.nextCacheResetTimestamp !== bgDB.dailyCache.nextCacheResetTimestamp) {
          this.customLoggerService.log('INPUT_APP_INIT_NCRT_DIVERGENCE', {
            nextCacheResetTimestamp: nextCacheResetTimestamp,
            loadedUserDBNCRT: userDB.dailyCache.nextCacheResetTimestamp,
            loadedBgDBNCRT: bgDB.dailyCache.nextCacheResetTimestamp,
            userDBEventsCount: userDB.dailyCache.events.list.length,
            bgDBEventsCount: bgDB.dailyCache.events.list.length,
            bgDBNextEventId: bgDB.persistanceCache.nextEventId,
            isReload,
          });
        }
        return this.inputAppClientDBFacade.reconcileUserAndBgEventsDB(userDB, bgDB, nextCacheResetTimestamp).pipe(
          take(1),
          map(([updatedUserDB, updatedBgDB]) => {
            return [updatedUserDB, updatedBgDB, isInit, isReload] as const;
          }),
        );
      }),
      switchMap(([updatedUserDB, updatedBgDB, isInit, isReload]) => {
        return from(
          this.persistentStorageService.set('[APP][INPUT_APP_BACKGROUND_EVENTS_SYNCING_DB]', updatedBgDB),
        ).pipe(
          take(1),
          switchMap(() => {
            //TODO: this might fail if user loguts/closes the app
            return from(this.persistentStorageService.set('[APP][INPUT_APP_CLIENT_DB]', updatedUserDB)).pipe(
              take(1),
              map(() => [updatedUserDB, updatedBgDB, isInit, isReload] as const),
            );
          }),
        );
      }),
      switchMap(([updatedUserDB, updatedBgDB, isInit, isReload]) => {
        return of(
          new SetUserDBAndClientDBAndReleaseLockAndEmitInitInfo(updatedUserDB, updatedBgDB, {
            isInit: isInit,
            isReload: isReload,
            isDayEnd: !(isInit || isReload),
            userDB: updatedUserDB,
            bgDB: updatedBgDB,
          }),
        );
      }),
      catchError((error) => {
        this.customLoggerService.log('INPUT_APP_INIT_USER_AND_BG_DBS_UNHANDLED_EXCEPTION', {
          error: error?.name + ' - ' + error?.message,
          stack: error?.stack,
        });
        return throwError(() => error);
      }),
    ),
  );

  SetUserDBAndClientDBAndReleaseLockAndEmitInitInfo$ = createEffect(() =>
    this.action$.pipe(
      ofType<SetUserDBAndClientDBAndReleaseLockAndEmitInitInfo>(
        InputAppClientDBActionTypes.SetUserDBAndClientDBAndReleaseLockAndEmitInitInfo,
      ),
      switchMap((action) => {
        this.inputAppClientDBFacade.emitInitUserDBAndBgDBSubscription(action.initInfo);
        return of(new InputAppNoAction());
      }),
    ),
  );

  AcquireUserDBLockAndFetchIncompleteBundles$ = createEffect(() => {
    return this.action$.pipe(
      ofType<AcquireUserDBLockAndFetchIncompleteBundles>(
        InputAppClientDBActionTypes.AcquireUserDBLockAndFetchIncompleteBundles,
      ),
      switchMap((action) => {
        return this.inputAppClientDBFacade.acquireUserDBLock('FETCHING_INCOMPLETE_BUNDLES').pipe(
          take(1),
          map((res) => {
            if (res.status === 'SUCCESS') {
              return new FetchIncompleteBundlesAndReleaseLock(action.chainActions);
            } else {
              this.inputAppAPIHelperUtil.showPopup('Error', res.message);
              return new InputAppNoAction();
            }
          }),
        );
      }),
    );
  });

  FetchIncompleteBundlesAndReleaseLock$ = createEffect(() => {
    return this.action$.pipe(
      ofType<FetchIncompleteBundlesAndReleaseLock>(InputAppClientDBActionTypes.FetchIncompleteBundlesAndReleaseLock),
      switchMap((action) => {
        return this.inputAppClientDBFacade.getStationDetails().pipe(
          take(1),
          map((res) => [action, res] as const),
        );
      }),
      switchMap(([action, stationDetails]) =>
        from(this.persistentStorageService.get('[APP][INPUT_APP_CLIENT_DB]')).pipe(
          map((localStorageDb) => {
            return [action, stationDetails, localStorageDb] as const;
          }),
        ),
      ),
      switchMap(([action, stationDetails, currentDB]) => {
        return this.inputAppDataService
          .getIncompleteBundles({
            app_type: stationDetails.hsk,
            domerole: stationDetails.hsk,
            sub_id: stationDetails.subject,
            subject_key: stationDetails.subjectKey,
            hsk: stationDetails.hsk,
          })
          .pipe(
            take(1),
            switchMap((incompleteBundlesResponse) => {
              currentDB = produce(currentDB, (draft) => {
                if (!draft.persistanceCache.incompleteBundlesInfo[stationDetails.subject]) {
                  draft.persistanceCache.incompleteBundlesInfo[stationDetails.subject] = {
                    [stationDetails.shiftId]: {
                      list: incompleteBundlesResponse.result || [],
                      lastUpdatedAt: new Date().getTime(),
                    },
                  };
                } else {
                  draft.persistanceCache.incompleteBundlesInfo[stationDetails.subject][stationDetails.shiftId] = {
                    list: incompleteBundlesResponse.result || [],
                    lastUpdatedAt: new Date().getTime(),
                  };
                }
              });
              return from(this.persistentStorageService.set('[APP][INPUT_APP_CLIENT_DB]', currentDB)).pipe(
                take(1),
                map(() => {
                  return new UpdateUserDBAndReleaseLockAndSyncStyleInfo(currentDB, action.chainActions);
                }),
              );
            }),
            catchError((error) => {
              this.customLoggerService.log(
                'INPUT APP CLIENT DB EFFECT FetchIncompleteBundlesAndReleaseLock - getIncompleteBundles API call failed',
                JSON.stringify(error),
              );
              return of(new UpdateUserDBAndReleaseLockAndSyncStyleInfo(currentDB, action.chainActions));
            }),
          );
      }),
    );
  });

  UpdateUserDBAndReleaseLockAndSyncStyleInfo$ = createEffect(() => {
    return this.action$.pipe(
      ofType<UpdateUserDBAndReleaseLockAndSyncStyleInfo>(
        InputAppClientDBActionTypes.UpdateUserDBAndReleaseLockAndSyncStyleInfo,
      ),
      map((action) => {
        if (action.chainActions.chainWithBctxSync) {
          const { hideLoader, moreActions, chainActions } = action.chainActions.chainWithBctxSync;
          return new AcquireUserDBLockAndSyncStyleInfo(hideLoader, moreActions, chainActions);
        } else if (action.chainActions.chainWithLineOrShiftChange) {
          return new CheckStationOrShiftChange();
        } else return new InputAppNoAction();
      }),
    );
  });

  AcquireUserDBLockAndSyncStyleInfo$ = createEffect(() => {
    return this.action$.pipe(
      ofType<AcquireUserDBLockAndSyncStyleInfo>(InputAppClientDBActionTypes.AcquireUserDBLockAndSyncStyleInfo),
      switchMap((action) => {
        return this.inputAppClientDBFacade.acquireUserDBLock('BCTX_SYNCING').pipe(
          take(1),
          map((res) => {
            if (res.status === 'SUCCESS') {
              return new SyncStyleInfoAndThenReleaseUserDBLock(
                action.hideLoader,
                action.moreActions,
                action.chainActions,
              );
            } else {
              if (!action.hideLoader)
                this.inputAppAPIHelperUtil.showPopup(this.translate.instant('input_app_common.error'), res.message);
              return new InputAppNoAction();
            }
          }),
        );
      }),
    );
  });

  //This will fetch all bctx and filter out the bctx not present in cache,
  //and then returns filtered bctx
  SyncStyleInfoAndThenReleaseUserDBLock$ = createEffect(() =>
    this.action$.pipe(
      ofType<SyncStyleInfoAndThenReleaseUserDBLock>(InputAppClientDBActionTypes.SyncStyleInfoAndThenReleaseUserDBLock),
      switchMap((action) =>
        this.inputAppClientDBFacade.getBusinessContextDataPayload().pipe(
          take(1),
          map((payload) => {
            return [payload, action] as const;
          }),
        ),
      ),
      switchMap(([payload, action]) => {
        this.metadataFacade.updateSyncingStatus(BCTX_SYNCING_KEY, 'SYNCING');
        if (action.hideLoader) {
          return of([payload, action] as const);
        } else
          return from(
            this.inputAppErrorUtil.presentLoadingWithId(
              'BCTX_SYNCING',
              this.translate.instant('input_app_db_effects.loadingBctx'),
            ),
          ).pipe(
            take(1),
            map(() => {
              return [payload, action] as const;
            }),
          );
      }),
      switchMap(([payload, action]) =>
        this.inputAppDataService.getBusninessContextData(payload).pipe(
          take(1),
          switchMap((businessContextData) => {
            this.metadataFacade.updateSyncingStatus(BCTX_SYNCING_KEY, 'SYNCED');
            if (action.hideLoader) {
              return of(
                new SyncStyleInfoSuccessAndThenReleaseLock(
                  businessContextData,
                  action.moreActions,
                  action.chainActions,
                ),
              );
            } else {
              return from(this.inputAppErrorUtil.dismissLoadingWithId('BCTX_SYNCING')).pipe(
                take(1),
                map(() => {
                  return new SyncStyleInfoSuccessAndThenReleaseLock(
                    businessContextData,
                    action.moreActions,
                    action.chainActions,
                  );
                }),
              );
            }
          }),
          catchError((error) => {
            this.metadataFacade.updateSyncingStatus(BCTX_SYNCING_KEY, 'FAILED');
            this.customLoggerService.log(
              'INPUT APP CLIENT DB EFFECT: SyncStyleInfoAndThenReleaseUserDBLock - getBusninessContextData API Error',
              JSON.stringify(error),
            );
            if (!action.hideLoader)
              return of(
                new ReleaseUserDBLockAndShowPopupAndDismissLoader(
                  this.translate.instant('input_app_db_effects.fetchingBctxListError.header'),
                  this.translate.instant('input_app_db_effects.fetchingBctxListError.message'),
                  'BCTX_SYNCING',
                ),
              );
            else return of(new ReleaseUserDBLock());
          }),
        ),
      ),
    ),
  );

  SyncStyleInfoSuccessAndThenReleaseLock$ = createEffect(() =>
    this.action$.pipe(
      ofType<SyncStyleInfoSuccessAndThenReleaseLock>(
        InputAppClientDBActionTypes.SyncStyleInfoSuccessAndThenReleaseLock,
      ),
      switchMap((action) =>
        this.inputAppClientDBFacade.getSelectedStationIdAndShiftId().pipe(
          take(1),
          map((selectedStationIdAndShiftId) => {
            return [action.businessContextData, selectedStationIdAndShiftId, action] as const;
          }),
        ),
      ),
      switchMap(([businessContextData, selectedStationIdAndShiftId, action]) => {
        return this.inputAppClientDBFacade.getBctxItemsOrderForBackUp().pipe(
          take(1),
          map((bctxKeysOrder) => [businessContextData, selectedStationIdAndShiftId, action, bctxKeysOrder] as const),
        );
      }),
      switchMap(([businessContextData, selectedStationIdAndShiftId, action, bctxKeysOrder]) => {
        return this.inputAppClientDBFacade.getConfigurations().pipe(
          take(1),
          map(
            ({ delayWipUpdatesByMin, aggregatedLineMapForPerPiece }) =>
              [
                businessContextData,
                selectedStationIdAndShiftId,
                action,
                bctxKeysOrder,
                delayWipUpdatesByMin,
                aggregatedLineMapForPerPiece,
              ] as const,
          ),
        );
      }),
      switchMap(
        ([
          businessContextData,
          selectedStationIdAndShiftId,
          action,
          bctxKeysOrder,
          delayWipUpdatesByMin,
          aggregatedLineMapForPerPiece,
        ]) => {
          return from(this.inputAppClientDBFacade.getTodayAndPastDaysMergedEvents()).pipe(
            take(1),
            map((bulkTodayAndPastDaysEventsWithBgStatus) => {
              return [
                businessContextData,
                selectedStationIdAndShiftId,
                action,
                bctxKeysOrder,
                bulkTodayAndPastDaysEventsWithBgStatus,
                delayWipUpdatesByMin,
                aggregatedLineMapForPerPiece,
              ] as const;
            }),
          );
        },
      ),
      switchMap(
        ([
          businessContextData,
          selectedStationIdAndShiftId,
          action,
          bctxKeysOrder,
          bulkTodayAndPastDaysEventsWithBgStatus,
          delayWipUpdatesByMin,
          aggregatedLineMapForPerPiece,
        ]) =>
          this.inputAppClientDBFacade.getIsSingleLineMapForLineInEnabledAndAppIdentifier().pipe(
            take(1),
            map(({ isSingleLineMapForLineInEnabled: evictOtherStations, appIdentifier: app_identifier }) => {
              return [
                businessContextData,
                selectedStationIdAndShiftId,
                action,
                bctxKeysOrder,
                bulkTodayAndPastDaysEventsWithBgStatus,
                delayWipUpdatesByMin,
                aggregatedLineMapForPerPiece,
                evictOtherStations,
                app_identifier,
              ] as const;
            }),
          ),
      ),
      switchMap(
        ([
          businessContextData,
          selectedStationIdAndShiftId,
          action,
          bctxKeysOrder,
          bulkTodayAndPastDaysEventsWithBgStatus,
          delayWipUpdatesByMin,
          aggregatedLineMapForPerPiece,
          evictOtherStations,
          app_identifier,
        ]) =>
          from(this.persistentStorageService.get('[APP][INPUT_APP_CLIENT_DB]')).pipe(
            map((currentDB) => {
              // PBI-3272: a station kept in the line map uses its own selection; an evicted one falls
              // back to what it had before, so the operator does not re-pick on every switch.
              const evictedSelectedBctxInfo = evictOtherStations
                ? currentDB.dailyCache.stationToSelectedBctxInfo?.[selectedStationIdAndShiftId.stationId]
                : undefined;
              const selectedBctxInfoForBuild = currentDB.dailyCache.lineMap[selectedStationIdAndShiftId.stationId]
                ? currentDB.dailyCache.lineMap[selectedStationIdAndShiftId.stationId].selectedBctxInfo
                : evictedSelectedBctxInfo ?? DEFAULT_SELECTED_BCTX_INFO;
              const lineMapItem = BCTXComputationHelper.createInitialLineMapItem(
                businessContextData,
                selectedStationIdAndShiftId.shiftId,
                bctxKeysOrder,
                selectedBctxInfoForBuild,
                action.moreActions.discardWipUpdates,
                bulkTodayAndPastDaysEventsWithBgStatus,
                delayWipUpdatesByMin,
              );
              // A bctx sync rebuilds bctxWipMap but carries the selection over, so a bctx completed
              // since it was chosen leaves the key dangling - getFilteredSizesListForSelectedBctx then
              // throws. Clear it and let the operator pick again. DEFAULT_BCTX_KEY means none selected.
              const selectedBctxKey = selectedBctxInfoForBuild.bctxInfoWithoutSize.bctxKey;
              if (selectedBctxKey !== DEFAULT_BCTX_KEY && !lineMapItem.bctxWipMap[selectedBctxKey]) {
                lineMapItem.selectedBctxInfo = DEFAULT_SELECTED_BCTX_INFO;
              }
              const bctxMinMaxDateTime: TBctxMinMaxDateTime =
                BCTXComputationHelper.getBctxMinMaxDateTime(businessContextData);
              const bctxWithMultipleSizeList: TBctxWithMultipleSize[] =
                BCTXComputationHelper.getFilteredBctxWithMultipleSizeList(
                  selectedStationIdAndShiftId,
                  currentDB.dailyCache,
                  lineMapItem,
                );
              let updatedDailyCache = currentDB.dailyCache;
              if (aggregatedLineMapForPerPiece && BCTXComputationHelper.isPerPieceApp(app_identifier)) {
                updatedDailyCache = PerPieceComputationHelper.getMergedProductTypeStyleDBOnBctxLoad(
                  currentDB.dailyCache,
                  selectedStationIdAndShiftId,
                  lineMapItem,
                );
              } else {
                updatedDailyCache = BCTXComputationHelper.getMergedDBOnBctxLoad(
                  currentDB.dailyCache,
                  selectedStationIdAndShiftId,
                  lineMapItem,
                  BCTXComputationHelper.getBctxWithMultipleSizeList(lineMapItem),
                  bctxKeysOrder,
                  bulkTodayAndPastDaysEventsWithBgStatus,
                  delayWipUpdatesByMin,
                );
              }
              currentDB = produce(currentDB, (draft) => {
                draft.dailyCache = updatedDailyCache;
              });
              currentDB = produce(currentDB, (draft) => {
                draft.dailyCache.lastStyleSyncInfoTimestamp = new Date().getTime();
                draft.dailyCache.bctxMinMaxDateTime = bctxMinMaxDateTime;
                // PBI-3272: keep only the station in use, so the stored DB stays one line's worth of
                // bctx. Safe here and nowhere earlier - pending events are already synced by this point,
                // so everything dropped is on the server and returns via bctx fetch + restore.
                // Retaining more would need an LRU list
                if (evictOtherStations && selectedStationIdAndShiftId.stationId) {
                  const { stationId } = selectedStationIdAndShiftId;
                  for (const id of Object.keys(draft.dailyCache.lineMap)) {
                    if (id !== stationId) {
                      if (!draft.dailyCache.stationToSelectedBctxInfo) draft.dailyCache.stationToSelectedBctxInfo = {};
                      draft.dailyCache.stationToSelectedBctxInfo[id] = draft.dailyCache.lineMap[id].selectedBctxInfo;
                      delete draft.dailyCache.lineMap[id];
                    }
                  }
                }
              });
              return [currentDB, bctxWithMultipleSizeList, action] as const;
            }),
          ),
      ),
      switchMap(([currentDB, bctxWithMultipleSizeList, action]) =>
        from(this.persistentStorageService.set('[APP][INPUT_APP_CLIENT_DB]', currentDB)).pipe(
          map(() => {
            if (action.chainActions && action.chainActions.chainWithRestoreActualsForNewStyles) {
              if (bctxWithMultipleSizeList.length === 0) {
                return new SetUserDBAndReleaseLock(currentDB);
              } else
                return new UpdateUserDBAndThenReleaseLockAndThenRestoreActualsForNewStyles(
                  currentDB,
                  bctxWithMultipleSizeList,
                );
            } else if (
              action.chainActions &&
              action.chainActions.chainWithRestoreBackedUpBctxAndThenLoadMasterdataList
            ) {
              return new UpdateUserDBAndThenReleaseLockAndThenRestoreActualsForBackedUpBctx(
                currentDB,
                action.chainActions.chainWithRestoreBackedUpBctxAndThenLoadMasterdataList,
              );
            } else if (action.chainActions && action.chainActions.chainWithLoadMasterdataLists) {
              return new SetUserDBAndReleaseLockAndThenLoadMasterdataLists(currentDB, { source: 'UNKNOWN' });
            } else if (action.chainActions && action.chainActions.chainWithBctxChangeEvent) {
              return new SetUserDBAndReleaseLockAndThenEmitBctxChangeEvent(currentDB);
            } else return new SetUserDBAndReleaseLock(currentDB);
          }),
        ),
      ),
    ),
  );

  UpdateUserDBAndThenReleaseLockAndThenRestoreActualsForBackedUpBctx$ = createEffect(() =>
    this.action$.pipe(
      ofType<UpdateUserDBAndThenReleaseLockAndThenRestoreActualsForBackedUpBctx>(
        InputAppClientDBActionTypes.UpdateUserDBAndThenReleaseLockAndThenRestoreActualsForBackedUpBctx,
      ),
      switchMap((action) => {
        return of(new AcquireUserDBLockAndThenRestoreActualsForBackedUpBctx(action.restoreBackedUpBctxDto));
      }),
    ),
  );

  AcquireUserDBLockAndThenRestoreActualsForBackedUpBctx$ = createEffect(() => {
    return this.action$.pipe(
      ofType<AcquireUserDBLockAndThenRestoreActualsForBackedUpBctx>(
        InputAppClientDBActionTypes.AcquireUserDBLockAndThenRestoreActualsForBackedUpBctx,
      ),
      switchMap((action) => {
        return this.inputAppClientDBFacade.acquireUserDBLock('RESTORE_ACTUALS_AND_WIP').pipe(
          take(1),
          map((res) => {
            if (res.status === 'SUCCESS') {
              return new RestoreAppStateForBackedUpBctxAndThenReleaseUserDBLock(action.dto);
            } else {
              this.inputAppAPIHelperUtil.showPopup(this.translate.instant('input_app_common.error'), res.message);
              return new InputAppNoAction();
            }
          }),
        );
      }),
    );
  });

  RestoreAppStateForBackedUpBctxAndThenReleaseUserDBLock$ = createEffect(() =>
    this.action$.pipe(
      ofType<RestoreAppStateForBackedUpBctxAndThenReleaseUserDBLock>(
        InputAppClientDBActionTypes.RestoreAppStateForBackedUpBctxAndThenReleaseUserDBLock,
      ),
      switchMap((action) =>
        from(
          this.inputAppErrorUtil.presentLoadingWithId(
            'RESTORING_FOR_BACKED_UP_BCTX',
            this.translate.instant('input_app_db_effects.restoringAppState'),
          ),
        ).pipe(
          take(1),
          map(() => {
            return action;
          }),
        ),
      ),
      switchMap((action) => {
        return from(this.inputAppClientDBFacade.getRestorePayloadForBackedUpBctx()).pipe(
          take(1),
          map((payload) => {
            return [payload, action] as const;
          }),
        );
      }),
      switchMap(([payload, action]) =>
        this.inputAppDataService.restoreAppStoreForBackedUpBctx(payload).pipe(
          switchMap((appStateResponse) =>
            from(this.inputAppErrorUtil.dismissLoadingWithId('RESTORING_FOR_BACKED_UP_BCTX')).pipe(
              take(1),
              map(() => {
                return new RestoreAppStateSuccessForBackedUpBctxAndThenReleaseUserDBLock(appStateResponse, action.dto);
              }),
            ),
          ),
          catchError((error) => {
            this.customLoggerService.log(
              'INPUT APP CLIENT DB EFFECT: RestoreAppStateForBackedUpBctxAndThenReleaseUserDBLock -  restoreAppStoreForBackedUpBctx API Error',
              JSON.stringify(error),
            );
            return of(
              new ReleaseUserDBLockAndShowPopupAndDismissLoader(
                this.translate.instant('input_app_db_effects.restoringActualsError.header'),
                this.translate.instant('input_app_db_effects.restoringActualsError.message'),
                'RESTORING_FOR_BACKED_UP_BCTX',
              ),
            );
          }),
        ),
      ),
    ),
  );

  RestoreAppStateSuccessForBackedUpBctxAndThenReleaseUserDBLock$ = createEffect(() =>
    this.action$.pipe(
      ofType<RestoreAppStateSuccessForBackedUpBctxAndThenReleaseUserDBLock>(
        InputAppClientDBActionTypes.RestoreAppStateSuccessForBackedUpBctxAndThenReleaseUserDBLock,
      ),
      switchMap((action) =>
        this.inputAppClientDBFacade.getSelectedStationIdAndShiftId().pipe(
          take(1),
          map((selectedStationAndShiftId) => {
            return [action, selectedStationAndShiftId] as const;
          }),
        ),
      ),
      switchMap(([action, selectedStationAndShiftId]) =>
        this.inputAppClientDBFacade.getBctxItemsOrderForBackUp().pipe(
          take(1),
          map((res) => {
            return [action, selectedStationAndShiftId, res] as const;
          }),
        ),
      ),
      switchMap(([action, selectedStationAndShiftId, res]) => {
        return this.inputAppClientDBFacade.getConfigurations().pipe(
          take(1),
          map(
            ({ aggregatedLineMapForPerPiece, isPendingWipBasedOnActuals, enableTabDataCapture }) =>
              [
                action,
                selectedStationAndShiftId,
                res,
                aggregatedLineMapForPerPiece,
                isPendingWipBasedOnActuals,
                enableTabDataCapture,
              ] as const,
          ),
        );
      }),
      switchMap(
        ([
          action,
          selectedStationAndShiftId,
          res,
          aggregatedLineMapForPerPiece,
          isPendingWipBasedOnActuals,
          enableTabDataCapture,
        ]) =>
          this.inputAppClientDBFacade.getAppIdentifier().pipe(
            take(1),
            map((app_identifier) => {
              return [
                action,
                selectedStationAndShiftId,
                res,
                aggregatedLineMapForPerPiece,
                app_identifier,
                isPendingWipBasedOnActuals,
                enableTabDataCapture,
              ] as const;
            }),
          ),
      ),
      switchMap(
        ([
          action,
          selectedStationAndShiftId,
          orderKeys,
          aggregatedLineMapForPerPiece,
          app_identifier,
          isPendingWipBasedOnActuals,
          enableTabDataCapture,
        ]) =>
          from(this.persistentStorageService.get('[APP][INPUT_APP_CLIENT_DB]')).pipe(
            map((currentDB) => {
              let updatedDailyCache = currentDB.dailyCache;
              const oldShiftMap = currentDB.dailyCache.lineMap[selectedStationAndShiftId.stationId]
                ? cloneDeep(currentDB.dailyCache.lineMap[selectedStationAndShiftId.stationId].shiftMap)
                : {};
              if (aggregatedLineMapForPerPiece && BCTXComputationHelper.isPerPieceApp(app_identifier)) {
                updatedDailyCache = PerPieceComputationHelper.getMergedDBOnRestoreForBackedUpBctxPerPiece(
                  selectedStationAndShiftId,
                  currentDB.dailyCache,
                  action.appStateResponse,
                );
              } else {
                updatedDailyCache = BCTXComputationHelper.getMergedDBOnRestoreForBackedUpBctx(
                  action.dto,
                  orderKeys,
                  selectedStationAndShiftId,
                  currentDB.dailyCache,
                  action.appStateResponse,
                  isPendingWipBasedOnActuals,
                  app_identifier,
                );
              }
              currentDB = produce(currentDB, (draft) => {
                draft.dailyCache = updatedDailyCache;
              });
              if (enableTabDataCapture) {
                this.customLoggerService.sendDirectLogsToBackend('RESTORE_DATA_MONITOR', {
                  oldShiftMap,
                  newShiftMap: updatedDailyCache.lineMap[selectedStationAndShiftId.stationId]
                    ? updatedDailyCache.lineMap[selectedStationAndShiftId.stationId].shiftMap
                    : {},
                  response: action.appStateResponse,
                });
              }
              return [action, currentDB] as const;
            }),
          ),
      ),
      switchMap(([action, currentDB]) =>
        from(this.persistentStorageService.set('[APP][INPUT_APP_CLIENT_DB]', currentDB)).pipe(
          map(() => {
            console.log('[APP][INPUT_APP_CLIENT_DB] updated, Action is:', ['RestoreAppStateSuccess']);
            return [action, currentDB] as const;
          }),
        ),
      ),
      switchMap(([action, currentDB]) => {
        if (action.dto.chainWithLoadMasterdataList) {
          return of(new SetUserDBAndReleaseLockAndThenLoadMasterdataLists(currentDB, { source: 'UNKNOWN' }));
        } else return of(new SetUserDBAndReleaseLock(currentDB));
      }),
    ),
  );

  SetUserDBAndReleaseLockAndThenLoadMasterdataLists$ = createEffect(() =>
    this.action$.pipe(
      ofType<SetUserDBAndReleaseLockAndThenLoadMasterdataLists>(
        InputAppClientDBActionTypes.SetUserDBAndReleaseLockAndThenLoadMasterdataLists,
      ),
      switchMap((action) => {
        this.inputAppClientDBFacade.emitLoadAllMasterdataLists(action.masterDataListMetaData);
        return of(new InputAppNoAction());
      }),
    ),
  );
  SetUserDBAndReleaseLockAndThenEmitBctxChangeEvent$ = createEffect(() =>
    this.action$.pipe(
      ofType<SetUserDBAndReleaseLockAndThenEmitBctxChangeEvent>(
        InputAppClientDBActionTypes.SetUserDBAndReleaseLockAndThenEmitBctxChangeEvent,
      ),
      switchMap((action) => {
        this.inputAppClientDBFacade.emitTriggerBctxChangeEvent();
        return of(new InputAppNoAction());
      }),
    ),
  );

  UpdateClientDBAndThenReleaseLockAndThenRestoreActualsForNewStyles$ = createEffect(() =>
    this.action$.pipe(
      ofType<UpdateUserDBAndThenReleaseLockAndThenRestoreActualsForNewStyles>(
        InputAppClientDBActionTypes.UpdateUserDBAndThenReleaseLockAndThenRestoreActualsForNewStyles,
      ),
      switchMap((action) => {
        return of(new AcquireLockAndThenRestoreActuals(action.bctxWithMultipleSizeList, false));
      }),
    ),
  );

  AcquireLockAndThenRestoreActuals$ = createEffect(() => {
    return this.action$.pipe(
      ofType<AcquireLockAndThenRestoreActuals>(InputAppClientDBActionTypes.AcquireLockAndThenRestoreActuals),
      switchMap((action) => {
        return this.inputAppClientDBFacade.acquireUserDBLock('RESTORE_ACTUALS_AND_WIP').pipe(
          take(1),
          map((res) => {
            if (res.status === 'SUCCESS') {
              return new RestoreAppStateAndThenReleaseLock(action.bctxWithMultipleSizeList, action.wip_only);
            } else {
              this.inputAppAPIHelperUtil.showPopup(this.translate.instant('input_app_common.error'), res.message);
              return new InputAppNoAction();
            }
          }),
        );
      }),
    );
  });

  RestoreAppStateAndThenReleaseLock$ = createEffect(() =>
    this.action$.pipe(
      ofType<RestoreAppStateAndThenReleaseLock>(InputAppClientDBActionTypes.RestoreAppStateAndThenReleaseLock),
      switchMap((action) =>
        from(
          this.inputAppErrorUtil.presentLoadingWithId(
            'ONLINE_RESTORE_WIP_AND_ACTUALS',
            this.translate.instant('input_app_db_effects.restoringAppState'),
          ),
        ).pipe(
          take(1),
          map(() => {
            return action;
          }),
        ),
      ),
      switchMap((action) =>
        this.inputAppClientDBFacade.getBctxItemsOrderWithoutSize().pipe(
          take(1),
          map((res) => {
            return [action, res] as const;
          }),
        ),
      ),
      switchMap(([action, orderKeys]) => {
        return from(this.inputAppClientDBFacade.getRestorePayload()).pipe(
          take(1),
          map((payload) => {
            return [
              {
                ...payload,
                bctx_items: action.bctxWithMultipleSizeList.map((bctxWithSizeList) => {
                  const orderedBctx = BCTXComputationHelper.getOrderedBctx(
                    bctxWithSizeList.preSizeLevelBctx,
                    orderKeys,
                  );
                  return produce(bctxWithSizeList, (draft) => {
                    draft.preSizeLevelBctx = orderedBctx;
                  });
                }),
              },
              action,
            ] as const;
          }),
        );
      }),
      switchMap(([payload, action]) =>
        this.inputAppDataService.restoreAppStore(payload).pipe(
          switchMap((appStateResponse) =>
            from(this.inputAppErrorUtil.dismissLoadingWithId('ONLINE_RESTORE_WIP_AND_ACTUALS')).pipe(
              take(1),
              map(() => {
                return new RestoreAppStateSuccessAndThenReleaseLock(
                  appStateResponse,
                  action.wip_only,
                  payload.bctx_items,
                );
              }),
            ),
          ),
          catchError((error) => {
            this.customLoggerService.log(
              'INPUT APP CLIENT DB EFFECT: RestoreAppStateAndThenReleaseLock -  restoreAppStore API Error',
              JSON.stringify(error),
            );
            return of(
              new ReleaseUserDBLockAndShowPopupAndDismissLoader(
                this.translate.instant('input_app_db_effects.restoringActualsError.header'),
                this.translate.instant('input_app_db_effects.restoringActualsError.message'),
                'ONLINE_RESTORE_WIP_AND_ACTUALS',
              ),
            );
          }),
        ),
      ),
    ),
  );

  RestoreAppStateSuccessAndThenReleaseLock$ = createEffect(() =>
    this.action$.pipe(
      ofType<RestoreAppStateSuccessAndThenReleaseLock>(
        InputAppClientDBActionTypes.RestoreAppStateSuccessAndThenReleaseLock,
      ),
      switchMap((action) =>
        this.inputAppClientDBFacade.getSelectedStationIdAndShiftId().pipe(
          take(1),
          map((selectedStationAndShiftId) => {
            return [action, selectedStationAndShiftId] as const;
          }),
        ),
      ),
      switchMap(([action, selectedStationAndShiftId]) =>
        this.inputAppClientDBFacade.getBctxItemsOrderWithoutSize().pipe(
          take(1),
          map((res) => {
            return [action, selectedStationAndShiftId, res] as const;
          }),
        ),
      ),
      switchMap(([action, selectedStationAndShiftId, orderKeys]) =>
        from(this.persistentStorageService.get('[APP][INPUT_APP_CLIENT_DB]')).pipe(
          map((currentDB) => {
            const updatedDailyCache = BCTXComputationHelper.getMergedDBOnRestore(
              orderKeys,
              action.wip_only,
              selectedStationAndShiftId,
              currentDB.dailyCache,
              action.appStateResponse,
            );
            currentDB = produce(currentDB, (draft) => {
              draft.dailyCache = updatedDailyCache;
            });
            return [action, currentDB] as const;
          }),
        ),
      ),
      switchMap(([action, currentDB]) =>
        from(this.persistentStorageService.set('[APP][INPUT_APP_CLIENT_DB]', currentDB)).pipe(
          map(() => {
            console.log('[APP][INPUT_APP_CLIENT_DB] updated, Action is:', ['RestoreAppStateSuccess']);
            return [action, currentDB] as const;
          }),
        ),
      ),
      switchMap(([action, currentDB]) => {
        if (action.wip_only) return of(new SetUserDBAndReleaseLock(currentDB, true));
        else {
          return of(
            new SetClientDBAndReleaseLockAndThenRestoreToBeRectifiedCounts(currentDB, action.bctxWithMultipleSizeList),
          );
        }
      }),
    ),
  );

  SetClientDBAndReleaseLock$ = createEffect(() => {
    return this.action$.pipe(
      ofType<SetUserDBAndReleaseLock>(InputAppClientDBActionTypes.SetUserDBAndReleaseLock),
      switchMap((action) => {
        if (action.closeModal) {
          return from(this.modalCtrl.dismiss()).pipe(
            take(1),
            map(() => new InputAppNoAction()),
          );
        } else return of(new InputAppNoAction());
      }),
    );
  });

  SetClientDBAndReleaseLockAndThenRestoreToBeRectifiedCounts$ = createEffect(() => {
    return this.action$.pipe(
      ofType<SetClientDBAndReleaseLockAndThenRestoreToBeRectifiedCounts>(
        InputAppClientDBActionTypes.SetClientDBAndReleaseLockAndThenRestoreToBeRectifiedCounts,
      ),
      switchMap((action) => {
        return of(new AcquireLockAndRestoreToBeRectifiedCounts(action.bctxWithMultipleSizeList));
      }),
    );
  });

  AcquireLockAndRestoreToBeRectifiedCounts$ = createEffect(() => {
    return this.action$.pipe(
      ofType<AcquireLockAndRestoreToBeRectifiedCounts>(
        InputAppClientDBActionTypes.AcquireLockAndRestoreToBeRectifiedCounts,
      ),
      switchMap((action) => {
        return this.inputAppClientDBFacade.acquireUserDBLock('RESTORE_TO_BE_RECTIFIED_COUNTS').pipe(
          take(1),
          map((res) => {
            if (res.status === 'SUCCESS') {
              return new RestoreToBeRectifiedCountsAndThenReleaseLock(action.bctxWithMultipleSizeList);
            } else {
              this.inputAppAPIHelperUtil.showPopup(this.translate.instant('input_app_common.error'), res.message);
              return new InputAppNoAction();
            }
          }),
        );
      }),
    );
  });

  RestoreToBeRectifiedCountsAndThenReleaseLock$ = createEffect(() =>
    this.action$.pipe(
      ofType<RestoreToBeRectifiedCountsAndThenReleaseLock>(
        InputAppClientDBActionTypes.RestoreToBeRectifiedCountsAndThenReleaseLock,
      ),
      switchMap((action) =>
        from(
          this.inputAppErrorUtil.presentLoadingWithId(
            'ONLINE_RESTORE_TO_BE_RECTIFIED_COUNTS',
            this.translate.instant('input_app_db_effects.fetchingToBeRectifiedCounts'),
          ),
        ).pipe(
          take(1),
          map(() => {
            return action;
          }),
        ),
      ),
      switchMap((action) => {
        return this.inputAppClientDBFacade.getStationDetails().pipe(
          take(1),
          map((stationDetails) => {
            return [{ stationDetails, bctxItems: action.bctxWithMultipleSizeList }] as const;
          }),
        );
      }),
      switchMap(([payload]) =>
        this.inputAppDataService.restoreToBeRectifiedCounts(payload).pipe(
          switchMap((res) =>
            from(this.inputAppErrorUtil.dismissLoadingWithId('ONLINE_RESTORE_TO_BE_RECTIFIED_COUNTS')).pipe(
              take(1),
              map(() => {
                return new RestoreToBeRectifiedCountsSuccessAndThenReleaseLock(res, payload.stationDetails);
              }),
            ),
          ),
          catchError((error) => {
            this.customLoggerService.log(
              'INPUT APP CLIENT DB EFFECT: RestoreToBeRectifiedCountsAndThenReleaseLock -  restoreToBeRectifiedCounts API Error',
              JSON.stringify(error),
            );
            return of(
              new ReleaseUserDBLockAndShowPopupAndDismissLoader(
                this.translate.instant('input_app_db_effects.restoringToBeRectifiedCountError.header'),
                this.translate.instant('input_app_db_effects.restoringToBeRectifiedCountError.message'),
                'ONLINE_RESTORE_TO_BE_RECTIFIED_COUNTS',
              ),
            );
          }),
        ),
      ),
    ),
  );

  RestoreToBeRectifiedCountsSuccessAndThenReleaseLock$ = createEffect(() =>
    this.action$.pipe(
      ofType<RestoreToBeRectifiedCountsSuccessAndThenReleaseLock>(
        InputAppClientDBActionTypes.RestoreToBeRectifiedCountsSuccessAndThenReleaseLock,
      ),
      switchMap((action) =>
        from(
          this.inputAppErrorUtil.presentLoadingWithId(
            'ONLINE_RESTORE_TO_BE_RECTIFIED_COUNTS_SUCCESS',
            this.translate.instant('input_app_db_effects.syncingToBeRectifiedCounts'),
          ),
        ).pipe(
          take(1),
          map(() => {
            return action;
          }),
        ),
      ),
      switchMap((action) =>
        this.inputAppClientDBFacade.getBctxItemsOrderWithoutSize().pipe(
          take(1),
          map((res) => {
            return [action, res] as const;
          }),
        ),
      ),
      switchMap(([action, orderKeys]) =>
        from(this.persistentStorageService.get('[APP][INPUT_APP_CLIENT_DB]')).pipe(
          map((currentDB) => {
            action.response.bctxItems.forEach((bctxItem) => {
              const orderedBctx = BCTXComputationHelper.getOrderedBctx(bctxItem.preSizeLevelBctx, orderKeys);
              Object.keys(bctxItem.sizeToCountMap).forEach((size) => {
                const updatedLineMap = BCTXComputationHelper.backFillBctxInUserLineMap(
                  {
                    bctxKey: BCTXComputationHelper.getUniqueBctxKeyWithOrder(orderKeys, orderedBctx),
                    businessContextDetailsWithoutSize: orderedBctx,
                    size: size,
                    count: 0,
                  },
                  currentDB.dailyCache.lineMap,
                  action.stationDetails.subject,
                  action.stationDetails.shiftId,
                  BCTXComputationHelper.getUniqueBctxKeyWithOrder(orderKeys, orderedBctx),
                );
                currentDB = produce(currentDB, (draft) => {
                  draft.dailyCache.lineMap = updatedLineMap;
                });
              });
            });
            const updatedClientBctx = BCTXComputationHelper.getRestoredClientBctxWithToBeRectifiedCounts(
              orderKeys,
              currentDB.dailyCache.lineMap[action.stationDetails.subject].shiftMap[action.stationDetails.shiftId]
                .clientBctx,
              action.response.bctxItems,
            );
            currentDB = produce(currentDB, (draft) => {
              draft.dailyCache.lineMap[action.stationDetails.subject].shiftMap[
                action.stationDetails.shiftId
              ].clientBctx = updatedClientBctx;
            });
            return currentDB;
          }),
        ),
      ),
      switchMap((currentDB) =>
        from(this.persistentStorageService.set('[APP][INPUT_APP_CLIENT_DB]', currentDB)).pipe(
          switchMap(() => {
            return from(
              this.inputAppErrorUtil.dismissLoadingWithId('ONLINE_RESTORE_TO_BE_RECTIFIED_COUNTS_SUCCESS'),
            ).pipe(
              take(1),
              map(() => new SetUserDBAndReleaseLock(currentDB)),
            );
          }),
        ),
      ),
    ),
  );

  AcquireUserDBLockAndLoadToBeRectifiedData$ = createEffect(() => {
    return this.action$.pipe(
      ofType<AcquireUserDBLockAndLoadToBeRectifiedData>(
        InputAppClientDBActionTypes.AcquireUserDBLockAndLoadToBeRectifiedData,
      ),
      switchMap((action) => {
        return this.inputAppClientDBFacade.acquireUserDBLock('LOAD_DEFECT_LIST_MD_POINT').pipe(
          take(1),
          map((res) => {
            if (res.status === 'SUCCESS') {
              return new LoadToBeRectifiedDataAndReleaseLock(action.filters, action.paginationInfo);
            } else {
              this.inputAppAPIHelperUtil.showPopup(this.translate.instant('input_app_common.error'), res.message);
              return new InputAppNoAction();
            }
          }),
        );
      }),
    );
  });

  LoadToBeRectifiedDataAndReleaseLock$ = createEffect(() =>
    this.action$.pipe(
      ofType<LoadToBeRectifiedDataAndReleaseLock>(InputAppClientDBActionTypes.LoadToBeRectifiedDataAndReleaseLock),
      switchMap((action) =>
        from(
          this.inputAppErrorUtil.presentLoadingWithId(
            'LOAD_TO_BE_RECTIFIED_DATA',
            this.translate.instant('input_app_db_effects.loadingDefectsList'),
          ),
        ).pipe(
          take(1),
          map(() => {
            return action;
          }),
        ),
      ),
      switchMap((action) =>
        this.inputAppClientDBFacade.getStationDetailsAndSelectedBctxItem().pipe(
          take(1),
          map(({ stationDetails, selectedBctxItem }) => {
            return {
              stationDetails,
              selectedBctxItem:
                selectedBctxItem.bctxInfoWithoutSize.list.length === 0
                  ? undefined
                  : selectedBctxItem.bctxInfoWithoutSize.list.reduce((acc, curr) => {
                      acc[curr.k] = curr.v;
                      return acc;
                    }, {} as Record<TBCTXKeysWithoutSize, string>),
              filters: action.filters,
              ...action.paginationInfo,
            };
          }),
        ),
      ),
      switchMap((payload) =>
        this.inputAppDataService.getToBeRectifiedData(payload).pipe(
          map((res) => new UpdateToBeRectifiedDataAndReleaseLockAndThenDismissLoader(res)),
          catchError((error) => {
            this.customLoggerService.log(
              'INPUT APP CLIENT DB EFFECT: LoadToBeRectifiedDataAndReleaseLock - getToBeRectifiedData API Error',
              JSON.stringify(error),
            );
            return from(
              this.inputAppAPIHelperUtil.showPopup(
                this.translate.instant('input_app_db_effects.fetchingToBeRectifiedListError.header'),
                this.translate.instant('input_app_db_effects.fetchingToBeRectifiedListError.message'),
              ),
            ).pipe(
              take(1),
              map(() => {
                this.inputAppErrorUtil.dismissLoadingWithId('LOAD_TO_BE_RECTIFIED_DATA');
                return new ReleaseUserDBLock();
              }),
            );
          }),
        ),
      ),
    ),
  );

  UpdateToBeRectifiedDataAndReleaseLockAndThenDismissLoader$ = createEffect(() =>
    this.action$.pipe(
      ofType<UpdateToBeRectifiedDataAndReleaseLockAndThenDismissLoader>(
        InputAppClientDBActionTypes.UpdateToBeRectifiedDataAndReleaseLockAndThenDismissLoader,
      ),
      switchMap(() =>
        from(this.inputAppErrorUtil.dismissLoadingWithId('LOAD_TO_BE_RECTIFIED_DATA')).pipe(
          map(() => new InputAppNoAction()),
        ),
      ),
    ),
  );

  AcquireUserDBLockAndClearToBeRectifiedList$ = createEffect(() => {
    return this.action$.pipe(
      ofType<AcquireUserDBLockAndClearToBeRectifiedList>(
        InputAppClientDBActionTypes.AcquireUserDBLockAndClearToBeRectifiedList,
      ),
      switchMap((action) => {
        return this.inputAppClientDBFacade.acquireUserDBLock('CLEAR_DEFECT_LIST_MD_POINT').pipe(
          take(1),
          map((res) => {
            if (res.status === 'SUCCESS') {
              return new ClearToBeRectifiedListingAndReleaseLockAndThenDismissModal();
            } else {
              this.inputAppAPIHelperUtil.showPopup(this.translate.instant('input_app_common.error'), res.message);
              return new InputAppNoAction();
            }
          }),
        );
      }),
    );
  });

  ClearToBeRectifiedListingAndDismissModal$ = createEffect(() =>
    this.action$.pipe(
      ofType<ClearToBeRectifiedListingAndReleaseLockAndThenDismissModal>(
        InputAppClientDBActionTypes.ClearToBeRectifiedListingAndReleaseLockAndThenDismissModal,
      ),
      switchMap(() =>
        from(this.modalCtrl.dismiss()).pipe(
          take(1),
          map(() => new InputAppNoAction()),
        ),
      ),
    ),
  );

  AcquireLockAndClearSelectedBctxAndReleaseLock$ = createEffect(() =>
    this.action$.pipe(
      ofType<AcquireLockAndClearSelectedBctxAndReleaseLock>(
        InputAppClientDBActionTypes.AcquireLockAndClearSelectedBctxAndReleaseLock,
      ),
      switchMap((res) => {
        return this.inputAppClientDBFacade.acquireUserDBLock('EVENT_ADDITION').pipe(
          take(1),
          switchMap((lockRes) => {
            if (lockRes.status === 'SUCCESS') {
              return from(
                this.inputAppClientDBFacade.updateSelectedBctxOfLocalDBForCurrentStation(DEFAULT_SELECTED_BCTX_INFO),
              ).pipe(
                take(1),
                map((updatedDB) => new SetUserDBAndReleaseLock(updatedDB)),
              );
            } else {
              this.inputAppAPIHelperUtil.showPopup(this.translate.instant('input_app_common.error'), lockRes.message);
              return of(new InputAppNoAction());
            }
          }),
        );
      }),
    ),
  );

  AcquireLockAndNotifyBctxChangeAndDismissModalAndReleaseLock$ = createEffect(() =>
    this.action$.pipe(
      ofType<AcquireLockAndNotifyBctxChangeAndDismissModalAndReleaseLock>(
        InputAppClientDBActionTypes.AcquireLockAndNotifyBctxChangeAndDismissModalAndReleaseLock,
      ),
      switchMap((res) => {
        return this.inputAppClientDBFacade.acquireUserDBLock('EVENT_ADDITION').pipe(
          take(1),
          map((lockRes) => {
            if (lockRes.status === 'SUCCESS') {
              return new NotifyBctxChangeAndReleaseLockAndThenDismissModal(res.payload, res.dismissModal);
            } else {
              this.inputAppAPIHelperUtil.showPopup(this.translate.instant('input_app_common.error'), lockRes.message);
              return new InputAppNoAction();
            }
          }),
        );
      }),
    ),
  );

  NotifyBctxChangeAndReleaseLockAndThenDismissModal$ = createEffect(() =>
    this.action$.pipe(
      ofType<NotifyBctxChangeAndReleaseLockAndThenDismissModal>(
        InputAppClientDBActionTypes.NotifyBctxChangeAndReleaseLockAndThenDismissModal,
      ),
      switchMap((action) => {
        return from(
          this.inputAppErrorUtil.presentLoadingWithId(
            'NOTIFY_BCTX_CHANGE',
            this.translate.instant('input_app_db_effects.changingWorkingItem'),
          ),
        ).pipe(
          take(1),
          map(() => action),
        );
      }),
      switchMap((action) =>
        this.inputAppClientDBFacade.getselectedBctxItem().pipe(
          take(1),
          map((currentBctx) => {
            return [action, currentBctx] as const;
          }),
        ),
      ),
      switchMap(([action, currentBctx]) =>
        from(this.inputAppClientDBFacade.updateSelectedBctxOfLocalDBForCurrentStation(action.payload)).pipe(
          take(1),
          map(() => [action, currentBctx] as const),
        ),
      ),
      switchMap(([action, currentBctx]) =>
        this.inputAppClientDBFacade.getSelectedStationIdAndShiftId().pipe(
          take(1),
          map((selectedStationAndShiftId) => {
            return [action, currentBctx, selectedStationAndShiftId.stationId] as const;
          }),
        ),
      ),
      switchMap(([action, currentBctx, stationId]) => {
        return this.inputAppClientDBFacade
          .getBctxChangeBulkEvent(
            new Date().getTime(),
            action.payload.bctxInfoWithoutSize.list,
            currentBctx.bctxInfoWithoutSize.list,
            {},
          )
          .pipe(
            take(1),
            map((bulkEvent) => {
              return [bulkEvent, action, stationId] as const;
            }),
          );
      }),
      switchMap(([event, action, stationId]) => {
        return from(this.inputAppErrorUtil.dismissLoadingWithId('NOTIFY_BCTX_CHANGE')).pipe(
          take(1),
          switchMap(() => {
            if (action.dismissModal) {
              return from(this.modalCtrl.dismiss()).pipe(
                take(1),
                map(() => {
                  return new UpdateSelectedBctxItemAndReleaseLockAndThenAddEvent(action.payload, event, stationId);
                }),
              );
            } else {
              return of(new UpdateSelectedBctxItemAndReleaseLockAndThenAddEvent(action.payload, event, stationId));
            }
          }),
        );
      }),
    ),
  );

  UpdateSelectedBctxItemAndReleaseLockAndThenAddEvent$ = createEffect(() =>
    this.action$.pipe(
      ofType<UpdateSelectedBctxItemAndReleaseLockAndThenAddEvent>(
        InputAppClientDBActionTypes.UpdateSelectedBctxItemAndReleaseLockAndThenAddEvent,
      ),
      switchMap((action) => {
        return of(new AcquireUserDBLockAndAddBulkEvents([action.bulkEvent], false, { updateActualsOnly: false }));
      }),
    ),
  );

  SaveEvents$ = createEffect(() =>
    this.action$.pipe(
      ofType<SaveEvents>(InputAppClientDBActionTypes.SaveEvents),
      switchMap((action) =>
        this.inputAppClientDBFacade.getSelectedStationIdAndShiftId().pipe(
          take(1),
          map((selectedStationIdAndShiftId) => {
            return [action, selectedStationIdAndShiftId] as const;
          }),
        ),
      ),
      switchMap(([action, selectedStationIdAndShiftId]) =>
        this.inputAppClientDBFacade.getselectedBctxItem().pipe(
          take(1),
          map((selectedBctx) => {
            return [action, selectedStationIdAndShiftId, selectedBctx] as const;
          }),
        ),
      ),
      switchMap(([action, selectedStationIdAndShiftId, selectedBctx]) =>
        this.inputAppClientDBFacade.getSizeList().pipe(
          take(1),
          map((sizeList) => {
            const sizeAndCountList: TCountEvent[] = sizeList
              .map((sizeItem) => {
                const item: TCountEvent = {
                  sizeName: sizeItem.name,
                  bctxKey: selectedBctx.bctxInfoWithoutSize.bctxKey,
                  count: sizeItem.client_work[action.actionType].actuals,
                  // newBctxKey: selectedBctx.newBctxForPOSplit?.bctx.bctxKey,
                };
                return item;
              })
              .filter((item) => item.count);
            return [action, sizeAndCountList, selectedStationIdAndShiftId, selectedBctx] as const;
          }),
        ),
      ),
      switchMap(([action, sizeAndCountList, selectedStationIdAndShiftId, selectedBctx]) =>
        this.inputAppClientDBFacade.getSizeMapFromLocalDB(selectedStationIdAndShiftId).pipe(
          take(1),
          map((sizeMap) => {
            sizeAndCountList = sizeAndCountList
              .map((sizeAndCountListItem) => {
                return {
                  ...sizeAndCountListItem,
                  count:
                    sizeAndCountListItem.count -
                    sizeMap[sizeAndCountListItem.sizeName].client_work[action.actionType].actuals,
                };
              })
              .filter((item) => item.count > 0);
            return [action, sizeAndCountList, selectedBctx] as const;
          }),
        ),
      ),
      switchMap(([action, sizeAndCountList, selectedBctx]) =>
        this.inputAppClientDBFacade
          .getBulkEventsMetadataAndEventsInfo(
            sizeAndCountList.map((sizeAndCount) => {
              const bctxDetails: TEventBctxDetails = {
                businessContextDetailsWithoutSize: selectedBctx.bctxInfoWithoutSize.list,
                count: sizeAndCount.count,
                bctxKey: sizeAndCount.bctxKey,
                size: sizeAndCount.sizeName,
              };
              if (selectedBctx.newBctxForPOSplit) {
                return {
                  linked_v_id: undefined,
                  bctxDetails: {
                    ...bctxDetails,
                    newBctxDetails: {
                      bctxKey: selectedBctx.newBctxForPOSplit.bctx.bctxKey,
                      businessContextDetailsWithoutSize: selectedBctx.newBctxForPOSplit.bctx.list,
                      groupedHeaderInfo: selectedBctx.newBctxForPOSplit.groupedHeaderInfo,
                    },
                  },
                };
              }
              return {
                linked_v_id: undefined,
                bctxDetails,
              };
            }),
            new Date().getTime(),
            'WITH_IN_BCTX',
          )
          .pipe(
            take(1),
            map(({ metadata, eventsCommonDetails }) => {
              return new AddBulkEventForOnlineApps({
                type: 'FORWARD_BULK_EVENT',
                metadata,
                events: eventsCommonDetails.map((eventCommonDetails) => {
                  return BCTXComputationHelper.getMDPointSingleEvent(action.actionType, eventCommonDetails);
                }),
              });
            }),
          ),
      ),
    ),
  );

  ToBeRectifiedSaveEvents$ = createEffect(() =>
    this.action$.pipe(
      ofType<ToBeRectifiedSaveEvents>(InputAppClientDBActionTypes.ToBeRectifiedSaveEvents),
      switchMap((action) => {
        return this.inputAppClientDBFacade.getBctxItemsOrderWithoutSize().pipe(
          take(1),
          map((order) => [action, order] as const),
        );
      }),
      switchMap(([action, order]) =>
        this.inputAppClientDBFacade.getStationDetailsAndSelectedBctxItem().pipe(
          take(1),
          map(({ stationDetails, selectedBctxItem }) => {
            return {
              stationDetails,
              selectedBctxItem: selectedBctxItem,
              toBeRectifiedItems: action.toBeRectifiedItems,
              actionType: action.actionType,
              toBeRectifiedRequestPayload: {
                stationDetails,
                selectedBctxItem:
                  selectedBctxItem.bctxInfoWithoutSize.list.length === 0
                    ? undefined
                    : selectedBctxItem.bctxInfoWithoutSize.list.reduce((acc, curr) => {
                        acc[curr.k] = curr.v;
                        return acc;
                      }, {} as Record<TBCTXKeysWithoutSize, string>),
                filters: action.filters,
                ...action.paginationInfo,
              },
              order,
            };
          }),
        ),
      ),
      switchMap((action) =>
        this.inputAppClientDBFacade
          .getBulkEventsMetadataAndEventsInfo(
            action.toBeRectifiedItems.map((toBeRectifiedItem) => {
              return {
                bctxDetails: {
                  size: toBeRectifiedItem.size,
                  bctxKey: BCTXComputationHelper.getUniqueBctxKeyWithOrder(action.order, toBeRectifiedItem.bctx),
                  count: 1,
                  businessContextDetailsWithoutSize: toBeRectifiedItem.bctx,
                  filteredSizesList: [],
                },
                linked_v_id: undefined,
              };
            }),
            new Date().getTime(),
            action.selectedBctxItem.bctxInfoWithoutSize.list.length > 0 ? 'WITH_IN_BCTX' : 'ACROSS_BCTX',
          )
          .pipe(
            take(1),
            map(({ metadata, eventsCommonDetails }) => {
              return new AddDefectiveResolutionBulkEventForOnlineApps(
                {
                  metadata,
                  type: 'FORWARD_BULK_EVENT',
                  events: eventsCommonDetails.map((eventCommonDetails, index) => {
                    return BCTXComputationHelper.getMDPointDefectiveResolutionEvent(
                      action.actionType,
                      eventCommonDetails,
                      action.toBeRectifiedItems[index].datetime,
                      action.toBeRectifiedItems[index].key,
                    );
                  }),
                },
                action.toBeRectifiedRequestPayload,
              );
            }),
          ),
      ),
    ),
  );

  InitializeReduxStore$ = createEffect(() =>
    this.action$.pipe(
      ofType<InitializeReduxStore>(InputAppClientDBActionTypes.InitializeReduxStore),
      switchMap((action) =>
        from(this.persistentStorageService.get('[APP][INPUT_APP_CLIENT_DB]')).pipe(
          map((inputClientDB) => {
            return new InitializeReduxStoreSuccess(inputClientDB);
          }),
          catchError((error) => {
            this.customLoggerService.log('INPUT_APP_INITIALIZE_REDUX_STORE_FAILED', {
              error: error?.name + ' - ' + error?.message,
              stack: error?.stack,
            });
            return of(new InitializeReduxStoreFailed());
          }),
        ),
      ),
    ),
  );

  ChangeStation$ = createEffect(() =>
    this.action$.pipe(
      ofType<ChangeStation>(AppMasterDBActionTypes.ChangeStation),
      switchMap(() =>
        this.appMasterDBFacade.getAppIdentifier().pipe(
          take(1),
          switchMap((appIdentifier) => {
            switch (appIdentifier) {
              case 'endline_qc_v2':
              case 'md_point_per_piece_qc_v2':
              case 'md_point_v2':
              case 'roaming_qc_v2':
              case 'per_piece_qc_v2':
              case 'per_piece_line_in_v2':
              case 'line_in_v2':
                return of(new CheckStationOrShiftChange());
              case 'bundle_qc_v2': {
                return this.inputAppClientDBFacade.hasIncompleteBundlesInfoInitializedForCurrentStationAndShift().pipe(
                  take(1),
                  map((hasInitialized) => {
                    if (!hasInitialized)
                      return new AcquireUserDBLockAndFetchIncompleteBundles({ chainWithLineOrShiftChange: true });
                    else return new CheckStationOrShiftChange();
                  }),
                );
              }
              default:
                return of(new InputAppNoAction());
            }
          }),
        ),
      ),
    ),
  );

  CheckStationOrShiftChange$ = createEffect(() =>
    this.action$.pipe(
      ofType<CheckStationOrShiftChange>(InputAppClientDBActionTypes.CheckStationOrShiftChange),
      switchMap((action) =>
        this.inputAppClientDBFacade.getSelectedStationIdAndShiftId().pipe(
          take(1),
          map((selectedStationAndShiftId) => [selectedStationAndShiftId, action] as const),
        ),
      ),
      switchMap(([selectedStationAndShiftId, action]) =>
        this.inputAppClientDBFacade.getClientDB().pipe(
          take(1),
          map((userDB) => {
            return [selectedStationAndShiftId, userDB, action] as const;
          }),
        ),
      ),
      switchMap(([selectedStationAndShiftId, userDB, action]) =>
        this.appMasterDBFacade.getAppIdentifier().pipe(
          take(1),
          map((appIdentifier) => {
            return [selectedStationAndShiftId, userDB, action, appIdentifier] as const;
          }),
        ),
      ),
      switchMap(([selectedStationAndShiftId, userDB, action, appIdentifier]) =>
        this.inputAppClientDBFacade.getConfigurations().pipe(
          take(1),
          map(({ isWipValidationEnabledLineIn }) => {
            return [selectedStationAndShiftId, userDB, action, appIdentifier, isWipValidationEnabledLineIn] as const;
          }),
        ),
      ),
      switchMap(([selectedStationAndShiftId, userDB, action, appIdentifier, isWipValidationEnabledLineIn]) => {
        const { stationId, shiftId } = selectedStationAndShiftId;
        if (userDB.dailyCache.lineMap[stationId]) {
          if (userDB.dailyCache.lineMap[stationId].shiftMap[shiftId]) {
            return of(new InputAppNoAction());
          } else {
            //we are guranteed to have bctxWIPMap, as we always set the bctxWIPMap on landing/line change
            // currentDB.dailyCache.lineMap[stationId].shiftMap[shiftId] = BCTXComputationHelper.createInitialShiftMapItem(
            //   currentDB.dailyCache.lineMap[stationId].bctxWipMap,
            // );
            // return from(this.persistentStorageService.set('[APP][INPUT_APP_CLIENT_DB]', currentDB)).pipe(
            //   map(() => {
            //     console.log('[APP][INPUT_APP_CLIENT_DB] updated, Action is:', ['CheckStationOrShiftIdChange']);
            //     const bctxWithMultipleSizeList: TBctxWithMultipleSize[] =
            //       BCTXComputationHelper.getBctxWithMultipleSizeList(currentDB.dailyCache.lineMap[stationId]);
            //     if(action.chainWithRestoreCountsForNewStyles){
            //       return new UpdateClientDBAndThenReleaseLockAndThenRestoreActualsForNewStyles(
            //         currentDB,
            //         bctxWithMultipleSizeList
            //       )
            //     }else return new ReleaseLock();
            //   })
            // )
            return of(new InputAppNoAction());
          }
        } else {
          switch (appIdentifier) {
            case 'bundle_qc_v2':
            case 'endline_qc_v2':
            case 'per_piece_qc_v2':
            case 'md_point_per_piece_qc_v2':
              this.inputAppClientDBFacade.forceInitLineChangeAfterSyncingAllPendingEvents(
                appIdentifier === 'per_piece_qc_v2' || appIdentifier === 'md_point_per_piece_qc_v2',
                false,
                false,
                {
                  actions: {
                    chainWithRestoreBackedUpBctxAndThenLoadMasterdataList: {
                      wipOnly: false,
                      actualsOnly:
                        appIdentifier === 'per_piece_qc_v2' ||
                        appIdentifier === 'md_point_per_piece_qc_v2' ||
                        appIdentifier === 'bundle_qc_v2',
                      chainWithLoadMasterdataList: appIdentifier !== 'md_point_per_piece_qc_v2',
                    },
                  },
                },
              );
              break;
            case 'md_point_v2': {
              this.inputAppClientDBFacade.forceInitLineChangeAfterSyncingAllPendingEvents(false, false, false, {
                actions: { chainWithRestoreActualsForNewStyles: true },
              });
              break;
            }
            case 'roaming_qc_v2': {
              this.inputAppClientDBFacade.lineChangeForNonCountingApps();
              break;
            }
            case 'per_piece_line_in_v2': {
              this.inputAppClientDBFacade.restoreAppStateForBackedUpBctx(
                true,
                { actualsOnly: true, wipOnly: false, chainWithLoadMasterdataList: false },
                false,
                false,
              );
              break;
            }
            case 'line_in_v2': {
              isWipValidationEnabledLineIn
                ? this.inputAppClientDBFacade.forceInitLineChangeAfterSyncingAllPendingEvents(false, false, false, {
                    actions: {
                      chainWithRestoreBackedUpBctxAndThenLoadMasterdataList: {
                        wipOnly: false,
                        actualsOnly: false,
                        chainWithLoadMasterdataList: true,
                      },
                    },
                  })
                : this.inputAppClientDBFacade.forceInitLineChangeAfterSyncingAllPendingEvents(false, false, false, {
                    actions: {
                      chainWithLoadAllMasterDataList: true,
                      masterDataListMetaData: { source: 'INIT' },
                    },
                    isPlanBasedApp: true,
                  });
              break;
            }
            default:
              break;
          }
          return of(new InputAppNoAction());
        }
      }),
    ),
  );

  // ChangeShiftId$ = createEffect(() =>
  //   this.action$.pipe(
  //     ofType<ChangeShiftId>(ShiftsActionTypes.ChangeShiftId),
  //     switchMap((action) => {
  //       return this.appMasterDBFacade.getAppName().pipe(
  //         take(1),
  //         map((appName) => {
  //           if (appName === 'MD POINT') {
  //             return new AcquireLockAndThenCheckStationOrShiftChange(true, false, true);
  //           } else if (appName === 'Fabric Inspection') {
  //             return new InputAppNoAction();
  //           } else return new AcquireLockAndThenCheckStationOrShiftChange(false, true, false);
  //         }),
  //       );
  //     }),
  //   ),
  // );

  ReleaseLockAndShowPopupAndDismissLoader$ = createEffect(() =>
    this.action$.pipe(
      ofType<ReleaseUserDBLockAndShowPopupAndDismissLoader>(
        InputAppClientDBActionTypes.ReleaseUserDBLockAndShowPopupAndDismissLoader,
      ),
      switchMap((action) =>
        from(this.inputAppAPIHelperUtil.showPopup(action.title, action.message)).pipe(
          take(1),
          map(() => {
            this.inputAppErrorUtil.dismissLoadingWithId(action.id);
            return new InputAppNoAction();
          }),
        ),
      ),
    ),
  );

  AcquireUserDBLockAndValidateUndoBulkEventAndAddEvents$ = createEffect(() => {
    return this.action$.pipe(
      ofType<AcquireUserDBLockAndValidateUndoBulkEventAndAddEvents>(
        InputAppClientDBActionTypes.AcquireUserDBLockAndValidateUndoBulkEventAndAddEvents,
      ),
      switchMap((action) => {
        return this.inputAppClientDBFacade.acquireUserDBLock('VALIDATING_UNDO').pipe(
          take(1),
          map((userDBLockResult) => {
            if (userDBLockResult.status === 'SUCCESS') {
              return new ValidateUndoBulkEventAndReleaseLockAndThenAddEvents(
                action.bulkEvent,
                action.eventAdditionMoreActions,
                action.location,
                action.poSplitUndoWipOverrideDetails,
              );
            } else {
              this.inputAppAPIHelperUtil.showPopup(
                this.translate.instant('input_app_common.error'),
                userDBLockResult.message,
              );
              return new InputAppNoAction();
            }
          }),
        );
      }),
    );
  });

  ValidateUndoBulkEventAndReleaseLockAndThenAddEvents$ = createEffect(() =>
    this.action$.pipe(
      ofType<ValidateUndoBulkEventAndReleaseLockAndThenAddEvents>(
        InputAppClientDBActionTypes.ValidateUndoBulkEventAndReleaseLockAndThenAddEvents,
      ),
      switchMap((action) => {
        return this.inputAppClientDBFacade
          .isUndoValidationRequired(EventUtil.getActionTypeForBulkEvent(action.bulkEvent) as TForwardEventActionType)
          .pipe(
            take(1),
            map((isValidationNeeded) => {
              return [isValidationNeeded, action] as const;
            }),
          );
      }),
      switchMap(([isValidationNeeded, action]) => {
        return from(
          this.inputAppErrorUtil.presentLoadingWithId(
            'VALIDATING_UNDO_EVENT',
            isValidationNeeded
              ? this.translate.instant('input_app_db_effects.validatingUndoQuantity')
              : this.translate.instant('input_app_db_effects.addingUndo'),
          ),
        ).pipe(map(() => [isValidationNeeded, action] as const));
      }),
      switchMap(([isValidationNeeded, action]) => {
        return this.inputAppClientDBFacade.getTransactionWipTypeAndSubjectKeyAndAppIdentifier().pipe(
          take(1),
          map(
            ({ subjectKey, transactionWipType, nonWashingTransactionWipType, app_identifier }) =>
              [
                isValidationNeeded,
                transactionWipType,
                nonWashingTransactionWipType,
                action,
                subjectKey,
                app_identifier,
              ] as const,
          ),
        );
      }),
      switchMap(
        ([
          isValidationNeeded,
          transactionWipType,
          nonWashingTransactionWipType,
          { bulkEvent, location, eventAdditionMoreActions, poSplitUndoWipOverrideDetails },
          subjectKey,
          app_identifier,
        ]) => {
          if (isValidationNeeded) {
            const eventTime = new Date().getTime();
            const filteredEvents = bulkEvent.events.filter(
              (curr) =>
                curr.eventBackgroundMetadata.status === 'SYNCED_WITH_SUCCESS' ||
                curr.eventBackgroundMetadata.status === 'YET_TO_BE_SYNCED',
            );
            return forkJoin(
              filteredEvents.map((event) =>
                this.inputAppDataService.validateUndo({
                  wipType: transactionWipType,
                  nonWashWipType: nonWashingTransactionWipType,
                  subject: bulkEvent.metadata.stationDetails.subject.subject,
                  subjectKey: subjectKey,
                  columns: BCTXComputationHelper.getColumnsForUndo(
                    event.eventInfo.bctxDetails.businessContextDetailsWithoutSize,
                    event.eventInfo.bctxDetails.size,
                    app_identifier,
                  ),
                  qty: event.eventInfo.bctxDetails.count,
                  filter_range: {
                    start: 0,
                    end: eventTime,
                  },
                  window:
                    moment(new Date(eventTime)).format('YYYY-MM-DD') +
                    '/' +
                    moment(new Date(eventTime + 86400000)).format('YYYY-MM-DD'),
                }),
              ),
            ).pipe(
              switchMap((res) => {
                this.customLoggerService.log('INPUT_APP_CLIENT_EFFECT_UNDO_VALIDATION', {
                  res,
                });
                const modifiedEvents = res.reduce((acc, curr, index) => {
                  if (curr.valid || curr.remaining_qty > 0) {
                    acc.push(
                      produce(filteredEvents[index], (draft) => {
                        if (curr.remaining_qty < draft.eventInfo.bctxDetails.count)
                          draft.eventInfo.bctxDetails.count = curr.remaining_qty; // TODO NISHA: Count change is not happening here
                      }),
                    );
                  }
                  return acc;
                }, [] as TForwardSingleEvent[]);
                const modifiedBulkEvent = produce(bulkEvent, (draft) => {
                  draft.events = modifiedEvents;
                });
                return from(this.inputAppErrorUtil.dismissLoadingWithId('VALIDATING_UNDO_EVENT')).pipe(
                  take(1),
                  switchMap(() => {
                    if (modifiedBulkEvent.events.length > 0) {
                      this.inputAppClientDBFacade.releaseUserDBLock();
                      return of(
                        new UndoBulkEvent(
                          modifiedBulkEvent,
                          eventAdditionMoreActions,
                          location,
                          poSplitUndoWipOverrideDetails,
                        ),
                      );
                    } else {
                      return from(
                        this.inputAppAPIHelperUtil.showPopup(
                          this.translate.instant('input_app_db_effects.cannotUndoError.header'),
                          this.translate.instant('input_app_db_effects.cannotUndoError.message'),
                        ),
                      ).pipe(
                        take(1),
                        map(() => {
                          this.inputAppClientDBFacade.releaseUserDBLock();
                          return new InputAppNoAction();
                        }),
                      );
                    }
                  }),
                );
              }),
              catchError((error) => {
                this.customLoggerService.log(
                  'INPUT APP CLIENT DB EFFECT: ValidateUndoBulkEventAndReleaseLockAndThenAddEvents - validateUndo API Error',
                  JSON.stringify(error),
                );
                return from(
                  this.inputAppAPIHelperUtil.showPopup(
                    this.translate.instant('input_app_db_effects.undoValidationFailed.header'),
                    this.translate.instant('input_app_db_effects.undoValidationFailed.message'),
                  ),
                ).pipe(
                  take(1),
                  switchMap(() => {
                    return from(this.inputAppErrorUtil.dismissLoadingWithId('VALIDATING_UNDO_EVENT')).pipe(
                      map(() => {
                        this.inputAppClientDBFacade.releaseUserDBLock();
                        return new InputAppNoAction();
                      }),
                    );
                  }),
                );
              }),
            );
          } else {
            return from(this.inputAppErrorUtil.dismissLoadingWithId('VALIDATING_UNDO_EVENT')).pipe(
              take(1),
              map(() => {
                this.inputAppClientDBFacade.releaseUserDBLock();
                return new UndoBulkEvent(
                  produce(bulkEvent, (draft) => {
                    draft.events = bulkEvent.events.filter(
                      (curr) =>
                        curr.eventBackgroundMetadata.status === 'SYNCED_WITH_SUCCESS' ||
                        curr.eventBackgroundMetadata.status === 'YET_TO_BE_SYNCED',
                    );
                  }),
                  eventAdditionMoreActions,
                  location,
                );
              }),
            );
          }
        },
      ),
    ),
  );

  UndoBulkEvent$ = createEffect(() =>
    this.action$.pipe(
      ofType<UndoBulkEvent>(InputAppClientDBActionTypes.UndoBulkEvent),
      switchMap((action) => {
        return this.inputAppClientDBFacade.getselectedBctxItem().pipe(
          take(1),
          map(({ bctxInfoWithoutSize }) => {
            return [action, bctxInfoWithoutSize.bctxKey] as const;
          }),
        );
      }),
      switchMap(([action, currentBctxKey]) => {
        return this.inputAppClientDBFacade.getConfigurations().pipe(
          take(1),
          map(({ useRFIDScanMode }) => {
            return [action, currentBctxKey, useRFIDScanMode] as const;
          }),
        );
      }),
      switchMap(
        ([
          { bulkEvent, location, eventAdditionMoreActions, poSplitUndoWipOverrideDetails },
          currentBctxKey,
          useRFIDScanMode,
        ]) => {
          const eventTime = new Date().getTime();
          const bulkEventUndoMetadata: TUndoBulkEventMetadata = {
            forwardEventGroupId: bulkEvent.metadata.groupId,
          };
          const actionType = EventUtil.getActionTypeForBulkEvent(bulkEvent);
          return this.inputAppClientDBFacade
            .getBulkEventsMetadataAndEventsInfo(
              bulkEvent.events.map((event) => {
                if (poSplitUndoWipOverrideDetails && !event.eventInfo.bctxDetails.newBctxDetails) {
                  event = produce(event, (draft) => {
                    const newBctxDetails = draft.eventInfo.bctxDetails.businessContextDetailsWithoutSize;
                    draft.eventInfo.bctxDetails.newBctxDetails = {
                      businessContextDetailsWithoutSize: newBctxDetails,
                    };
                    draft.eventInfo.bctxDetails.businessContextDetailsWithoutSize =
                      poSplitUndoWipOverrideDetails as TBctxItemWithoutSize[];
                  });
                }
                return {
                  bctxDetails: event.eventInfo.bctxDetails,
                  linked_v_id: event.eventInfo.v_id,
                };
              }),
              eventTime,
              location,
            )
            .pipe(
              take(1),
              map(({ metadata, eventsCommonDetails }) => {
                switch (actionType) {
                  case 'CHECK_IN': {
                    return this.inputAppClientDBFacade.getActionForUndoEvents(
                      [
                        {
                          type: 'UNDO_BULK_EVENT',
                          metadata,
                          undoMetadata: bulkEventUndoMetadata,
                          events: eventsCommonDetails.map((eventCommonDetails, index) => {
                            return {
                              undoMetadata: {
                                forwardEventTime: bulkEvent.events[index].eventInfo.eventTime,
                              },
                              eventInfo: eventCommonDetails,
                              type: 'UNDO_EVENT',
                              actionType: 'UNDO_CHECK_IN',
                            };
                          }),
                        },
                      ],
                      eventAdditionMoreActions,
                      useRFIDScanMode,
                    );
                  }
                  case 'FTT': {
                    return this.inputAppClientDBFacade.getActionForUndoEvents(
                      [
                        {
                          type: 'UNDO_BULK_EVENT',
                          metadata,
                          undoMetadata: bulkEventUndoMetadata,
                          events: eventsCommonDetails.map((eventCommonDetails, index) => {
                            return {
                              undoMetadata: {
                                forwardEventTime: bulkEvent.events[index].eventInfo.eventTime,
                              },
                              eventInfo: eventCommonDetails,
                              type: 'UNDO_EVENT',
                              actionType: 'UNDO_FTT',
                            };
                          }),
                        },
                      ],
                      eventAdditionMoreActions,
                      useRFIDScanMode,
                    );
                  }
                  case 'DEFECTIVE': {
                    return this.inputAppClientDBFacade.getActionForUndoEvents(
                      [
                        {
                          type: 'UNDO_BULK_EVENT',
                          metadata,
                          undoMetadata: bulkEventUndoMetadata,
                          events: eventsCommonDetails.map((eventCommonDetails, index) => {
                            const singleDefectiveEvent = bulkEvent.events[index] as TSingleDefectiveEvent;
                            return {
                              undoMetadata: {
                                forwardEventTime: singleDefectiveEvent.eventInfo.eventTime,
                              },
                              eventInfo: eventCommonDetails,
                              type: 'UNDO_EVENT',
                              actionType: 'UNDO_DEFECTIVE',
                              subType:
                                singleDefectiveEvent.subType === 'DEFECTIVE'
                                  ? 'UNDO_DEFECTIVE'
                                  : 'UNDO_DEFECTIVE_FROM_DEFECTIVE',
                              defectivesInfo: (bulkEvent.events[index] as TSingleDefectiveEvent).defectivesInfo,
                              sourceDefectiveCreatedTime: singleDefectiveEvent.sourceDefectiveCreatedTime,
                              imageId: singleDefectiveEvent.imageId,
                            };
                          }),
                        },
                      ],
                      eventAdditionMoreActions,
                      useRFIDScanMode,
                    );
                  }
                  case 'REWORKED_FROM_DEFECTIVE': {
                    return this.inputAppClientDBFacade.getActionForUndoEvents(
                      [
                        {
                          type: 'UNDO_BULK_EVENT',
                          metadata,
                          undoMetadata: bulkEventUndoMetadata,
                          events: eventsCommonDetails.map((eventCommonDetails, index) => {
                            return {
                              undoMetadata: {
                                forwardEventTime: bulkEvent.events[index].eventInfo.eventTime,
                              },
                              eventInfo: eventCommonDetails,
                              type: 'UNDO_EVENT',
                              actionType: 'UNDO_REWORKED_FROM_DEFECTIVE',
                              defectivesInfo: (bulkEvent.events[index] as TSingleReworkedEventFromDefectives)
                                .defectivesInfo,
                              sourceDefectiveCreatedTime: (
                                bulkEvent.events[index] as TSingleReworkedEventFromDefectives
                              ).sourceDefectiveCreatedTime,
                              imageId: (bulkEvent.events[index] as TSingleReworkedEventFromDefectives).imageId,
                            };
                          }),
                        },
                      ],
                      eventAdditionMoreActions,
                      useRFIDScanMode,
                    );
                  }
                  case 'REJECTED_FROM_DEFECTIVE': {
                    return this.inputAppClientDBFacade.getActionForUndoEvents(
                      [
                        {
                          type: 'UNDO_BULK_EVENT',
                          metadata,
                          undoMetadata: bulkEventUndoMetadata,
                          events: eventsCommonDetails.map((eventCommonDetails, index) => {
                            return {
                              undoMetadata: {
                                forwardEventTime: bulkEvent.events[index].eventInfo.eventTime,
                              },
                              eventInfo: eventCommonDetails,
                              type: 'UNDO_EVENT',
                              actionType: 'UNDO_REJECTED_FROM_DEFECTIVE',
                              defectivesInfo: (bulkEvent.events[index] as TSingleRejectedEventFromDefectives)
                                .defectivesInfo,
                              rejectedInfo: (bulkEvent.events[index] as TSingleRejectedEventFromDefectives)
                                .rejectedInfo,
                              sourceDefectiveCreatedTime: (
                                bulkEvent.events[index] as TSingleRejectedEventFromDefectives
                              ).sourceDefectiveCreatedTime,
                              imageId: (bulkEvent.events[index] as TSingleRejectedEventFromDefectives).imageId,
                            };
                          }),
                        },
                      ],
                      eventAdditionMoreActions,
                      useRFIDScanMode,
                    );
                  }
                  case 'REJECTED': {
                    return this.inputAppClientDBFacade.getActionForUndoEvents(
                      [
                        {
                          type: 'UNDO_BULK_EVENT',
                          metadata,
                          undoMetadata: bulkEventUndoMetadata,
                          events: eventsCommonDetails.map((eventCommonDetails, index) => {
                            return {
                              undoMetadata: {
                                forwardEventTime: bulkEvent.events[index].eventInfo.eventTime,
                              },
                              eventInfo: eventCommonDetails,
                              type: 'UNDO_EVENT',
                              actionType: 'UNDO_REJECTED',
                              rejectedInfo: (bulkEvent.events[index] as TSingleRejectedEvent).rejectedInfo,
                              imageId: (bulkEvent.events[index] as TSingleRejectedEvent).imageId,
                            };
                          }),
                        },
                      ],
                      eventAdditionMoreActions,
                      useRFIDScanMode,
                    );
                  }
                  default:
                    return new InputAppNoAction();
                }
              }),
            );
        },
      ),
    ),
  );

  AddBulkEventForOnlineApps$ = createEffect(() =>
    this.action$.pipe(
      ofType<AddBulkEventForOnlineApps>(InputAppClientDBActionTypes.AddBulkEventForOnlineApps),
      switchMap((action) => {
        return this.inputAppClientDBFacade.acquireUserDBLock('EVENT_ADDITION').pipe(
          map((res) => {
            if (res.status === 'SUCCESS') {
              return new SyncEventsForOnlineAppsAndReleaseLock(action.bulkEvent);
            } else {
              this.inputAppAPIHelperUtil.showPopup(this.translate.instant('input_app_common.error'), res.message);
              return new InputAppNoAction();
            }
          }),
        );
      }),
    ),
  );

  SyncEventsForOnlineAppsAndReleaseLock$ = createEffect(() =>
    this.action$.pipe(
      ofType<SyncEventsForOnlineAppsAndReleaseLock>(InputAppClientDBActionTypes.SyncEventsForOnlineAppsAndReleaseLock),
      switchMap((action) =>
        from(
          this.inputAppErrorUtil.presentLoadingWithId(
            'ONLINE_ADD_MD_PASS',
            this.translate.instant('input_app_db_effects.syncingEvents'),
          ),
        ).pipe(
          take(1),
          map(() => action),
        ),
      ),
      switchMap((action) =>
        from(this.persistentStorageService.get('[APP][INPUT_APP_CLIENT_DB]')).pipe(
          take(1),
          switchMap((currentDB) => {
            return from(this.persistentStorageService.get('[APP][INPUT_APP_BACKGROUND_EVENTS_SYNCING_DB]')).pipe(
              take(1),
              map((bgDB) => {
                return [action, currentDB, bgDB] as const;
              }),
            );
          }),
        ),
      ),
      switchMap(([action, currentDB, bgDB]) => {
        //no need of lock here as there is no background syncing for MD-point
        return this.inputAppClientDBFacade.addMissingEventsStatusInBgDB([action.bulkEvent], bgDB, true).pipe(
          take(1),
          map(([x, bulkEventWithStatus]) => [action, currentDB, bulkEventWithStatus] as const),
        );
      }),
      switchMap(([action, currentDB, bulkEvent]) =>
        this.inputAppClientDBFacade
          .syncAtLeastOnePendingBulkEventWithBatchCountWrapper(bulkEvent, action.bulkEvent.events.length)
          .pipe(
            switchMap((res) => {
              if (res.lastBatchSyncStatus === 'ALL_SYNCED') {
                currentDB = BCTXComputationHelper.updateWipAndActualsForBulkEventsForOnlineApps(
                  currentDB,
                  res.bulkEvents,
                );
                const failedEventsIndexes = res.failedBulkEventsIndexes;

                currentDB = BCTXComputationHelper.updateCurrentDbBulkMdpointEvents(currentDB, res.bulkEvents);

                return from(this.persistentStorageService.set('[APP][INPUT_APP_CLIENT_DB]', currentDB)).pipe(
                  switchMap(() =>
                    from(this.inputAppErrorUtil.dismissLoadingWithId('ONLINE_ADD_MD_PASS')).pipe(
                      take(1),
                      map(
                        () =>
                          new UpdateUserDBAndReleaseLockForSyncEventsForOnlineApps(
                            currentDB,
                            failedEventsIndexes,
                            res.lastBatchSyncStatus,
                            res.bulkEvents[0],
                          ),
                      ),
                    ),
                  ),
                );
              } else {
                if (res.lastBatchSyncStatus === 'SERVER_ERROR' || res.lastBatchSyncStatus === 'UNKNOWN_ERROR') {
                  this.customLoggerService.log(
                    `INPUT APP CLIENT DB EFFECT: SyncEventsForOnlineAppsAndReleaseLock - syncAtLeastOnePendingBulkEventWithBatchCountWrapper ${res.lastBatchSyncStatus}`,
                  );
                }
                return from(
                  this.inputAppAPIHelperUtil.showPopup(
                    this.translate.instant('input_app_common.error'),
                    this.translate.instant('common_components.somethingWentWrong'),
                  ),
                ).pipe(
                  take(1),
                  map(() => {
                    this.inputAppErrorUtil.dismissLoadingWithId('ONLINE_ADD_MD_PASS');
                    return new ReleaseUserDBLock();
                  }),
                );
              }
            }),
          ),
      ),
    ),
  );

  UpdateUserDBAndReleaseLockForSyncEventsForOnlineApps$ = createEffect(() =>
    this.action$.pipe(
      ofType<UpdateUserDBAndReleaseLockForSyncEventsForOnlineApps>(
        InputAppClientDBActionTypes.UpdateUserDBAndReleaseLockForSyncEventsForOnlineApps,
      ),
      switchMap((action) => {
        if (action.failedEventsIndexes.length > 0) {
          return from(this.inputAppAPIHelperUtil.showFailedEventsOnline(action.bulkEvent as TForwardBulkEvent)).pipe(
            map(() => {
              return new InputAppNoAction();
            }),
          );
        } else {
          this.modalCtrl.dismiss();
          return of(new InputAppNoAction());
        }
      }),
    ),
  );

  AddDefectiveResolutionBulkEventForOnlineApps$ = createEffect(() =>
    this.action$.pipe(
      ofType<AddDefectiveResolutionBulkEventForOnlineApps>(
        InputAppClientDBActionTypes.AddDefectiveResolutionBulkEventForOnlineApps,
      ),
      switchMap((action) => {
        return this.inputAppClientDBFacade.acquireUserDBLock('EVENT_ADDITION').pipe(
          map((res) => {
            if (res.status === 'SUCCESS') {
              return new SyncDefectiveResolutionEventsForOnlineAppsAndReleaseLock(
                action.bulkEvent,
                action.reFetchToBeRectifiedList,
              );
            } else {
              this.inputAppAPIHelperUtil.showPopup(this.translate.instant('input_app_common.error'), res.message);
              return new InputAppNoAction();
            }
          }),
        );
      }),
    ),
  );

  SyncDefectiveResolutionEventsForOnlineAppsAndReleaseLock$ = createEffect(() =>
    this.action$.pipe(
      ofType<SyncDefectiveResolutionEventsForOnlineAppsAndReleaseLock>(
        InputAppClientDBActionTypes.SyncDefectiveResolutionEventsForOnlineAppsAndReleaseLock,
      ),
      switchMap((action) =>
        from(
          this.inputAppErrorUtil.presentLoadingWithId(
            'ONLINE_ADD_MD_DEFECT_OR_REJECT',
            this.translate.instant('input_app_db_effects.syncingEvents'),
          ),
        ).pipe(
          take(1),
          map(() => action),
        ),
      ),
      switchMap((action) =>
        this.inputAppClientDBFacade.getToBeRectifiedListing().pipe(
          take(1),
          map((res) => [action, res] as const),
        ),
      ),
      switchMap(([action, res]) =>
        from(this.persistentStorageService.get('[APP][INPUT_APP_CLIENT_DB]')).pipe(
          take(1),
          switchMap((currentDB) => {
            return from(this.persistentStorageService.get('[APP][INPUT_APP_BACKGROUND_EVENTS_SYNCING_DB]')).pipe(
              take(1),
              switchMap((bgDB) => {
                //no need of lock here as there is no background syncing for MD-point
                return this.inputAppClientDBFacade.addMissingEventsStatusInBgDB([action.bulkEvent], bgDB, true).pipe(
                  take(1),
                  map(([x, bulkEvents]) => {
                    return [action, res, currentDB, bulkEvents] as const;
                  }),
                );
              }),
            );
          }),
        ),
      ),
      switchMap(([action, currentToBeRectifiedListing, currentDB, bulkEvents]) =>
        this.inputAppClientDBFacade
          .syncAtLeastOnePendingBulkEventWithBatchCountWrapper(bulkEvents, action.bulkEvent.events.length)
          .pipe(
            switchMap((res) => {
              if (res.lastBatchSyncStatus === 'ALL_SYNCED') {
                currentDB = BCTXComputationHelper.updateWipAndActualsForBulkEventsForOnlineApps(
                  currentDB,
                  res.bulkEvents,
                );
                currentDB = BCTXComputationHelper.updateCurrentDbBulkMdpointEvents(currentDB, res.bulkEvents);
                const failedEventsIndexes = res.failedBulkEventsIndexes;
                const actionType = EventUtil.getActionTypeForBulkEvent(res.bulkEvents[0]);
                let message = '';
                currentDB = BCTXComputationHelper.getStateWithUpdatedToBeRectifiedKeysNew(
                  currentDB,
                  res.bulkEvents[0].metadata.stationDetails.subject.subject,
                  res.bulkEvents[0].metadata.stationDetails.shift.id,
                  res.bulkEvents[0].events.map((event) => {
                    return {
                      rectifiedTime: event.eventInfo.eventTime,
                      key: (event as TDefectiveReleatedEvent).defectivesInfo.id,
                    };
                  }),
                );
                if (failedEventsIndexes.length === 0) {
                  if (actionType === 'REWORKED_FROM_DEFECTIVE')
                    message = `${this.translate.instant('input_app_db_effects.successfullyRectified')} ${
                      res.bulkEvents[0].events.length
                    } ${this.translate.instant('common_components.items')}`;
                  else
                    message = `${this.translate.instant('input_app_db_effects.successfullyRejected')} ${
                      res.bulkEvents[0].events.length
                    } ${this.translate.instant('common_components.items')}`;
                }

                return from(this.inputAppAPIHelperUtil.showToast(message)).pipe(
                  take(1),
                  switchMap(() => {
                    return from(
                      this.inputAppDataService.getToBeRectifiedData(action.reFetchToBeRectifiedList).pipe(
                        map((res) => {
                          return { response: res };
                        }),
                        catchError(() => of(currentToBeRectifiedListing)),
                      ),
                    ).pipe(
                      take(1),
                      switchMap((updatedToBeRectifiedListing) => {
                        return from(this.persistentStorageService.set('[APP][INPUT_APP_CLIENT_DB]', currentDB)).pipe(
                          switchMap(() =>
                            from(this.inputAppErrorUtil.dismissLoadingWithId('ONLINE_ADD_MD_DEFECT_OR_REJECT')).pipe(
                              take(1),
                              map(
                                () =>
                                  new UpdateToBeRectifiedListingAndClientDBAndReleaseLockForSyncEventsForOnlineApps(
                                    updatedToBeRectifiedListing,
                                    currentDB,
                                    failedEventsIndexes,
                                    res.lastBatchSyncStatus,
                                    res.bulkEvents[0],
                                  ),
                              ),
                            ),
                          ),
                        );
                      }),
                    );
                  }),
                );
              } else {
                if (res.lastBatchSyncStatus === 'SERVER_ERROR' || res.lastBatchSyncStatus === 'UNKNOWN_ERROR') {
                  this.customLoggerService.log(
                    `INPUT APP CLIENT DB EFFECT: SyncDefectiveResolutionEventsForOnlineAppsAndReleaseLock - syncAtLeastOnePendingBulkEventWithBatchCountWrapper ${res.lastBatchSyncStatus}`,
                  );
                }
                return from(
                  this.inputAppAPIHelperUtil.showPopup(
                    this.translate.instant('input_app_common.error'),
                    this.translate.instant('common_components.somethingWentWrong'),
                  ),
                ).pipe(
                  take(1),
                  map(() => {
                    this.inputAppErrorUtil.dismissLoadingWithId('ONLINE_ADD_MD_DEFECT_OR_REJECT');
                    return new ReleaseUserDBLock();
                  }),
                );
              }
            }),
          ),
      ),
    ),
  );

  UpdateToBeRectifiedListingAndClientDBAndReleaseLockForSyncEventsForOnlineApps$ = createEffect(() =>
    this.action$.pipe(
      ofType<UpdateToBeRectifiedListingAndClientDBAndReleaseLockForSyncEventsForOnlineApps>(
        InputAppClientDBActionTypes.UpdateToBeRectifiedListingAndClientDBAndReleaseLockForSyncEventsForOnlineApps,
      ),
      switchMap((action) => {
        return this.inputAppClientDBFacade.getBctxKeysToDisplayMap().pipe(
          take(1),
          map((bctxKeysToDisplayMap) => {
            if (action.failedEventsIndexes.length > 0) {
              this.inputAppAPIHelperUtil.showFailedDefectiveResolutionEventsOnline(
                action.bulkEvent as TForwardBulkEvent,
                bctxKeysToDisplayMap,
              );
            }
            return new InputAppNoAction();
          }),
        );
      }),
    ),
  );

  AddBctxChangeEventForOnlineApps$ = createEffect(() =>
    this.action$.pipe(
      ofType<AddBctxChangeEventForOnlineApps>(InputAppClientDBActionTypes.AddBctxChangeEventForOnlineApps),
      switchMap((action) => {
        return this.inputAppClientDBFacade.acquireUserDBLock('EVENT_ADDITION').pipe(
          switchMap((res) => {
            if (res.status === 'SUCCESS') {
              return this.inputAppClientDBFacade
                .getBctxChangeBulkEvent(
                  new Date().getTime(),
                  action.newBctxForPOSplit ? action.newBctxForPOSplit.bctx.list : action.newBctx.list,
                  action.oldBctx.list,
                  {},
                )
                .pipe(
                  take(1),
                  map((event) => {
                    return new SyncBctxChangeEventForOnlineAppsAndThenReleaseLock(
                      event,
                      action.newBctx,
                      action.stationId,
                      action.newBctxForPOSplit,
                    );
                  }),
                );
            } else {
              this.inputAppAPIHelperUtil.showPopup(this.translate.instant('input_app_common.error'), res.message);
              return of(new InputAppNoAction());
            }
          }),
        );
      }),
    ),
  );

  SyncBctxChangeEventForOnlineAppsAndThenReleaseLock$ = createEffect(() =>
    this.action$.pipe(
      ofType<SyncBctxChangeEventForOnlineAppsAndThenReleaseLock>(
        InputAppClientDBActionTypes.SyncBctxChangeEventForOnlineAppsAndThenReleaseLock,
      ),
      switchMap((action) =>
        from(
          this.inputAppErrorUtil.presentLoadingWithId(
            'ONLINE_BCTX_CHANGE',
            this.translate.instant('input_app_db_effects.changingWorkingItem'),
          ),
        ).pipe(
          take(1),
          map(() => action),
        ),
      ),
      switchMap((action) =>
        from(this.persistentStorageService.get('[APP][INPUT_APP_CLIENT_DB]')).pipe(
          take(1),
          switchMap((currentDB) => {
            return from(this.persistentStorageService.get('[APP][INPUT_APP_BACKGROUND_EVENTS_SYNCING_DB]')).pipe(
              take(1),
              switchMap((bgDB) => {
                //no need of lock here as there is no background syncing for MD-point
                return this.inputAppClientDBFacade.addMissingEventsStatusInBgDB([action.bulkEvent], bgDB, true).pipe(
                  take(1),
                  map(([x, bulkEvents]) => {
                    return [action, currentDB, bulkEvents] as const;
                  }),
                );
              }),
            );
          }),
        ),
      ),
      switchMap(([action, currentDB, bulkEvents]) =>
        this.inputAppClientDBFacade.getAppIdentifier().pipe(
          take(1),
          map((app_identifier) => {
            return [action, currentDB, bulkEvents, app_identifier] as const;
          }),
        ),
      ),
      switchMap(([action, currentDB, bulkEvents, app_identifier]) => {
        return this.inputAppClientDBFacade.getConfigurations().pipe(
          take(1),
          map(
            ({ aggregatedLineMapForPerPiece }) =>
              [action, currentDB, bulkEvents, app_identifier, aggregatedLineMapForPerPiece] as const,
          ),
        );
      }),
      switchMap(([action, currentDB, bulkEvents, app_identifier, aggregatedLineMapForPerPiece]) =>
        this.inputAppClientDBFacade
          .syncAtLeastOnePendingBulkEventWithBatchCountWrapper(bulkEvents, action.bulkEvent.events.length)
          .pipe(
            switchMap((res) => {
              if (res.bulkEvents[0].backgroundMetadata.bulkEventStatus === 'SYNCED') {
                currentDB = produce(currentDB, (draft) => {
                  if (aggregatedLineMapForPerPiece && BCTXComputationHelper.isPerPieceApp(app_identifier)) {
                    if (!draft.dailyCache.ppLineMap[action.stationId].selectedBctxInfo) {
                      draft.dailyCache.ppLineMap[action.stationId].selectedBctxInfo = {
                        bctxInfoWithoutSize: action.newBctx,
                        newBctxForPOSplit: action.newBctxForPOSplit,
                      };
                    } else {
                      draft.dailyCache.ppLineMap[action.stationId].selectedBctxInfo.bctxInfoWithoutSize =
                        action.newBctx;
                      draft.dailyCache.ppLineMap[action.stationId].selectedBctxInfo.newBctxForPOSplit =
                        action.newBctxForPOSplit;
                    }
                  } else {
                    if (!draft.dailyCache.lineMap[action.stationId].selectedBctxInfo) {
                      draft.dailyCache.lineMap[action.stationId].selectedBctxInfo = {
                        bctxInfoWithoutSize: action.newBctx,
                        newBctxForPOSplit: action.newBctxForPOSplit,
                      };
                    } else {
                      draft.dailyCache.lineMap[action.stationId].selectedBctxInfo.bctxInfoWithoutSize = action.newBctx;
                      draft.dailyCache.lineMap[action.stationId].selectedBctxInfo.newBctxForPOSplit =
                        action.newBctxForPOSplit;
                    }
                  }
                });
                return from(this.persistentStorageService.set('[APP][INPUT_APP_CLIENT_DB]', currentDB)).pipe(
                  switchMap(() =>
                    from(this.inputAppErrorUtil.dismissLoadingWithId('ONLINE_BCTX_CHANGE')).pipe(
                      take(1),
                      map(
                        () =>
                          new UpdatedSelectedBctxAndReleaseLockAndThenDismissModal(
                            {
                              bctxInfoWithoutSize: action.newBctx,
                              newBctxForPOSplit: action.newBctxForPOSplit,
                            },
                            action.stationId,
                            aggregatedLineMapForPerPiece && BCTXComputationHelper.isPerPieceApp(app_identifier),
                          ),
                      ),
                    ),
                  ),
                );
              } else {
                return from(
                  this.inputAppAPIHelperUtil.showPopup(
                    this.translate.instant('input_app_common.error'),
                    this.translate.instant('common_components.somethingWentWrong'),
                  ),
                ).pipe(
                  take(1),
                  map(() => {
                    this.inputAppErrorUtil.dismissLoadingWithId('ONLINE_BCTX_CHANGE');
                    return new ReleaseUserDBLock();
                  }),
                );
              }
            }),
          ),
      ),
    ),
  );

  UpdatedSelectedBctxAndReleaseLockAndThenDismissModal$ = createEffect(() =>
    this.action$.pipe(
      ofType<UpdatedSelectedBctxAndReleaseLockAndThenDismissModal>(
        InputAppClientDBActionTypes.UpdatedSelectedBctxAndReleaseLockAndThenDismissModal,
      ),
      switchMap(() =>
        from(this.modalCtrl.dismiss()).pipe(
          take(1),
          map(() => new InputAppNoAction()),
        ),
      ),
    ),
  );

  AcquireLockAndUpdateBctxWithoutChangeEvent$ = createEffect(() =>
    this.action$.pipe(
      ofType<AcquireLockAndUpdateBctxWithoutChangeEvent>(
        InputAppClientDBActionTypes.AcquireLockAndUpdateBctxWithoutChangeEvent,
      ),
      switchMap((action) =>
        this.inputAppClientDBFacade.acquireUserDBLock('BCTX_SYNCING').pipe(
          take(1),
          map((lockRes) => {
            if (lockRes.status === 'SUCCESS') {
              return new UpdateBctxWithoutChangeEvent(action.bctx, action.newBctxForPOSplit);
            } else {
              this.inputAppAPIHelperUtil.showPopup(this.translate.instant('input_app_common.error'), lockRes.message);
              return new InputAppNoAction();
            }
          }),
        ),
      ),
    ),
  );

  UpdateBctxWithoutChangeEvent$ = createEffect(() =>
    this.action$.pipe(
      ofType<UpdateBctxWithoutChangeEvent>(InputAppClientDBActionTypes.UpdateBctxWithoutChangeEvent),
      switchMap((action) =>
        this.inputAppClientDBFacade.getSelectedStationIdAndShiftId().pipe(
          take(1),
          map(({ stationId }) => [action, stationId] as const),
        ),
      ),
      switchMap(([action, stationId]) =>
        from(this.persistentStorageService.get('[APP][INPUT_APP_CLIENT_DB]')).pipe(
          take(1),
          map((currentDB) => {
            currentDB = produce(currentDB, (draft) => {
              draft.dailyCache.lineMap[stationId].selectedBctxInfo.bctxInfoWithoutSize = action.bctx;
              draft.dailyCache.lineMap[stationId].selectedBctxInfo.newBctxForPOSplit = action.newBctxForPOSplit;
            });
            return [action, stationId, currentDB] as const;
          }),
        ),
      ),
      switchMap(([action, stationId, currentDB]) =>
        from(this.persistentStorageService.set('[APP][INPUT_APP_CLIENT_DB]', currentDB)).pipe(
          take(1),
          map(() => {
            return new UpdateBctxWithoutChangeEventSuccessAndReleaseLock(
              {
                bctxInfoWithoutSize: action.bctx,
                newBctxForPOSplit: action.newBctxForPOSplit,
              },
              stationId,
            );
          }),
        ),
      ),
    ),
  );

  AcquireUserDBLockAndSyncStyleInfoForPlanBased$ = createEffect(() => {
    return this.action$.pipe(
      ofType<AcquireUserDBLockAndSyncStyleInfoForPlanBased>(
        InputAppClientDBActionTypes.AcquireUserDBLockAndSyncStyleInfoForPlanBased,
      ),
      switchMap((action) => {
        return this.inputAppClientDBFacade.acquireUserDBLock('BCTX_SYNCING').pipe(
          take(1),
          map((res) => {
            if (res.status === 'SUCCESS') {
              return new SyncStyleInfoAndThenReleaseUserDBLockPlanBased(action.chainActions);
            } else {
              this.inputAppAPIHelperUtil.showPopup(this.translate.instant('input_app_common.error'), res.message);
              return new InputAppNoAction();
            }
          }),
        );
      }),
    );
  });

  SyncStyleInfoAndThenReleaseUserDBLockPlanBased$ = createEffect(() =>
    this.action$.pipe(
      ofType<SyncStyleInfoAndThenReleaseUserDBLockPlanBased>(
        InputAppClientDBActionTypes.SyncStyleInfoAndThenReleaseUserDBLockPlanBased,
      ),
      switchMap((action) =>
        this.inputAppClientDBFacade.getBusinessContextDataPayload().pipe(
          take(1),
          map((payload) => {
            return [payload, action] as const;
          }),
        ),
      ),
      switchMap(([payload, action]) => {
        this.metadataFacade.updateSyncingStatus(BCTX_SYNCING_KEY, 'SYNCING');
        return from(
          this.inputAppAPIHelperUtil.presentLoading(this.translate.instant('input_app_db_effects.loadingBctx')),
        ).pipe(
          take(1),
          map(() => {
            return [payload, action] as const;
          }),
        );
      }),
      switchMap(([payload, action]) =>
        this.inputAppDataService.getBusninessContextData(payload).pipe(
          take(1),
          switchMap((businessContextData) => {
            this.metadataFacade.updateSyncingStatus(BCTX_SYNCING_KEY, 'SYNCED');
            return from(this.inputAppAPIHelperUtil.dismissLoading()).pipe(
              take(1),
              map(() => {
                return new SyncStyleInfoSuccessAndThenReleaseLockPlanBased(businessContextData, action.chainActions);
              }),
            );
          }),
          catchError((error) => {
            this.metadataFacade.updateSyncingStatus(BCTX_SYNCING_KEY, 'FAILED');
            this.customLoggerService.log(
              'INPUT APP CLIENT DB EFFECT: SyncStyleInfoAndThenReleaseUserDBLockPlanBased - getBusninessContextData API Error',
              JSON.stringify(error),
            );
            return of(
              new ReleaseUserDBLockAndShowPopupAndDismissLoader(
                this.translate.instant('input_app_common.error'),
                this.translate.instant('input_app_db_effects.fetchingBctxListError'),
                'SYNC_STYLE_INFO_PLANBASED',
              ),
            );
          }),
        ),
      ),
    ),
  );

  UpdateBctxWithoutChangeEventSuccessAndReleaseLock$ = createEffect(() =>
    this.action$.pipe(
      ofType<UpdateBctxWithoutChangeEventSuccessAndReleaseLock>(
        InputAppClientDBActionTypes.UpdateBctxWithoutChangeEventSuccessAndReleaseLock,
      ),
      switchMap(() => {
        this.modalCtrl.dismiss();
        this.inputAppClientDBFacade.releaseUserDBLock();
        return of(new InputAppNoAction());
      }),
    ),
  );

  AcquireLockAndFetchNewBctxSizeList$ = createEffect(() =>
    this.action$.pipe(
      ofType<AcquireLockAndFetchNewBctxSizeList>(InputAppClientDBActionTypes.AcquireLockAndFetchNewBctxSizeList),
      switchMap((action) =>
        this.inputAppClientDBFacade.acquireUserDBLock('BCTX_SYNCING').pipe(
          take(1),
          map((lockRes) => {
            if (lockRes.status === 'SUCCESS') {
              const { parentBctx, childBctx, currentSelectedBctxInfo } = action;
              return new FetchNewBctxSizeList(parentBctx, childBctx, currentSelectedBctxInfo);
            } else {
              this.inputAppAPIHelperUtil.showPopup(this.translate.instant('input_app_common.error'), lockRes.message);
              return new InputAppNoAction();
            }
          }),
        ),
      ),
    ),
  );

  FetchNewBctxSizeList$ = createEffect(() =>
    this.action$.pipe(
      ofType<FetchNewBctxSizeList>(InputAppClientDBActionTypes.FetchNewBctxSizeList),
      switchMap((action) =>
        from(this.inputAppAPIHelperUtil.presentLoading('Getting size list...')).pipe(
          take(1),
          map(() => action),
        ),
      ),
      switchMap((action) =>
        this.inputAppClientDBFacade.getStationDetails().pipe(
          take(1),
          map((res) => [action, res] as const),
        ),
      ),
      switchMap(([action, stationDetails]) => {
        const bctxItemWithoutSearchAndGroupId = action.childBctx.bctx.list.filter(
          (ele) => ele.k !== 'search_id' && ele.k !== 'display_piece_tag',
        );
        return this.inputAppDataService
          .getNewBctxSizeList({
            subjectKey: stationDetails.subjectKey,
            bctxItemList: bctxItemWithoutSearchAndGroupId,
          })
          .pipe(
            take(1),
            map((res) => {
              if (res.responseStatus === 'FAILURE') {
                return new ReleaseUserDBLockAndShowPopupAndDismissLoader(
                  'Error',
                  res.error || 'Something went wrong!',
                  'BCTX_SYNCING',
                );
              }
              const { parentBctx, childBctx, currentSelectedBctxInfo } = action;
              return new InsertNewBctxSizeListIntoDB(res, parentBctx, childBctx, currentSelectedBctxInfo);
            }),
            catchError((error) =>
              from(this.inputAppAPIHelperUtil.dismissLoading()).pipe(
                take(1),
                map(() => {
                  this.customLoggerService.log(
                    '[NEW_PO_SIZE_LIST_ERROR]: INPUT APP CLIENT DB EFFECT FetchNewBctxSizeList - getNewBctxSizeList API call failed',
                    JSON.stringify(error),
                  );
                  this.inputAppAPIHelperUtil.showPopup('Error', 'Something went wrong!');
                  return new ReleaseUserDBLock();
                }),
              ),
            ),
          );
      }),
      catchError((error) => {
        return from(this.inputAppAPIHelperUtil.dismissLoading()).pipe(
          take(1),
          map(() => {
            this.customLoggerService.log('[NEW_PO_SIZE_LIST_ERROR]', error);
            this.inputAppAPIHelperUtil.showPopup('Error', 'Something went wrong!');
            return new ReleaseUserDBLock();
          }),
        );
      }),
    ),
  );

  InsertNewBctxSizeListIntoDB$ = createEffect(() =>
    this.action$.pipe(
      ofType<InsertNewBctxSizeListIntoDB>(InputAppClientDBActionTypes.InsertNewBctxSizeListIntoDB),
      switchMap((action) =>
        this.inputAppClientDBFacade.getSelectedStationIdAndShiftId().pipe(
          take(1),
          map((selectedStationIdAndShiftId) => {
            return [action, selectedStationIdAndShiftId] as const;
          }),
        ),
      ),
      switchMap(([action, selectedStationIdAndShiftId]) =>
        this.inputAppClientDBFacade.getAppIdentifier().pipe(
          take(1),
          map((app_identifier) => {
            return [action, selectedStationIdAndShiftId, app_identifier] as const;
          }),
        ),
      ),
      switchMap(([action, selectedStationIdAndShiftId, app_identifier]) => {
        return this.inputAppClientDBFacade.getConfigurations().pipe(
          take(1),
          map(
            ({ aggregatedLineMapForPerPiece }) =>
              [action, selectedStationIdAndShiftId, app_identifier, aggregatedLineMapForPerPiece] as const,
          ),
        );
      }),
      switchMap(([action, selectedStationIdAndShiftId, app_identifier, aggregatedLineMapForPerPiece]) => {
        return this.inputAppClientDBFacade.getBctxItemsOrderForBackUp().pipe(
          take(1),
          map(
            (orderKeys) =>
              [action, selectedStationIdAndShiftId, app_identifier, aggregatedLineMapForPerPiece, orderKeys] as const,
          ),
        );
      }),
      switchMap(([action, selectedStationIdAndShiftId, app_identifier, aggregatedLineMapForPerPiece, orderKeys]) =>
        from(this.persistentStorageService.get('[APP][INPUT_APP_CLIENT_DB]')).pipe(
          take(1),
          map((currentDB) => {
            let updatedCurrentDB = currentDB;
            if (aggregatedLineMapForPerPiece && BCTXComputationHelper.isPerPieceApp(app_identifier)) {
              updatedCurrentDB = PerPieceComputationHelper.updateCurrentDBWithWipMapAndShiftMapForTheNewBctxSizes(
                currentDB,
                selectedStationIdAndShiftId,
                action.childBctx,
                action.res.response.sizes,
                orderKeys,
              );
            } else {
              updatedCurrentDB = BCTXComputationHelper.updateCurrentDBWithWipMapAndShiftMapForTheNewBctxSizes(
                currentDB,
                selectedStationIdAndShiftId,
                action.childBctx,
                action.res.response.sizes,
              );
            }

            return [action, updatedCurrentDB] as const;
          }),
        ),
      ),
      switchMap(([action, currentDB]) =>
        from(this.persistentStorageService.set('[APP][INPUT_APP_CLIENT_DB]', currentDB)).pipe(
          take(1),
          map(() => {
            const { parentBctx, childBctx, currentSelectedBctxInfo } = action;
            return new InsertNewBctxSizeListIntoDBSuccessAndReleaseLock(
              currentDB,
              parentBctx,
              childBctx,
              currentSelectedBctxInfo,
            );
          }),
        ),
      ),
      catchError((error) => {
        return from(this.inputAppAPIHelperUtil.dismissLoading()).pipe(
          take(1),
          map(() => {
            this.customLoggerService.log('[NEW_PO_SIZE_LIST_ERROR]', error);
            this.inputAppAPIHelperUtil.showPopup('Error', 'Something went wrong!');
            return new ReleaseUserDBLock();
          }),
        );
      }),
    ),
  );

  InsertNewBctxSizeListIntoDBSuccessAndReleaseLock$ = createEffect(() =>
    this.action$.pipe(
      ofType<InsertNewBctxSizeListIntoDBSuccessAndReleaseLock>(
        InputAppClientDBActionTypes.InsertNewBctxSizeListIntoDBSuccessAndReleaseLock,
      ),
      switchMap((action) => {
        return this.inputAppClientDBFacade.getSelectedStationIdAndShiftId().pipe(
          take(1),
          map(({ stationId }) => [action, stationId] as const),
        );
      }),
      switchMap(([action, stationId]) =>
        from(this.inputAppAPIHelperUtil.dismissLoading()).pipe(
          take(1),
          map(() => {
            this.inputAppClientDBFacade.releaseUserDBLock();
            const { parentBctx, childBctx, currentSelectedBctxInfo } = action;
            return new AddBctxChangeEventForOnlineApps(
              currentSelectedBctxInfo.newBctxForPOSplit
                ? currentSelectedBctxInfo.newBctxForPOSplit.bctx
                : currentSelectedBctxInfo.bctxInfoWithoutSize,
              parentBctx,
              stationId,
              childBctx,
            );
          }),
        ),
      ),
    ),
  );

  SyncStyleInfoSuccessAndThenReleaseLockPlanBased$ = createEffect(() =>
    this.action$.pipe(
      ofType<SyncStyleInfoSuccessAndThenReleaseLockPlanBased>(
        InputAppClientDBActionTypes.SyncStyleInfoSuccessAndThenReleaseLockPlanBased,
      ),
      switchMap((action) =>
        this.inputAppClientDBFacade.getSelectedStationIdAndShiftId().pipe(
          take(1),
          map((selectedStationIdAndShiftId) => {
            return [action.businessContextData, selectedStationIdAndShiftId, action] as const;
          }),
        ),
      ),
      switchMap(([businessContextData, selectedStationIdAndShiftId, action]) => {
        return this.inputAppClientDBFacade.getBctxItemsOrderWithoutSize().pipe(
          take(1),
          map((bctxKeysOrder) => [businessContextData, selectedStationIdAndShiftId, action, bctxKeysOrder] as const),
        );
      }),
      switchMap(([businessContextData, selectedStationIdAndShiftId, action, bctxKeysOrder]) =>
        from(this.persistentStorageService.get('[APP][INPUT_APP_CLIENT_DB]')).pipe(
          map((currentDB) => {
            const bctxMinMaxDateTime: TBctxMinMaxDateTime =
              BCTXComputationHelper.getBctxMinMaxDateTime(businessContextData);

            const planBasedLineMapItem = BCTXComputationHelper.createInitialPlanBasedLineMap(
              businessContextData,
              bctxKeysOrder,
            );
            const updatedDailyCache = BCTXComputationHelper.getMergedPlanBasedLineMap(
              currentDB.dailyCache,
              selectedStationIdAndShiftId,
              planBasedLineMapItem,
            );
            currentDB = produce(currentDB, (draft) => {
              draft.dailyCache = {
                ...updatedDailyCache,
                bctxMinMaxDateTime: bctxMinMaxDateTime,
              };
            });
            return [currentDB, action] as const;
          }),
        ),
      ),
      switchMap(([currentDB, action]) =>
        from(this.persistentStorageService.set('[APP][INPUT_APP_CLIENT_DB]', currentDB)).pipe(
          map(() => {
            if (action.chainActions && action.chainActions.chainWithLoadNewSizes) {
              // set user db and fetch new styles
              return new SetUserDBAndReleaseLockAndThenFetchNewSizeList(currentDB);
            } else if (
              action.chainActions &&
              action.chainActions.chainWithLoadAllMasterDataList &&
              action.chainActions.masterDataListMetaData
            ) {
              return new SetUserDBAndReleaseLockAndThenLoadMasterdataLists(
                currentDB,
                action.chainActions.masterDataListMetaData,
              );
            } else return new SetUserDBAndReleaseLock(currentDB);
          }),
        ),
      ),
    ),
  );

  SetUserDBAndReleaseLockAndThenFetchNewSizeList$ = createEffect(() =>
    this.action$.pipe(
      ofType<SetUserDBAndReleaseLockAndThenFetchNewSizeList>(
        InputAppClientDBActionTypes.SetUserDBAndReleaseLockAndThenFetchNewSizeList,
      ),
      switchMap(() => {
        return this.appMasterDBFacade.getAppSyncItemList().pipe(
          map((appSyncItemList) => {
            const appSyncItem = BCTXComputationHelper.getAppSyncItem(appSyncItemList, 'size_list');
            if (appSyncItem) {
              this.masterDataListDbFacade.updateMasterdataList(appSyncItem);
            }
            return new InputAppNoAction();
          }),
        );
      }),
    ),
  );

  AcquireUserDBLockAndPopulateLineMapForPlanBased$ = createEffect(() => {
    return this.action$.pipe(
      ofType<AcquireUserDBLockAndPopulateLineMapForPlanBased>(
        InputAppClientDBActionTypes.AcquireUserDBLockAndPopulateLineMapForPlanBased,
      ),
      switchMap((action) => {
        return this.inputAppClientDBFacade.acquireUserDBLock('POPULATE_LINEMAP_PLANBASED').pipe(
          take(1),
          map((res) => {
            if (res.status === 'SUCCESS') {
              return new PopulateLineMapForPlanBasedAndThenReleaseUserDbLock(action.masterDataListMetaData);
            } else {
              this.inputAppAPIHelperUtil.showPopup(this.translate.instant('input_app_common.error'), res.message);
              return new InputAppNoAction();
            }
          }),
        );
      }),
    );
  });

  PopulateLineMapForPlanBasedAndThenReleaseUserDbLock$ = createEffect(() => {
    return this.action$.pipe(
      ofType<PopulateLineMapForPlanBasedAndThenReleaseUserDbLock>(
        InputAppClientDBActionTypes.PopulateLineMapForPlanBasedAndThenReleaseUserDbLock,
      ),
      switchMap((action) =>
        this.masterDataListDbFacade.getAllMasterdataListsInfo().pipe(
          take(1),
          map((allMasterdataListsInfo) => {
            return [action, allMasterdataListsInfo] as const;
          }),
        ),
      ),
      switchMap(([action, allMasterdataListsInfo]) =>
        this.inputAppClientDBFacade.getSelectedStationIdAndShiftId().pipe(
          take(1),
          map((selectedStationIdAndShiftId) => {
            return [action, allMasterdataListsInfo, selectedStationIdAndShiftId] as const;
          }),
        ),
      ),
      switchMap(([action, allMasterdataListsInfo, selectedStationIdAndShiftId]) =>
        this.inputAppClientDBFacade.getselectedBctxItem().pipe(
          take(1),
          map((selectedBctx) => {
            return [action, allMasterdataListsInfo, selectedStationIdAndShiftId, selectedBctx] as const;
          }),
        ),
      ),

      switchMap(([action, allMasterdataListsInfo, selectedStationIdAndShiftId, selectedBctx]) => {
        return this.inputAppClientDBFacade.getBctxItemsOrderWithoutSize().pipe(
          take(1),
          map(
            (bctxKeysOrder) =>
              [action, allMasterdataListsInfo, selectedStationIdAndShiftId, selectedBctx, bctxKeysOrder] as const,
          ),
        );
      }),
      switchMap(([action, allMasterdataListsInfo, selectedStationIdAndShiftId, selectedBctx, bctxKeysOrder]) => {
        return this.appMasterDBFacade.getAppSyncItemList().pipe(
          take(1),
          map(
            (appSyncItemList) =>
              [
                action,
                allMasterdataListsInfo,
                selectedStationIdAndShiftId,
                selectedBctx,
                bctxKeysOrder,
                appSyncItemList,
              ] as const,
          ),
        );
      }),
      switchMap(
        ([
          action,
          allMasterdataListsInfo,
          selectedStationIdAndShiftId,
          selectedBctx,
          bctxKeysOrder,
          appSyncItemList,
        ]) => {
          return this.inputAppClientDBFacade.getAllBctxItemsAcrossSelectedStaionId().pipe(
            take(1),
            switchMap((allBctxItems) =>
              this.inputAppClientDBFacade.getAppIdentifier().pipe(
                take(1),
                map(
                  (app_identifier) =>
                    [
                      action,
                      allMasterdataListsInfo,
                      selectedStationIdAndShiftId,
                      selectedBctx,
                      bctxKeysOrder,
                      appSyncItemList,
                      allBctxItems,
                      app_identifier,
                    ] as const,
                ),
              ),
            ),
          );
        },
      ),
      switchMap(
        ([
          action,
          allMasterdataListsInfo,
          selectedStationIdAndShiftId,
          selectedBctx,
          bctxKeysOrder,
          appSyncItemList,
          allBctxItems,
          app_identifier,
        ]) =>
          from(this.persistentStorageService.get('[APP][INPUT_APP_CLIENT_DB]')).pipe(
            map((currentDB) => {
              const lineMapItem = BCTXComputationHelper.createInitialLineMapItemForPlanBased(
                allBctxItems,
                appSyncItemList,
                allMasterdataListsInfo,
                selectedBctx,
                selectedStationIdAndShiftId.shiftId,
                app_identifier,
              );
              const updatedDailyCache = BCTXComputationHelper.getMergedDBOnBctxLoad(
                currentDB.dailyCache,
                selectedStationIdAndShiftId,
                lineMapItem,
                BCTXComputationHelper.getBctxWithMultipleSizeList(lineMapItem),
                bctxKeysOrder,
              );
              currentDB = produce(currentDB, (draft) => {
                draft.dailyCache = updatedDailyCache;
              });

              // all the bctx available in the admin
              const activeBctxKeys = BCTXComputationHelper.getActiveBctxKeys(
                currentDB.dailyCache.lineMap[selectedStationIdAndShiftId.stationId],
                currentDB.dailyCache.planBasedLineMap[selectedStationIdAndShiftId.stationId],
              );

              const updateLineMapWithInactiveBctxAndSizes =
                BCTXComputationHelper.getLIneMapItemUpdatedWithInactiveBctxAndSize(
                  activeBctxKeys,
                  currentDB.dailyCache.lineMap[selectedStationIdAndShiftId.stationId],
                  appSyncItemList,
                  allMasterdataListsInfo,
                  selectedStationIdAndShiftId.shiftId,
                  app_identifier,
                );
              currentDB = produce(currentDB, (draft) => {
                draft.dailyCache.lastStyleSyncInfoTimestamp = new Date().getTime();
                draft.dailyCache.lineMap[selectedStationIdAndShiftId.stationId] = updateLineMapWithInactiveBctxAndSizes;
                draft.dailyCache.planBasedLineMap = {};
              });
              currentDB = produce(currentDB, (draft) => {
                draft.dailyCache.planBasedLineMap = {};
              });
              return [action, currentDB] as const;
            }),
          ),
      ),

      switchMap(([action, currentDB]) =>
        from(this.persistentStorageService.set('[APP][INPUT_APP_CLIENT_DB]', currentDB)).pipe(
          map(() => {
            if (action.masterDataListMetaData.source === 'INIT') {
              return new SetUserDbAndAcquireUserDBLockAndThenRestoreActualsForBackedUpBctx(currentDB);
            }
            return new SetUserDBAndReleaseLock(currentDB);
          }),
        ),
      ),
    );
  });
  SetUserDbAndAcquireUserDBLockAndThenRestoreActualsForBackedUpBctx$ = createEffect(() =>
    this.action$.pipe(
      ofType<SetUserDbAndAcquireUserDBLockAndThenRestoreActualsForBackedUpBctx>(
        InputAppClientDBActionTypes.SetUserDbAndAcquireUserDBLockAndThenRestoreActualsForBackedUpBctx,
      ),
      map(
        () =>
          new AcquireUserDBLockAndThenRestoreActualsForBackedUpBctx({
            wipOnly: false,
            actualsOnly: true,
            chainWithLoadMasterdataList: false,
            hideLoader: true,
          }),
      ),
    ),
  );

  AcquireLockAndUpdateFilteredSizesListInLineMap$ = createEffect(() =>
    this.action$.pipe(
      ofType<AcquireLockAndUpdateFilteredSizesListInLineMap>(
        InputAppClientDBActionTypes.AcquireLockAndUpdateFilteredSizesListInLineMap,
      ),
      switchMap((action) => {
        return this.inputAppClientDBFacade.getSelectedStationIdAndShiftId().pipe(
          take(1),
          map(({ stationId }) => [stationId, action] as const),
        );
      }),
      switchMap(([stationId, action]) => {
        return this.inputAppClientDBFacade.getselectedBctxItem().pipe(
          take(1),
          map((selectedBctxItem) => [selectedBctxItem, stationId, action] as const),
        );
      }),
      switchMap(([selectedBctxItem, stationId, action]) =>
        from(this.inputAppClientDBFacade.acquireUserDBLock('UPDATING_FILTERED_SIZES_LIST_IN_LINEMAP')).pipe(
          switchMap((res) => {
            if (res.status === 'SUCCESS') {
              return from(this.persistentStorageService.get('[APP][INPUT_APP_CLIENT_DB]')).pipe(
                take(1),
                switchMap((currentDB) => {
                  const updatedDB = produce(currentDB, (draft) => {
                    draft.dailyCache.lineMap[stationId].bctxWipMap[
                      selectedBctxItem.bctxInfoWithoutSize.bctxKey
                    ].filteredSizesList = action.filteredSizesList;
                  });
                  return from(this.persistentStorageService.set('[APP][INPUT_APP_CLIENT_DB]', updatedDB)).pipe(
                    take(1),
                    map(() => new SetUserDBAndReleaseLock(updatedDB)),
                  );
                }),
              );
            } else {
              this.inputAppAPIHelperUtil.showPopup('Error', res.message);
              return of(new InputAppNoAction());
            }
          }),
        ),
      ),
    ),
  );

  CaptureSnapShotOfDbs$ = createEffect(() => {
    return this.action$.pipe(
      ofType<CaptureSnapShotOfDbs>(InputAppClientDBActionTypes.CaptureSnapShotOfDbs),
      switchMap((action) =>
        from(this.persistentStorageService.get('[APP][INPUT_APP_CLIENT_DB]')).pipe(
          take(1),
          map((userDB) => {
            return [userDB, action.origin] as const;
          }),
        ),
      ),

      switchMap(([userDB, origin]) => {
        return from(this.persistentStorageService.get('[APP][INPUT_APP_BACKGROUND_EVENTS_SYNCING_DB]')).pipe(
          map((bgDb) => {
            this.customLoggerService.sendDirectLogsToBackend('INPUT_APP_CLIENT_DB_REDUX_STORE - CaptureSnapShotOfDbs ' + origin, {
              userDB,
              bgDb,
            });
            return new InputAppNoAction();
          }),
        );
      }),
    );
  });
}
